import * as tslib_1 from "tslib";
import { Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { AddressDetails } from 'src/app/models/address-details';
import { Investor } from 'src/app/models/investor';
import { InvestorAccount } from 'src/app/models/investor-account';
import { InvestorDetails } from 'src/app/models/investor-details';
import { DocumentDetails } from '../models/document-details';
import { KycModification } from '../models/kyc-modification';
import { SegmentDetails } from '../models/segment-details';
import { OnboardingService } from '../services/rest/onboarding.service';
import { SharedService } from '../services/shared/shared.service';
import * as moment from 'moment';
import { Subject } from 'rxjs';
import validationtext from '../../../src/json/validationmsg.js';
import { ActivatedRoute, Router } from '@angular/router';
import * as cryptoJs from 'crypto-js';
import * as i0 from "@angular/core";
import * as i1 from "ngx-toastr";
import * as i2 from "../services/rest/onboarding.service";
import * as i3 from "../services/shared/shared.service";
import * as i4 from "@angular/router";
/**Regex for PAN Number*/
var panNumberRegex = /^[a-zA-Z]{3}[pP]{1}[a-zA-Z]{1}[0-9]{4}[a-zA-Z]{1}$/;
/**Regex for mobile Number*/
var mobileNumberRegex = /^(6|9|8|7)([0-9]{9})$/;
/**Regex for emailID*/
var emailRegex = /^[A-Za-z0-9._%+-]{1,}@[a-zA-Z-]{3,}([.]{1}[a-zA-Z]{2,}|[.]{1}[a-zA-Z]{2,}[.]{1}[a-zA-Z]{2,})$/;
/**Regex for Name*/
var nameRegex = /^(?!.*[\s]{2,})(?!.*[\.]{2,})(?!.*[\']{2,})(?!.*[\-]{2,})(?=.{2,}$)(([A-Za-z\.\'\- ])\2?(?!\2))+$/;
/**Regex for city Name*/
var cityRegex = /^(?!.*[\s]{2,})([A-Za-z\s\-\.]){2,}$/;
/**Regex for Message*/
var messageRegex = /^(?!.*[ ]{2,})([A-Za-z0-9\s\'-:.,\(\[\]\)@]){1,}$/;
/**Regex for Address*/
var addressRegex = /^(?!.*[ ]{2,})([A-Za-z0-9\s\'-:.,~!\(\[\]\)]){2,}$/;
/**Regex for Pin Code*/
var pinCodeRegex = /^[1-9][0-9]{5}$/;
/**Regex for Account Number*/
var accNoRegex = /^([0-9]){8,18}$/;
/**Regex for OTP*/
var otpRegex = /^([0-9]){4}$/;
/**Regex for unified OTP*/
var unifiedotpRegex = /^([0-9]){6}$/;
/**Regex for IFSC Code*/
var ifscRegex = /^([A-Za-z0-9]){11}/;
/**Regex for userName*/
var userNameRegex = /^[a-z0-9]+$/i;
/** Regex for dob */
var dobRegex = /^\d{4}\-(0[1-9]|1[012])\-(0[1-9]|[12][0-9]|3[01])$/;
/**Regex for Share Percent*/
var sharePercentRegex = /^[1-9]$|^[1-9][0-9]$|^(100)$/;
/**Regex for Indian Passport*/
var passportRegex = /^[A-PR-WYa-pr-wy][1-9]\d\s?\d{4}[1-9]$/;
/**Regex for Indian Voter ID*/
var voterRegex = /^([a-zA-Z]){3}([0-9]){7}?$/;
/**Regex for Aadhaar Number*/
var aadhaarRegex = /^\d{12}$/;
/**Regex for alphaNumeric*/
var alphaNumericRegex = /^[a-zA-Z0-9]+$/i;
/**Regex for MF Nominee Name*/
var nomineeNameRegex = /^(?!.*[\s]{2,})(?!.*[\.]{2,})(?!.*[\']{2,})(?!.*[\-]{2,})(([A-Za-z\'\- ])\2?(?!\2))+$/;
/**Configuration for Redirection based on BU */
var URLs = {
    'JF': {
        id: 2,
        loginURL: 'https://finx.choiceindia.com/auth/login',
        dashboardURL: 'https://finx.choiceindia.com/client/dashboard',
        tnc: 'https://finx.choiceindia.com/terms-use',
        privacyPolicy: 'https://finx.choiceindia.com/privacy-policy',
        leadCreationURL: 'https://finx.choiceindia.com/open-demat-account',
        alphabeeURL: 'https://alphabee.choicebroking.in',
        signUpURL: 'https://finx.choiceindia.com/open-demat-account',
        homePageURL: 'https://finx.choiceindia.com/',
        mfChoiceIndiaURL: 'https://mf.choiceindia.com'
    },
    'MFJF': {
        id: 2,
        loginURL: 'https://finx.choiceindia.com/auth/login',
        dashboardURL: 'https://finx.choiceindia.com/client/dashboard',
        tnc: 'https://finx.choiceindia.com/terms-use',
        privacyPolicy: 'https://finx.choiceindia.com/privacy-policy',
        leadCreationURL: 'https://finx.choiceindia.com/open-demat-account',
        signUpURL: 'https://finx.choiceindia.com/open-demat-account',
        homePageURL: 'https://finx.choiceindia.com/',
        mfChoiceIndiaURL: 'https://mf.choiceindia.com'
    },
    'MF': {
        id: 1,
        loginURL: 'https://investica.com/auth/sign-in',
        dashboardURL: 'https://investica.com/user/my-dashboard',
        tnc: 'https://investica.com/terms-of-use',
        privacyPolicy: 'https://investica.com/privacy-policy',
        leadCreationURL: 'https://investica.com/auth/sign-up',
        signUpURL: 'https://investica.com/auth/sign-up',
        mfChoiceIndiaURL: 'https://mf.choiceindia.com'
    }
};
/** Service Injectable */
var UtilsService = /** @class */ (function () {
    // subject2 = new Subject<any>(); 
    // subscription: Subscription;
    /**
     * Method to initialize Component
     * @param toastr instance of ToastrService
     * @param rest instance of OnboardingService
     * @param shared instance of SharedService
     * @param activatedRoute instance of ActivatedRoute
     * @param route instance of Router
     */
    function UtilsService(toastr, rest, shared, activatedRoute, route) {
        this.toastr = toastr;
        this.rest = rest;
        this.shared = shared;
        this.activatedRoute = activatedRoute;
        this.route = route;
        /** subject */
        this.subject = new Subject();
        this.activatedRoute.queryParams.subscribe(function (params) {
            // console.log('inside subscripte')
            // this.secureParams = params;
            console.log(params, "params");
            for (var _i = 0, _a = Object.entries(params); _i < _a.length; _i++) {
                var _b = _a[_i], key = _b[0], value = _b[1];
                // if(key == 'invid'){
                //   let inv = value.replace(' ','+').toString();
                //   sessionStorage.setItem(`${key}`, inv)
                // }
                // else{
                //   sessionStorage.setItem(`${key}`, value.toString())
                // }
                var text = value.replaceAll(' ', '+').toString();
                sessionStorage.setItem("" + key, text);
            }
            // if(sessionStorage.getItem('code') && sessionStorage.getItem('invid')){
            //   this.generateAccessToken();
            // }
        });
        // if(sessionStorage.getItem('code') && sessionStorage.getItem('invid')){
        sessionStorage.setItem('businessUnit', this.getBusinessUnit().toString());
        this.config = {};
        this.storage = window.sessionStorage; //|| window.localStorage;
        this.storage = window.sessionStorage;
        this.initializeConfig();
        this.isMobile = this.isMobileDevice();
        this.businessUnit = this.getBusinessUnit();
        this.investor = this.getOnboardingData() || new Investor();
        this.modification = this.getModificationData() || new KycModification();
        this.langData = {};
        // }
        // this.subscription = this.getMessage2().subscribe((res) => {
        //   console.log('POPUPLSDKFJ')
        //   this.showSessionExpiredPopup();
        // })
    }
    /** FOR reset page step and screen */
    UtilsService.prototype.resetStep = function () {
        this.initializeScreenList();
    };
    /** show config Modal*/
    UtilsService.prototype.showModal = function (config) {
        this.modalConfig = config;
    };
    /** show config based OTPForm */
    UtilsService.prototype.showOTPForm = function (config) {
        this.otpFormModal = config;
    };
    /** Getting  Redirection URL*/
    UtilsService.prototype.getRedirectionURL = function (key) {
        return URLs[this.businessUnit][key];
    };
    /**
     * page load time initial configuration
     */
    UtilsService.prototype.initializeConfig = function () {
        console.log('inside initializeConfig');
        this.initializeScreenList();
        this.selectedLanguage = this.getLanguage();
        this.setLanguage(this.selectedLanguage);
        this.getLangData(this.selectedLanguage);
        this.setValidationLang();
        this.initializeFlowPoints();
        console.log(location.pathname, "location.pathname utils");
        location.pathname.indexOf('respond-issue') > -1 ? (sessionStorage.setItem('requestFrom', 'raiseIssue'), sessionStorage.setItem('requestSource', 'raiseIssue')) : location.href.indexOf('account-closure') > -1 ? sessionStorage.setItem('requestFrom', 'accountClosure') : location.pathname.indexOf('modification/trading') > -1 ? (sessionStorage.setItem('requestFrom', 'modification'), sessionStorage.setItem('requestSource', 'contactModification')) : location.pathname.indexOf('offline-onboard') > -1 ? (sessionStorage.setItem('requestFrom', 'offlineClientCreation'), sessionStorage.setItem('requestSource', 'offlineClientCreation')) : location.pathname.indexOf('modification/mf') > -1 ? (sessionStorage.setItem('requestFrom', 'addressModification'), sessionStorage.setItem('requestSource', 'addressModification')) :
            (sessionStorage.setItem('requestFrom', 'onboarding'), sessionStorage.setItem('requestSource', 'objourneyModify'));
        if ((location.pathname.indexOf('/modification/trading/client-login') === -1) || (location.pathname.indexOf('/modification/mf/client-login') === -1)) {
            // this.initializeLeadCityList();
            // this.initializeLeadCityListV2('');
            this.initializeCountryList();
            if ((location.pathname.indexOf('/modification/trading/client-login') === -1) || (location.pathname.indexOf('/modification/mf/client-login') === -1)) {
                // this.initializeStateList();
                this.initializeStateListV2();
                // this.initializeIncomeSlabs();
                this.initializeOccupationList();
                // this.initializeEducationList();
                this.initializeEducationListV2();
            }
        }
    };
    /**
     * GEt Lead City List
     */
    UtilsService.prototype.initializeLeadCityList = function () {
        var _this = this;
        this.rest.retrieveLeadCityList().subscribe(function (res) {
            if (res && (!res.errorCode && !res.error)) {
                _this.config.leadCities = res;
            }
        });
    };
    /** Get Lead City List  version 2*/
    UtilsService.prototype.initializeLeadCityListV2 = function (cityname) {
        var _this = this;
        this.rest.retrieveLeadCityListV2(cityname).subscribe(function (res) {
            if (res && (!res.errorCode && !res.error && res.Body.CityMasterList.length)) {
                _this.config.leadCities = res.Body.CityMasterList;
            }
        });
    };
    /** GEt Lead State List */
    UtilsService.prototype.initializeStateList = function () {
        var _this = this;
        this.rest.retrieveStateLists().subscribe(function (res) {
            if (res && (!res.errorCode && !res.error)) {
                _this.config.states = res;
            }
        });
    };
    /**state list OPT V2 */
    UtilsService.prototype.initializeStateListV2 = function () {
        var _this = this;
        this.rest.retrieveStateListsV2().subscribe(function (res) {
            if (res && (!res.errorCode && !res.error && res.Body.StateList.length)) {
                _this.config.states = res.Body.StateList;
            }
        });
    };
    /** initialize Income Slabs */
    UtilsService.prototype.initializeIncomeSlabs = function () {
        var _this = this;
        this.rest.retrieveIncomeSlabLists().subscribe(function (res) {
            if (res && (!res.errorCode && !res.error)) {
                _this.config.incomeSlabs = res.filter(function (slab) {
                    return slab.slab != '>25L';
                });
            }
        });
    };
    ;
    /**  initialize Occupation List */
    UtilsService.prototype.initializeOccupationList = function () {
        var _this = this;
        this.rest.retrieveOccupationLists().subscribe(function (res) {
            if (res && (!res.errorCode && !res.error)) {
                _this.config.occupations = res;
            }
        });
    };
    ;
    /** initialize Education List */
    UtilsService.prototype.initializeEducationList = function () {
        var _this = this;
        this.rest.retrieveEducationLists().subscribe(function (res) {
            if (res && (!res.errorCode && !res.error)) {
                _this.config.educations = res;
            }
        });
    };
    ;
    /** initialize total Screen List */
    UtilsService.prototype.initializeScreenList = function () {
        var _this = this;
        var screensMap = {
            "onboard-info": { id: 1, JF: 1, MF: 1, MFJF: 1, event: 'on_info', screenName: 'info', label: 'Onboard Info' },
            "registration": { id: 2, JF: 2, MF: 2, MFJF: 2, event: 'on_register', screenName: 'register', label: 'Registration' },
            "open-account": { id: 3, JF: 3, MF: 3, MFJF: 3, event: 'on_pan', screenName: 'pan', label: 'Open Account' },
            "basic-details": { id: 4, JF: 4, MF: 4, MFJF: 4, event: 'on_basic', screenName: 'basic', label: 'Basic Details' },
            "address-details": { id: 5, JF: 5, MF: 5, MFJF: 5, event: 'on_address', screenName: 'address', label: 'Address Details' },
            "nominee-details": { id: 6, JF: 6, MF: 6, MFJF: 6, event: 'on_nominee', screenName: 'nominee', label: 'Nominee Details' },
            "income-details": { id: 7, JF: 7, MF: 7, MFJF: 7, event: 'on_income_fatca', screenName: 'income_fatca', label: 'Income Details' },
            "bank-details": { id: 8, JF: 8, MF: 8, MFJF: 8, event: 'on_bank', screenName: 'bank', label: 'Bank Details' },
            "segment-details": { id: 9, JF: 9, MF: 9, MFJF: 9, event: 'on_segments', screenName: 'segments', label: 'Segment Details' },
            "ipv-details": { id: 10, JF: 10, MF: 10, MFJF: 10, event: 'on_ipv', screenName: 'ipv', label: 'IPV Details' },
            "document-uploads": { id: 11, JF: 11, MF: 11, MFJF: 11, event: 'on_document', screenName: 'document', label: 'Document Uploads' },
            "brokerage-details": { id: 16, JF: 16, MF: 16, MFJF: 16, event: 'on_brokerage', screenName: 'brokerage' },
            "esign": { id: 12, JF: 12, MF: 12, MFJF: 12, event: 'on_esign', screenName: 'esign', label: 'E-sign' },
            "congrats": { id: 13, JF: 13, MF: 13, MFJF: 13, event: 'on_congrats', screenName: 'congrats', label: 'Congrats' },
            "digi-locker": { id: 15, JF: 15, MF: 15, MFJF: 15, event: 'on_digi-locker', screenName: 'digi-locker', label: 'Digi Locker' },
        };
        this.config.screens = screensMap;
        this.rest.retrieveScreenLists().subscribe(function (res) {
            console.log(res, "this.config.screens");
            if (res && (!res.errorCode && !res.error)) {
                var screens_1 = {};
                res.forEach(function (screen, index) {
                    screens_1[screen.name] = { screen: screen, step: screensMap[screen.name] };
                });
                _this.config.screens = screens_1;
            }
        });
    };
    ;
    /** initialize Country List */
    UtilsService.prototype.initializeCountryList = function () {
        var _this = this;
        this.rest.retrieveCountryLists().subscribe(function (res) {
            if (res && (!res.errorCode && !res.error)) {
                _this.config.countries = res;
            }
        });
    };
    /**
     * configuration base key value
     * @param key Geetin key value
     * @returns this key will join with config object
     */
    UtilsService.prototype.getConfigList = function (key) {
        return this.config[key] || [];
    };
    /**
     * Get Language Data
     * @param selectedLang passing selected Language
     * @returns passing message using through language
     */
    UtilsService.prototype.getLangData = function (selectedLang) {
        var _this = this;
        return this.rest.getLanguageData(selectedLang).subscribe(function (response) {
            if (response) {
                _this.langData = response;
                _this.sendMessage(selectedLang);
            }
        });
    };
    /**
     * all platform key name mention here like (onboarding,modification,raise issue,offeline)
     * all platform validate of every key
     * validation type
     * showing error message base on validation
     * identify MF or JF condition base
     */
    UtilsService.prototype.initializeFlowPoints = function () {
        var _this = this;
        var investorDateRange = this.getInvestorDOBRange();
        var nomineeDateRange = this.getNomineeDOBRange();
        this.utils = {
            'offline-onboard': {
                inputs: {
                    panNumber: {
                        validations: [Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern(panNumberRegex)],
                        error: {
                            required: this.errorMessages.pan_required,
                            pattern: this.errorMessages.pan_pattern
                        },
                        MF: true,
                        JF: true,
                        MFJF: true
                    },
                    dateOfBirth: {
                        validations: [Validators.required, range(new Date(investorDateRange.min).valueOf(), new Date(investorDateRange.max).valueOf())],
                        error: {
                            required: this.errorMessages.dob_required,
                            range: this.errorMessages.dob_range
                        },
                        MF: true,
                        JF: true,
                        MFJF: true
                    },
                    mobileNumber: {
                        MFValidators: [Validators.minLength(10), Validators.maxLength(10), Validators.pattern(mobileNumberRegex)],
                        JFValidators: [Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern(mobileNumberRegex)],
                        MFJFValidators: [Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern(mobileNumberRegex)],
                        error: {
                            required: this.errorMessages.mob_required,
                            pattern: this.errorMessages.mob_pattern
                        },
                        MF: false,
                        JF: true,
                        MFJF: false,
                    },
                    email: {
                        MFValidators: [Validators.pattern(emailRegex)],
                        JFValidators: [Validators.required, Validators.pattern(emailRegex)],
                        MFJFValidators: [Validators.required, Validators.pattern(emailRegex)],
                        error: {
                            required: this.errorMessages.email_required,
                            pattern: this.errorMessages.email_pattern
                        },
                        JF: true,
                        MFJF: true
                    },
                    referralCode: {
                        MFValidators: [],
                        JFValidators: [Validators.minLength(0), Validators.maxLength(20), Validators.pattern(/^[a-z0-9]+$/i)],
                        MFJFValidators: [Validators.minLength(0), Validators.maxLength(20), Validators.pattern(/^[a-z0-9]+$/i)],
                        error: {
                            maxlength: this.errorMessages.reffcode_maxlength,
                            pattern: this.errorMessages.reffcode_pattern,
                        },
                        JF: true,
                        MFJF: true
                    },
                    leadCity: {
                        MFValidators: [],
                        JFValidators: [],
                        MFJFValidators: [],
                        error: {
                            required: this.errorMessages.leadcity_required,
                        },
                        JF: false,
                        MFJF: false
                    },
                    leadState: {
                        MFValidators: [],
                        JFValidators: [],
                        MFJFValidators: [],
                        error: {
                            required: this.errorMessages.leadstate_required,
                        },
                        JF: false,
                        MFJF: false
                    },
                    occupation: {
                        validations: [Validators.required],
                        error: {
                            required: this.errorMessages.default_required,
                            invalid: this.errorMessages.occupation_invalid
                        },
                        MF: true,
                        JF: true,
                        MFJF: true
                    },
                    education: {
                        validations: [Validators.required],
                        error: {
                            required: this.errorMessages.education_required,
                        },
                        JF: true
                    },
                    annualIncome: {
                        validations: [Validators.required, Validators.min(1)],
                        error: {
                            pattern: this.errorMessages.annualInc_invalid,
                            invalid: this.errorMessages.annualInc_invalid,
                            required: this.errorMessages.annualInc_required
                        },
                        JF: true
                    },
                    politicalRelation: {
                        validations: [Validators.required],
                        error: {
                            required: this.errorMessages.plRelation_required
                        },
                        JF: true
                    },
                    otherEducation: {
                        validations: [],
                        error: {
                            required: this.errorMessages.default_required
                        },
                        JF: true
                    },
                    fullName: {
                        validations: [Validators.required, Validators.minLength(2), Validators.pattern(nameRegex)],
                        error: {
                            required: this.errorMessages.fullname_required,
                            pattern: this.errorMessages.fullname_invalid,
                            minlength: this.errorMessages.name_minlength
                        },
                        MF: true,
                        JF: true,
                        MFJF: true
                    },
                    fatherName: {
                        validations: [Validators.required, Validators.minLength(2), Validators.pattern(nameRegex)],
                        error: {
                            required: this.errorMessages.fathername_required,
                            pattern: this.errorMessages.fathername_invalid,
                            minlength: this.errorMessages.name_minlength
                        },
                        MF: true,
                        JF: true,
                        MFJF: true
                    },
                    motherName: {
                        validations: [Validators.pattern(nameRegex), Validators.required],
                        error: {
                            required: this.errorMessages.mothername_required,
                            pattern: this.errorMessages.mothername_invalid,
                            minlength: this.errorMessages.name_minlength
                        },
                        MF: true,
                        JF: true,
                        MFJF: true
                    },
                    isPolitics: {
                        validations: [Validators.required],
                        error: {
                            required: this.errorMessages.default_required,
                        },
                        MF: true,
                        JF: true,
                        MFJF: true
                    },
                    gender: {
                        validations: [Validators.required],
                        error: {
                            required: this.errorMessages.default_required,
                        },
                        MF: true,
                        JF: true,
                        MFJF: true
                    },
                    marital: {
                        validations: [Validators.required],
                        error: {
                            required: this.errorMessages.default_required,
                        },
                        MF: true,
                        JF: true,
                        MFJF: true
                    },
                    address: {
                        validations: [],
                        error: {
                            required: this.errorMessages.default_required,
                            pattern: this.errorMessages.address_invalid
                        },
                        JF: false,
                        MF: true,
                        MFJF: false
                    },
                    address1: {
                        validations: [Validators.required, Validators.minLength(2)],
                        error: {
                            required: this.errorMessages.default_required,
                            pattern: this.errorMessages.address_invalid
                        },
                        JF: true,
                        MF: false,
                        MFJF: true
                    },
                    address2: {
                        validations: [Validators.required, Validators.minLength(2)],
                        error: {
                            required: this.errorMessages.default_required,
                            pattern: this.errorMessages.address_invalid
                        },
                        JF: true,
                        MF: false,
                        MFJF: true
                    },
                    city: {
                        validations: [Validators.required, Validators.minLength(2), Validators.pattern(cityRegex)],
                        error: {
                            required: this.errorMessages.default_required,
                            pattern: this.errorMessages.city_invalid
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    state: {
                        validations: [Validators.required],
                        error: {
                            required: this.errorMessages.default_required,
                            pattern: this.errorMessages.state_invalid
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    zipCode: {
                        validations: [Validators.required, Validators.pattern(pinCodeRegex)],
                        error: {
                            required: this.errorMessages.zipcode_required,
                            pattern: this.errorMessages.zipcode_invalid
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    isAddressSame: {
                        JFValidators: [Validators.required],
                        MFJFValidators: [Validators.required],
                        JF: true,
                        MF: false,
                        MFJF: true
                    },
                    addressC: {
                        JFValidators: [],
                        MFJFValidators: [Validators.minLength(2)],
                        MFValidators: [],
                        error: {
                            required: this.errorMessages.default_required,
                            pattern: this.errorMessages.address_invalid
                        },
                        JF: false,
                        MF: true,
                        MFJF: false
                    },
                    addressC1: {
                        JFValidators: [Validators.minLength(2)],
                        MFJFValidators: [Validators.minLength(2)],
                        MFValidators: [],
                        error: {
                            required: this.errorMessages.default_required,
                            pattern: this.errorMessages.address_invalid
                        },
                        JF: true,
                        MF: false,
                        MFJF: true
                    },
                    addressC2: {
                        JFValidators: [Validators.minLength(2)],
                        MFJFValidators: [Validators.minLength(2)],
                        MFValidators: [],
                        error: {
                            required: this.errorMessages.default_required,
                            pattern: this.errorMessages.address_invalid
                        },
                        JF: true,
                        MF: false,
                        MFJF: true
                    },
                    cityC: {
                        JFValidators: [Validators.minLength(2), Validators.pattern(cityRegex)],
                        MFValidators: [],
                        MFJFValidators: [Validators.minLength(2), Validators.pattern(cityRegex)],
                        error: {
                            required: this.errorMessages.default_required,
                            pattern: this.errorMessages.address_invalid
                        },
                        JF: true,
                        MFJF: true
                    },
                    stateC: {
                        JFValidators: [Validators.minLength(2), Validators.pattern(cityRegex)],
                        MFJFValidators: [Validators.minLength(2), Validators.pattern(cityRegex)],
                        MFValidators: [],
                        error: {
                            required: this.errorMessages.default_required,
                            pattern: this.errorMessages.address_invalid
                        },
                        JF: true,
                        MFJF: true
                    },
                    zipCodeC: {
                        JFValidators: [Validators.pattern(pinCodeRegex)],
                        MFJFValidators: [Validators.pattern(pinCodeRegex)],
                        MFValidators: [],
                        error: {
                            required: this.errorMessages.zipcode_required,
                            pattern: this.errorMessages.zipcode_invalid
                        },
                        JF: true,
                        MFJF: true
                    },
                    birthCountry: {
                        validations: [Validators.required, Validators.minLength(2), Validators.pattern(nameRegex)],
                        error: {
                            required: this.errorMessages.birthCountry_required,
                            invalid: this.errorMessages.country_invalid
                        },
                        MF: true,
                        MFJF: true,
                        JF: true
                    },
                    taxResidency: {
                        validations: [Validators.required, Validators.minLength(2), Validators.pattern(nameRegex)],
                        error: {
                            required: this.errorMessages.taxCountry_required,
                            invalid: this.errorMessages.country_invalid
                        },
                        MF: true,
                        MFJF: true,
                        JF: true
                    },
                    /*  occupation: {
                       JFValidators: [],
                       MFJFValidators: [],
                       MFValidators: [Validators.required],
                       error: {
                         required: this.errorMessages.default_required,
                         invalid: this.errorMessages.occupation_invalid
                       },
                       MF: true,
                       JF: false,
                       MFJF: false
                     }, */
                    tinNumber: {
                        JFValidators: [],
                        MFJFValidators: [],
                        MFValidators: [],
                        error: {
                            required: this.errorMessages.default_required,
                        },
                        MF: true,
                        JF: false,
                        MFJF: true
                    },
                    chequeFile: {
                        validations: [Validators.required],
                        error: {
                            'required': this.errorMessages.cheque_required,
                            'fileType': this.errorMessages.default_fileType,
                            'fileSize': this.errorMessages.default_fileSize
                        },
                        MF: true,
                        JF: true,
                        MFJF: true
                    },
                    accountNumber: {
                        validations: [Validators.required, Validators.pattern(accNoRegex)],
                        error: {
                            required: this.errorMessages.accNo_required,
                            pattern: this.errorMessages.accNo_pattern
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    repeatAccountNumber: {
                        validations: [Validators.required, Validators.pattern(accNoRegex)],
                        error: {
                            required: this.errorMessages.accNo_required,
                            pattern: this.errorMessages.accNo_pattern,
                            invalid: this.errorMessages.accNo_notmatch
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    ifsc: {
                        validations: [Validators.required, Validators.pattern(ifscRegex)],
                        error: {
                            required: this.errorMessages.ifsc_required,
                            pattern: this.errorMessages.ifsc_invalid
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    bankName: {
                        validations: [Validators.required],
                        error: {
                            required: this.errorMessages.bankname_required
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    branch: {
                        validations: [Validators.required],
                        error: {
                            required: this.errorMessages.bankbranchname_required
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    bankAddress: {
                        validations: [Validators.required],
                        error: {
                            required: this.errorMessages.branchAdd_required
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    micr: {
                        validations: [],
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    bankZipCode: {
                        JFValidators: [Validators.pattern(pinCodeRegex)],
                        MFJFValidators: [Validators.pattern(pinCodeRegex)],
                        MFValidators: [],
                        error: {
                            required: this.errorMessages.zipcode_required,
                            pattern: this.errorMessages.zipcode_invalid
                        },
                        JF: true,
                        MFJF: true
                    },
                    accountType: {
                        validations: [Validators.required],
                        error: {
                            required: this.errorMessages.accType_required
                        },
                        defaults: { JF: 'S', MF: 'S', MFJF: 'S' },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    /*  segments: [
                       {
                         formControlName: 'NSECASH',
                         formControlLabel: 'NSE CASH',
                         id: '8a82b2b068bc46360168bc52702b0002',
                         segmentName: "NSECash",
                         segmentType: "Equity",
                         validations: [],
                         JF: true,
                         MFJF: true
                       },
                       {
                         formControlName: 'BSECash',
                         formControlLabel: 'BSE CASH',
                         id: '8a82b2b068bc46360168bc5271d80003',
                         segmentName: "BSECash",
                         segmentType: "Equity",
                         validations: [],
                         JF: true,
                         MFJF: true
                       },
                       {
                         formControlName: 'NSEFNO',
                         formControlLabel: 'NSE F&O',
                         id: '8a82b2b0689dbae201689dbb581e0001',
                         segmentName: "NSEFNO",
                         segmentType: "Derivatives",
                         validations: [],
                         JF: true,
                         MFJF: true
                       },
                       {
                         formControlName: 'BSEFNO',
                         formControlLabel: 'BSE F&O',
                         id: '8a82b2b068bc46360168bc5272fe0006',
                         segmentName: "BSEFNO",
                         segmentType: "Derivatives",
                         validations: [],
                         JF: true,
                         MFJF: true,
                         hidden: true
                       },
                       {
                         formControlName: 'NSECDS',
                         formControlLabel: 'NSE CURRENCY',
                         id: '8a82b2b068bc46360168bc5272320004',
                         segmentName: "NSECDS",
                         segmentType: "Equity",
                         validations: [],
                         JF: true,
                         MFJF: true
                       },
                       {
                         formControlName: 'BSECDS',
                         formControlLabel: 'BSE CURRENCY',
                         id: '8a82b2b068bc46360168bc52729b0005',
                         segmentName: "BSECDS",
                         segmentType: "Equity",
                         validations: [],
                         JF: true,
                         MFJF: true,
                         hidden: true
                       },
                       {
                         formControlName: 'MCX',
                         formControlLabel: 'MCX',
                         id: '8a82b2b068bc46360168bc526e3c0000',
                         segmentName: "MCX",
                         segmentType: "Commodity",
                         validations: [],
                         JF: true,
                         MFJF: true
                       },
                       {
                         formControlName: 'NCDEX',
                         formControlLabel: 'NCDEX',
                         id: '8a82b2b068bc46360168bc526f570001',
                         segmentName: "NCDEX",
                         segmentType: "Commodity",
                         validations: [],
                         JF: true,
                         MFJF: true
                       }
                     ], */
                    /*           plans: {
                                selected: 'Life Time AMC Plan',
                                disabled: true,
                                controls: [
                                  { id: 'Life Time AMC Plan', value: 'Life Time AMC Plan', desc: '<strong>&#8377; 1,500 + 18% GST</strong>' },
                                  { id: 'Zero AMC Plan', value: 'Zero AMC Plan', desc: 'NIL with <strong>&#8377; 3,000 Refundable Deposit</strong>. Deposit will be refunded at the time of closing of Demat Account.' },
                                  { id: 'Annual AMC Plan', value: 'Annual AMC Plan', desc: '<strong>&#8377;  200+18% GST </strong>(Free for 1st Year)' }
                                ],
                                validations: [],
                                JF: true,
                                MFJF: true
                              }, */
                    ipvFile: {
                        validations: [],
                        error: {
                            'required': this.errorMessages.ipvFile_required,
                            'fileType': this.errorMessages.default_fileType2,
                            'fileSize': this.errorMessages.default_fileSize
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    panCardFile: {
                        JFValidators: [Validators.required],
                        MFJFValidators: [Validators.required],
                        MFValidators: [Validators.required],
                        error: {
                            'required': this.errorMessages.panFile_required,
                            'fileType': this.errorMessages.default_fileType,
                            'fileSize': this.errorMessages.default_fileSize
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    photoFile: {
                        validations: [Validators.required],
                        JFValidators: [],
                        MFJFValidators: [],
                        MFValidators: [],
                        error: {
                            'required': this.errorMessages.photoFile_required,
                            'fileType': this.errorMessages.default_fileType2,
                            'fileSize': this.errorMessages.default_fileSize
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    signFile: {
                        validations: [Validators.required],
                        error: {
                            'required': this.errorMessages.signFile_required,
                            'fileType': this.errorMessages.default_fileType2,
                            'fileSize': this.errorMessages.default_fileSize3
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    addrProofType: {
                        JFValidators: [Validators.required],
                        MFJFValidators: [Validators.required],
                        MFValidators: [Validators.required],
                        error: {
                            'required': this.errorMessages.addproof_required,
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    addrProofFrontFile: {
                        JFValidators: [Validators.required],
                        MFJFValidators: [Validators.required],
                        MFValidators: [Validators.required],
                        error: {
                            'required': 'Please Click/Upload Valid Address Proof.',
                            'fileType': 'Please upload file having extensions jpeg, jpg, and png only.',
                            'fileSize': 'Maximum Allowed File size is 10MB.',
                            'fileSize2': 'Maximum Allowed File size is 10MB.',
                            'fileTypeadhaar': 'Please upload file having extensions jpeg, jpg and png only.',
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    addrProofRearFile: {
                        validations: [],
                        error: {
                            'required': 'Please Click/Upload Valid Address Proof.',
                            'fileType': 'Please upload file having extensions jpeg, jpg, and png only.',
                            'fileSize': 'Maximum Allowed File size is 10MB.',
                            'fileSize2': 'Maximum Allowed File size is 10MB.',
                            'fileTypeadhaar': 'Please upload file having extensions jpeg, jpg and png only.',
                        },
                        JF: true,
                        MF: true,
                        MFJF: true,
                        hidden: true
                    },
                    ismaskingadhaar: {
                        JFValidators: [Validators.required],
                        MFJFValidators: [Validators.required],
                        MFValidators: [Validators.required],
                        JF: true,
                        MF: true,
                        MFJF: true,
                    },
                    overseasAddressFrontFile: {
                        JFValidators: [],
                        MFJFValidators: [],
                        MFValidators: [],
                        error: {
                            'required': this.errorMessages.overseasAddProof_required,
                            'fileType': this.errorMessages.default_fileType,
                            'fileSize': this.errorMessages.default_fileSize
                        },
                        JF: false,
                        MF: true,
                        MFJF: false
                    },
                    overseasAddressRearFile: {
                        JFValidators: [],
                        MFJFValidators: [],
                        MFValidators: [],
                        error: {
                            'required': this.errorMessages.overseasAddProof_required,
                            'fileType': this.errorMessages.default_fileType,
                            'fileSize': this.errorMessages.default_fileSize
                        },
                        JF: false,
                        MF: true,
                        MFJF: false
                    },
                    passportFrontFile: {
                        JFValidators: [],
                        MFJFValidators: [],
                        MFValidators: [],
                        error: {
                            'required': this.errorMessages.passportFile_required,
                            'fileType': this.errorMessages.default_fileType,
                            'fileSize': this.errorMessages.default_fileSize
                        },
                        JF: false,
                        MF: true,
                        MFJF: false
                    },
                    passportRearFile: {
                        JFValidators: [],
                        MFJFValidators: [],
                        MFValidators: [],
                        error: {
                            'required': this.errorMessages.passportFile_required,
                            'fileType': this.errorMessages.default_fileType,
                            'fileSize': this.errorMessages.default_fileSize
                        },
                        JF: false,
                        MF: true,
                        MFJF: false
                    },
                    visaFile: {
                        JFValidators: [],
                        MFJFValidators: [],
                        MFValidators: [],
                        error: {
                            'required': this.errorMessages.uploadVisa_required,
                            'fileType': this.errorMessages.default_fileType,
                            'fileSize': this.errorMessages.default_fileSize
                        },
                        JF: false,
                        MF: true,
                        MFJF: false
                    },
                    incomeProofType: {
                        JFValidators: [],
                        MFJFValidators: [],
                        MFValidators: [],
                        error: {
                            'required': this.errorMessages.incProof_required,
                        },
                        JF: true,
                        MF: false,
                        MFJF: true
                    },
                    incomeProofFile: {
                        validations: [],
                        error: {
                            'required': this.errorMessages.incProofFile_required,
                            'fileType': this.errorMessages.default_fileType_incomeproof,
                            'fileSize': this.errorMessages.default_fileSize
                        },
                        JF: true,
                        MF: false,
                        MFJF: true
                    },
                    aof: {
                        validations: [Validators.required],
                        error: {
                            'required': this.errorMessages.aofFile_required,
                            'fileType': this.errorMessages.default_fileType,
                            'fileSize': this.errorMessages.default_fileSize
                        },
                        JF: true,
                        MF: false,
                        MFJF: true
                    },
                    plans: {
                        selected: 'Annual AMC Plan',
                        disabled: true,
                        controls: [
                            { id: 'Annual AMC Plan', value: 'Annual AMC Plan', desc: '<strong>&#8377;  200+18% GST </strong><span class="info-style">(Free for 1st Year)</span>' },
                            { id: 'Life Time AMC Plan', value: 'Life Time AMC Plan', desc: '<strong>&#8377; 1,500 + 18% GST</strong>' },
                            { id: 'Zero AMC Plan', value: 'Zero AMC Plan', desc: 'NIL with <strong>&#8377; 3,000 Refundable Deposit</strong>. Deposit will be refunded at the time of closing of Demat Account.' },
                            { id: 'First Three Years AMC Free Plan', value: 'First Three Years AMC Free Plan', desc: '' },
                            { id: 'BSDA', value: 'BSDA', desc: '' }
                        ],
                        validations: [],
                        JF: false,
                        MFJF: true
                    },
                },
            },
            'onboard-info': {
                inputs: {
                    panNumber: {
                        validations: [Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern(panNumberRegex)],
                        error: {
                            required: this.errorMessages.pan_required,
                            pattern: this.errorMessages.pan_pattern2
                        },
                        MF: true,
                        JF: true,
                        MFJF: true
                    },
                    dateOfBirth: {
                        validations: [Validators.required, range(new Date(investorDateRange.min).valueOf(), new Date(investorDateRange.max).valueOf())],
                        error: {
                            required: this.errorMessages.dob_required,
                            range: this.errorMessages.dob_range,
                            pattern: this.errorMessages.invalidFormat
                        },
                        MF: true,
                        JF: true,
                        MFJF: true
                    }
                },
                getForwardRoute: function (investor) {
                    investor = investor || _this.investor;
                    if (investor && investor.id) {
                        var investorAccount = _this.getInvestorAccount(investor);
                        if (investorAccount.isOnBoardFlag == 'Y') {
                            return { 'error': 'Your onboarding is already completed. You will receive login credentials on your registered email ID within next few hours', 'onboardFlag': investorAccount.isOnBoardFlag };
                        }
                        else if (investorAccount.isOnBoardFlag == 'C') {
                            return _this.businessUnit == 'MF' ? { 'error': 'Congratualtions. Your account is already active with us.  Login to Investica with your client ID ' + investorAccount.clientID + '. You would have received the login credentials in your e-mail', 'onboardFlag': investorAccount.isOnBoardFlag } : _this.businessUnit == 'JF' ? { 'error': 'Congratualtions. Your account is already active with us.  Login to Choice FinX/Alphabee with your client ID ' + investorAccount.clientID + '. You would have received the login credentials in your e-mail', 'onboardFlag': investorAccount.isOnBoardFlag } : '';
                        }
                        // if (investorAccount.isOnBoardFlag == 'Y' || investorAccount.isOnBoardFlag == 'C') {
                        //   return this.businessUnit == 'MF' ? { 'error': 'This PAN is already associated with another account. Please Login or contact support team' } :
                        //     this.businessUnit == 'JF' ? { 'error': investorAccount.clientID ? 'Client associated with this pan already exists. Please Login' : 'Your Onboarding is Completed, You will recieve your credentials soon.' } : '';
                        // }
                        else if (investorAccount && investorAccount.isOnBoardFlag == 'N') {
                            return _this.getForwardRoute(investor, _this.businessUnit);
                        }
                    }
                    else {
                        return _this.getForwardRoute(investor, _this.businessUnit);
                    }
                },
                getBackwardRoute: function () {
                }
            },
            'registration': {
                inputs: {
                    mobileNumber: {
                        validations: [Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern(mobileNumberRegex)],
                        error: {
                            required: this.errorMessages.mob_required,
                            pattern: this.errorMessages.mob_pattern
                        },
                        MF: true
                    },
                    userName: {
                        validations: [Validators.required, Validators.minLength(6), Validators.maxLength(10), Validators.pattern(userNameRegex)],
                        error: {
                            required: this.errorMessages.userid_required,
                            pattern: this.errorMessages.username_pattern,
                            maxlength: this.errorMessages.username_maxlength,
                            minlength: this.errorMessages.username_minlength,
                            exist: this.errorMessages.userid_exists
                        },
                        MF: true
                    },
                    email: {
                        validations: [Validators.required, Validators.pattern(emailRegex)],
                        error: {
                            required: this.errorMessages.email_required,
                            pattern: this.errorMessages.email_invalid
                        },
                        MF: true
                    },
                    password: {
                        validations: [Validators.required, Validators.minLength(6), Validators.maxLength(20)],
                        error: {
                            required: this.errorMessages.password_required,
                            pattern: this.errorMessages.email_invalid
                        },
                        MF: true
                    },
                    referralCode: {
                        MFValidators: [Validators.minLength(0), Validators.maxLength(20), Validators.pattern(/^[a-z0-9]+$/i)],
                        JFValidators: [],
                        error: {
                            maxlength: this.errorMessages.reffcode_maxlength,
                            pattern: this.errorMessages.reffcode_pattern,
                        },
                        MF: true
                    }
                },
                getForwardRoute: function (investor) {
                    investor = investor || _this.investor;
                    if (investor && investor.id) {
                        return _this.businessUnit == 'MF' ? _this.getForwardRoute(investor, 'MF') : { 'error': _this.errorMessages.move_forward };
                    }
                },
                getBackwardRoute: function () {
                }
            },
            'otp-popup': {
                inputs: {
                    mobOtp: {
                        validations: [Validators.pattern(unifiedotpRegex)],
                        error: {
                            required: this.errorMessages.otp_required,
                            pattern: this.errorMessages.unifiedotp_pattern
                        },
                        MF: true,
                        JF: true
                    },
                    emailOtp: {
                        validations: [Validators.pattern(unifiedotpRegex)],
                        error: {
                            required: this.errorMessages.otp_required,
                            pattern: this.errorMessages.unifiedotp_pattern
                        },
                        MF: true,
                        JF: true
                    }
                }
            },
            'open-account': {
                inputs: {
                    mobileNumber: {
                        MFValidators: [Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern(mobileNumberRegex)],
                        JFValidators: [Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern(mobileNumberRegex)],
                        MFJFValidators: [Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern(mobileNumberRegex)],
                        error: {
                            required: this.errorMessages.mob_required,
                            pattern: this.errorMessages.mob_pattern
                        },
                        MF: true,
                        JF: true,
                        MFJF: false,
                    },
                    email: {
                        MFValidators: [Validators.required, Validators.pattern(emailRegex)],
                        JFValidators: [Validators.required, Validators.pattern(emailRegex)],
                        MFJFValidators: [Validators.required, Validators.pattern(emailRegex)],
                        error: {
                            required: this.errorMessages.email_required,
                            pattern: this.errorMessages.email_invalid
                        },
                        MF: true,
                        JF: true,
                        MFJF: true
                    },
                    referralCode: {
                        MFValidators: [],
                        JFValidators: [Validators.minLength(0), Validators.maxLength(20), Validators.pattern(/^[a-z0-9]+$/i)],
                        MFJFValidators: [Validators.minLength(0), Validators.maxLength(20), Validators.pattern(/^[a-z0-9]+$/i)],
                        error: {
                            maxlength: this.errorMessages.reffcode_maxlength,
                            pattern: this.errorMessages.reffcode_pattern,
                            invalid: this.errorMessages.reffCode_invalid
                        },
                        MF: false,
                        JF: true,
                        MFJF: false
                    },
                    leadCity: {
                        MFValidators: [],
                        JFValidators: [],
                        MFJFValidators: [],
                        error: {
                            required: this.errorMessages.leadcity_required,
                        },
                        MF: false,
                        JF: false,
                        MFJF: false
                    },
                    leadState: {
                        MFValidators: [],
                        JFValidators: [],
                        MFJFValidators: [],
                        error: {
                            required: this.errorMessages.leadstate_required,
                        },
                        MF: false,
                        JF: false,
                        MFJF: false
                    },
                    occupation: {
                        validations: [Validators.required],
                        error: {
                            required: this.errorMessages.default_required,
                            invalid: this.errorMessages.occupation_invalid
                        },
                        MF: true,
                        JF: true,
                        MFJF: true
                    },
                    education: {
                        validations: [Validators.required],
                        error: {
                            required: this.errorMessages.education_required,
                        },
                        JF: true,
                        MF: true
                    },
                    annualIncome: {
                        validations: [Validators.required, Validators.min(1)],
                        error: {
                            pattern: this.errorMessages.annualInc_invalid,
                            invalid: this.errorMessages.annualInc_invalid,
                            required: this.errorMessages.annualInc_required
                        },
                        JF: true,
                        MF: true
                    },
                    politicalRelation: {
                        validations: [Validators.required],
                        error: {
                            required: this.errorMessages.plRelation_required
                        },
                        JF: true,
                        MF: true
                    },
                    otherEducation: {
                        validations: [],
                        error: {
                            required: this.errorMessages.default_required
                        },
                        JF: true,
                        MF: true
                    }
                },
                getForwardRoute: function (investor) {
                    investor = investor || _this.investor;
                    if (investor && investor.id) {
                        return _this.getForwardRoute(investor, _this.businessUnit);
                    }
                },
                getBackwardRoute: function () {
                }
            },
            'recover-account': {
                inputs: {
                    otp: {
                        MFValidators: [Validators.required, Validators.pattern(otpRegex)],
                        error: {
                            required: this.errorMessages.otp_required,
                            pattern: this.errorMessages.otp_pattern
                        },
                        MF: true
                    }
                },
                getForwardRoute: function (investor) {
                    investor = investor || _this.investor;
                    if (investor && investor.id) {
                        return _this.getForwardRoute(investor, _this.businessUnit);
                    }
                    return _this.getForwardRoute(investor, _this.businessUnit);
                },
                getBackwardRoute: function () {
                }
            },
            'digi-locker': {
                getForwardRoute: function (investor) {
                    investor = investor || _this.investor;
                    if (investor && investor.id) {
                        return _this.getForwardRoute(investor, _this.businessUnit);
                    }
                },
                getBackwardRoute: function () {
                }
            },
            'basic-details': {
                inputs: {
                    fullName: {
                        validations: [Validators.required, Validators.minLength(2), Validators.pattern(nameRegex)],
                        error: {
                            required: this.errorMessages.fullname_required,
                            pattern: this.errorMessages.fullname_invalid,
                            minlength: this.errorMessages.name_minlength
                        },
                        MF: true,
                        JF: true,
                        MFJF: true
                    },
                    fatherName: {
                        validations: [Validators.required, Validators.minLength(2), Validators.pattern(nameRegex)],
                        error: {
                            required: this.errorMessages.fathername_required,
                            pattern: this.errorMessages.fathername_invalid,
                            minlength: this.errorMessages.name_minlength
                        },
                        MF: true,
                        JF: true,
                        MFJF: true
                    },
                    motherName: {
                        validations: [Validators.pattern(nameRegex), Validators.required],
                        error: {
                            required: this.errorMessages.mothername_required,
                            pattern: this.errorMessages.mothername_invalid,
                            minlength: this.errorMessages.name_minlength
                        },
                        MF: true,
                        JF: true,
                        MFJF: true
                    },
                    isPolitics: {
                        validations: [Validators.required],
                        error: {
                            required: this.errorMessages.default_required,
                        },
                        MF: true,
                        JF: true,
                        MFJF: true
                    },
                    gender: {
                        validations: [Validators.required],
                        error: {
                            required: this.errorMessages.default_required,
                        },
                        MF: true,
                        JF: true,
                        MFJF: true
                    },
                    marital: {
                        validations: [Validators.required],
                        error: {
                            required: this.errorMessages.default_required,
                        },
                        MF: true,
                        JF: true,
                        MFJF: true
                    },
                    isNomineeSkipped: {
                        validations: [Validators.required],
                        error: {
                            required: this.errorMessages.default_required,
                        },
                        MF: false,
                        JF: false,
                        MFJF: false
                    }
                },
                getForwardRoute: function (investor) {
                    investor = investor || _this.investor;
                    if (investor && investor.id) {
                        return _this.getForwardRoute(investor, _this.businessUnit);
                    }
                },
                getBackwardRoute: function () {
                }
            },
            'kyc-aadhar': {
                esignURL: '',
                successURL: '/nsdlekyc/succRes.jsp',
                failureURL: '/nsdlekyc/failRes.jsp',
                getForwardRoute: function (investor) {
                    investor = investor || _this.investor;
                    if (investor && investor.id) {
                        return _this.getForwardRoute(investor, _this.businessUnit);
                    }
                },
                getBackwardRoute: function () {
                }
            },
            'address-details': {
                inputs: {
                    address: {
                        validations: [Validators.required, Validators.minLength(2)],
                        error: {
                            required: this.errorMessages.default_required,
                            pattern: this.errorMessages.address_invalid
                        },
                        JF: false,
                        MF: true,
                        MFJF: true
                    },
                    address1: {
                        validations: [Validators.required, Validators.minLength(2)],
                        error: {
                            required: this.errorMessages.default_required,
                            pattern: this.errorMessages.address_invalid
                        },
                        JF: true,
                        MF: false,
                        MFJF: false
                    },
                    address2: {
                        validations: [Validators.required, Validators.minLength(2)],
                        error: {
                            required: this.errorMessages.default_required,
                            pattern: this.errorMessages.address_invalid
                        },
                        JF: true,
                        MF: false,
                        MFJF: false
                    },
                    city: {
                        validations: [Validators.required, Validators.minLength(2), Validators.pattern(cityRegex)],
                        error: {
                            required: this.errorMessages.default_required,
                            pattern: this.errorMessages.city_invalid
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    state: {
                        validations: [Validators.required],
                        error: {
                            required: this.errorMessages.default_required,
                            pattern: this.errorMessages.state_invalid
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    zipCode: {
                        validations: [Validators.required, Validators.pattern(pinCodeRegex)],
                        error: {
                            required: this.errorMessages.zipcode_required,
                            pattern: this.errorMessages.zipcode_invalid
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    isAddressSame: {
                        JFValidators: [Validators.required],
                        MFJFValidators: [Validators.required],
                        JF: true,
                        MF: false,
                        MFJF: true
                    },
                    addressC: {
                        JFValidators: [Validators.minLength(2)],
                        MFJFValidators: [Validators.minLength(2)],
                        MFValidators: [],
                        error: {
                            required: this.errorMessages.default_required,
                            pattern: this.errorMessages.address_invalid
                        },
                        JF: false,
                        MFJF: true
                    },
                    addressC1: {
                        JFValidators: [Validators.minLength(2)],
                        MFJFValidators: [Validators.minLength(2)],
                        MFValidators: [],
                        error: {
                            required: this.errorMessages.default_required,
                            pattern: this.errorMessages.address_invalid
                        },
                        JF: true,
                        MF: false,
                        MFJF: false
                    },
                    addressC2: {
                        JFValidators: [Validators.minLength(2)],
                        MFJFValidators: [Validators.minLength(2)],
                        MFValidators: [],
                        error: {
                            required: this.errorMessages.default_required,
                            pattern: this.errorMessages.address_invalid
                        },
                        JF: true,
                        MF: false,
                        MFJF: false
                    },
                    cityC: {
                        JFValidators: [Validators.minLength(2), Validators.pattern(cityRegex)],
                        MFValidators: [],
                        MFJFValidators: [Validators.minLength(2), Validators.pattern(cityRegex)],
                        error: {
                            required: this.errorMessages.default_required,
                            pattern: this.errorMessages.address_invalid
                        },
                        JF: true,
                        MFJF: true
                    },
                    stateC: {
                        JFValidators: [Validators.minLength(2), Validators.pattern(cityRegex)],
                        MFJFValidators: [Validators.minLength(2), Validators.pattern(cityRegex)],
                        MFValidators: [],
                        error: {
                            required: this.errorMessages.default_required,
                            pattern: this.errorMessages.address_invalid
                        },
                        JF: true,
                        MFJF: true
                    },
                    zipCodeC: {
                        JFValidators: [Validators.pattern(pinCodeRegex)],
                        MFJFValidators: [Validators.pattern(pinCodeRegex)],
                        MFValidators: [],
                        error: {
                            required: this.errorMessages.zipcode_required,
                            pattern: this.errorMessages.zipcode_invalid
                        },
                        JF: true,
                        MFJF: true
                    },
                },
                getForwardRoute: function (investor) {
                    investor = investor || _this.investor;
                    if (investor && investor.id) {
                        return _this.getForwardRoute(investor, _this.businessUnit);
                    }
                },
                getBackwardRoute: function () {
                }
            },
            'nominee-details': {
                inputs: {
                    name: {
                        JFValidators: [Validators.required, Validators.minLength(2), Validators.pattern(nameRegex)],
                        MFValidators: [Validators.required, Validators.minLength(2), Validators.pattern(nomineeNameRegex)],
                        MFJFValidators: [Validators.required, Validators.minLength(2), Validators.pattern(nameRegex)],
                        error: {
                            required: this.errorMessages.nominee_required,
                            pattern: this.errorMessages.name_invalid,
                            sameName: this.errorMessages.nominee_same
                        },
                        MF: true,
                        JF: true,
                        MFJF: true
                    },
                    mobileNum: {
                        JFValidators: [Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern(mobileNumberRegex)],
                        MFValidators: [Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern(mobileNumberRegex)],
                        MFJFValidators: [Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern(mobileNumberRegex)],
                        // validations: [Validators.minLength(10), Validators.maxLength(10), Validators.pattern(mobileNumberRegex)],
                        error: {
                            required: this.errorMessages.mob_required,
                            pattern: this.errorMessages.mob_pattern
                        },
                        MF: true,
                        JF: true,
                        MFJF: true,
                    },
                    email: {
                        // validations: [Validators.pattern(emailRegex)],
                        JFValidators: [Validators.required, Validators.pattern(emailRegex)],
                        MFValidators: [Validators.required, Validators.pattern(emailRegex)],
                        MFJFValidators: [Validators.required, Validators.pattern(emailRegex)],
                        error: {
                            required: this.errorMessages.email_required,
                            pattern: this.errorMessages.email_invalid
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    dob: {
                        // validations: [Validators.required],
                        JFValidators: [Validators.required],
                        MFValidators: [],
                        MFJFValidators: [],
                        error: {
                            required: this.errorMessages.dob_required,
                            range: this.errorMessages.dob_range,
                            pattern: this.errorMessages.invalidFormat
                        },
                        MF: true,
                        JF: true,
                        MFJF: true
                    },
                    isMinor: {
                        // validations: [],
                        JFValidators: [],
                        MFValidators: [],
                        MFJFValidators: [],
                        error: {
                            required: this.errorMessages.dob_required
                        },
                        MF: true,
                        JF: true,
                        MFJF: true
                    },
                    isAddrSameAsApplicant: {
                        // validations: [Validators.required],
                        JFValidators: [Validators.required],
                        MFValidators: [],
                        MFJFValidators: [],
                        error: {
                            required: this.errorMessages.default_required
                        },
                        MF: true,
                        JF: true,
                        MFJF: true
                    },
                    isNomineeMinor: {
                        // validations: [Validators.required],
                        JFValidators: [],
                        MFValidators: [],
                        MFJFValidators: [],
                        error: {
                            required: this.errorMessages.default_required
                        },
                        MF: false,
                        JF: false,
                        MFJF: false
                    },
                    isShowNomineeForm: {
                        // validations: [Validators.required],
                        JFValidators: [],
                        MFValidators: [],
                        MFJFValidators: [],
                        error: {
                            required: this.errorMessages.default_required
                        },
                        MF: false,
                        JF: false,
                        MFJF: false
                    },
                    address: {
                        validations: [],
                        error: {
                            required: this.errorMessages.default_required,
                            pattern: this.errorMessages.address_invalid
                        },
                        JF: false,
                        MF: false,
                        MFJF: false
                    },
                    address1: {
                        // validations: [Validators.required, Validators.minLength(2)],
                        JFValidators: [Validators.required, Validators.minLength(2)],
                        MFValidators: [Validators.minLength(2)],
                        MFJFValidators: [Validators.minLength(2)],
                        error: {
                            required: this.errorMessages.default_required,
                            pattern: this.errorMessages.address_invalid
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    address2: {
                        // validations: [Validators.required, Validators.minLength(2)],
                        JFValidators: [Validators.required, Validators.minLength(2)],
                        MFValidators: [Validators.minLength(2)],
                        MFJFValidators: [Validators.minLength(2)],
                        error: {
                            required: this.errorMessages.default_required,
                            pattern: this.errorMessages.address_invalid
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    city: {
                        // validations: [Validators.required, Validators.minLength(2), Validators.pattern(cityRegex)],
                        JFValidators: [Validators.required, Validators.minLength(2), Validators.pattern(cityRegex)],
                        MFValidators: [Validators.minLength(2), Validators.pattern(cityRegex)],
                        MFJFValidators: [Validators.minLength(2), Validators.pattern(cityRegex)],
                        error: {
                            required: this.errorMessages.default_required,
                            pattern: this.errorMessages.city_invalid
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    state: {
                        // validations: [Validators.required],
                        JFValidators: [Validators.required],
                        MFValidators: [],
                        MFJFValidators: [],
                        error: {
                            required: this.errorMessages.default_required,
                            pattern: this.errorMessages.state_invalid
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    zipCode: {
                        // validations: [Validators.required, Validators.pattern(pinCodeRegex)],
                        JFValidators: [Validators.required, Validators.pattern(pinCodeRegex)],
                        MFValidators: [Validators.pattern(pinCodeRegex)],
                        MFJFValidators: [Validators.pattern(pinCodeRegex)],
                        error: {
                            required: this.errorMessages.zipcode_required,
                            pattern: this.errorMessages.zipcode_invalid
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    relation: {
                        // validations: [Validators.required],
                        JFValidators: [Validators.required],
                        MFValidators: [Validators.required],
                        MFJFValidators: [Validators.required],
                        error: {
                            required: this.errorMessages.nomineeRelation_required
                        },
                        MF: true,
                        JF: true,
                        MFJF: true
                    },
                    shares: {
                        // validations: [Validators.required, Validators.pattern(sharePercentRegex)],
                        JFValidators: [Validators.required, Validators.pattern(sharePercentRegex)],
                        MFValidators: [Validators.required, Validators.pattern(sharePercentRegex)],
                        MFJFValidators: [Validators.required, Validators.pattern(sharePercentRegex)],
                        error: {
                            required: this.errorMessages.sharePrcnt_required,
                            pattern: this.errorMessages.sharePrcnt_invalid
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    proofType: {
                        // validations: [Validators.required],
                        JFValidators: [Validators.required],
                        MFValidators: [Validators.required],
                        MFJFValidators: [Validators.required],
                        error: {
                            'required': this.errorMessages.doctype_required
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    documentId: {
                        // validations: [Validators.required],
                        JFValidators: [Validators.required],
                        MFValidators: [Validators.required],
                        MFJFValidators: [Validators.required],
                        error: {
                            'required': this.errorMessages.docID_required,
                            'pattern': this.errorMessages.docID_invalid
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    proofFileName1: {
                        // validations: [Validators.required],
                        JFValidators: [Validators.required],
                        MFValidators: [],
                        MFJFValidators: [],
                        error: {
                            'required': this.errorMessages.defaultUpload_valid,
                            'fileType': this.errorMessages.default_fileType,
                            'fileSize': this.errorMessages.default_fileSize
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    proofFileName2: {
                        // validations: [],
                        JFValidators: [],
                        MFValidators: [],
                        MFJFValidators: [],
                        error: {
                            // 'required': this.errorMessages.defaultUpload_valid,
                            'fileType': this.errorMessages.default_fileType,
                            'fileSize': this.errorMessages.default_fileSize
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    guardianName: {
                        // validations: [Validators.minLength(2), Validators.pattern(nameRegex)],
                        JFValidators: [Validators.minLength(2), Validators.pattern(nameRegex)],
                        MFValidators: [Validators.minLength(2), Validators.pattern(nameRegex)],
                        MFJFValidators: [Validators.minLength(2), Validators.pattern(nameRegex)],
                        error: {
                            required: this.errorMessages.guardianname_required,
                            pattern: this.errorMessages.guardianname_invalid
                        },
                        MF: true,
                        JF: true,
                        MFJF: true
                    },
                    gdMobileNum: {
                        // validations: [Validators.minLength(10), Validators.maxLength(10), Validators.pattern(mobileNumberRegex)],
                        JFValidators: [Validators.minLength(10), Validators.maxLength(10), Validators.pattern(mobileNumberRegex)],
                        MFValidators: [Validators.minLength(10), Validators.maxLength(10), Validators.pattern(mobileNumberRegex)],
                        MFJFValidators: [Validators.minLength(10), Validators.maxLength(10), Validators.pattern(mobileNumberRegex)],
                        error: {
                            required: this.errorMessages.mob_required,
                            pattern: this.errorMessages.mob_pattern
                        },
                        MF: true,
                        JF: true,
                        MFJF: true,
                    },
                    gdEmail: {
                        // validations: [Validators.pattern(emailRegex)],
                        JFValidators: [Validators.pattern(emailRegex)],
                        MFValidators: [Validators.pattern(emailRegex)],
                        MFJFValidators: [Validators.pattern(emailRegex)],
                        error: {
                            required: this.errorMessages.email_required,
                            pattern: this.errorMessages.email_invalid
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    gdisAddrSameAsApplicant: {
                        // validations: [Validators.required],
                        JFValidators: [Validators.required],
                        MFValidators: [],
                        MFJFValidators: [],
                        error: {
                            required: this.errorMessages.default_required
                        },
                        MF: true,
                        JF: true,
                        MFJF: true
                    },
                    gdAddress: {
                        JFValidators: [],
                        MFValidators: [],
                        MFJFValidators: [],
                        error: {
                            required: this.errorMessages.default_required,
                            pattern: this.errorMessages.guardianAdd_invalid
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    gdAddress1: {
                        // validations: [Validators.required, Validators.minLength(2)],
                        JFValidators: [Validators.required, Validators.minLength(2)],
                        MFValidators: [Validators.minLength(2)],
                        MFJFValidators: [Validators.minLength(2)],
                        error: {
                            required: this.errorMessages.default_required,
                            pattern: this.errorMessages.address_invalid
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    gdAddress2: {
                        // validations: [Validators.required, Validators.minLength(2)],
                        JFValidators: [Validators.required, Validators.minLength(2)],
                        MFValidators: [Validators.minLength(2)],
                        MFJFValidators: [Validators.minLength(2)],
                        error: {
                            required: this.errorMessages.default_required,
                            pattern: this.errorMessages.address_invalid
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    gdCity: {
                        // validations: [Validators.required, Validators.minLength(2), Validators.pattern(cityRegex)],
                        JFValidators: [Validators.required, Validators.minLength(2), Validators.pattern(cityRegex)],
                        MFValidators: [Validators.minLength(2), Validators.pattern(cityRegex)],
                        MFJFValidators: [Validators.minLength(2), Validators.pattern(cityRegex)],
                        error: {
                            required: this.errorMessages.default_required,
                            pattern: this.errorMessages.city_invalid
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    gdState: {
                        // validations: [Validators.required, Validators.minLength(2), Validators.pattern(cityRegex)],
                        JFValidators: [Validators.required, Validators.minLength(2), Validators.pattern(cityRegex)],
                        MFValidators: [Validators.pattern(cityRegex)],
                        MFJFValidators: [Validators.pattern(cityRegex)],
                        error: {
                            required: this.errorMessages.default_required,
                            pattern: this.errorMessages.address_invalid
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    gdZipCode: {
                        // validations: [Validators.required, Validators.pattern(pinCodeRegex)],
                        JFValidators: [Validators.required, Validators.pattern(pinCodeRegex)],
                        MFValidators: [Validators.pattern(pinCodeRegex)],
                        MFJFValidators: [Validators.pattern(pinCodeRegex)],
                        error: {
                            required: this.errorMessages.zipcode_required,
                            pattern: this.errorMessages.zipcode_invalid
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    gdRelation: {
                        // validations: [Validators.required],
                        JFValidators: [Validators.required],
                        MFValidators: [Validators.required],
                        MFJFValidators: [Validators.required],
                        error: {
                            'required': this.errorMessages.defaultRelation_required
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    gdProofType: {
                        // validations: [Validators.required],
                        JFValidators: [],
                        MFValidators: [],
                        MFJFValidators: [],
                        error: {
                            'required': this.errorMessages.doctype_required
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    gdDocumentId: {
                        // validations: [Validators.required, Validators.pattern(panNumberRegex)],
                        JFValidators: [],
                        MFValidators: [],
                        MFJFValidators: [],
                        error: {
                            // 'required': this.errorMessages.docID_required,
                            'pattern': this.errorMessages.docID_invalid
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    gdproofFileName1: {
                        // validations: [Validators.required],
                        // JFValidators: [Validators.required],
                        MFValidators: [],
                        MFJFValidators: [],
                        error: {
                            // 'required': this.errorMessages.defaultUpload_valid,
                            'fileType': this.errorMessages.default_fileType,
                            'fileSize': this.errorMessages.default_fileSize
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    gdproofFileName2: {
                        // validations: [],
                        JFValidators: [],
                        MFValidators: [],
                        MFJFValidators: [],
                        error: {
                            // 'required': this.errorMessages.defaultUpload_valid,
                            'fileType': this.errorMessages.default_fileType,
                            'fileSize': this.errorMessages.default_fileSize
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                },
                getForwardRoute: function (investor) {
                    investor = investor || _this.investor;
                    if (investor && investor.id) {
                        return _this.getForwardRoute(investor, _this.businessUnit);
                    }
                },
                getBackwardRoute: function () {
                }
            },
            'bank-details': {
                inputs: {
                    chequeFile: {
                        validations: [],
                        error: {
                            'required': this.errorMessages.cheque_required,
                            'fileType': this.errorMessages.default_fileType,
                            'fileSize': this.errorMessages.default_fileSize
                        },
                        MF: true,
                        JF: true,
                        MFJF: true
                    },
                    accountNumber: {
                        validations: [Validators.required, Validators.pattern(accNoRegex)],
                        error: {
                            required: this.errorMessages.accNo_required,
                            pattern: this.errorMessages.accNo_pattern
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    repeatAccountNumber: {
                        validations: [Validators.required, Validators.pattern(accNoRegex)],
                        error: {
                            required: this.errorMessages.accNo_required,
                            pattern: this.errorMessages.accNo_pattern,
                            invalid: this.errorMessages.accNo_notmatch
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    ifsc: {
                        validations: [Validators.required, Validators.pattern(ifscRegex)],
                        error: {
                            required: this.errorMessages.ifsc_required,
                            pattern: this.errorMessages.ifsc_invalid
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    bankName: {
                        validations: [Validators.required],
                        error: {
                            required: this.errorMessages.bankname_required
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    branch: {
                        validations: [Validators.required],
                        error: {
                            required: this.errorMessages.bankbranchname_required
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    bankAddress: {
                        validations: [Validators.required],
                        error: {
                            required: this.errorMessages.branchAdd_required
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    micr: {
                        validations: [],
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    bankZipCode: {
                        JFValidators: [Validators.pattern(pinCodeRegex)],
                        MFJFValidators: [Validators.pattern(pinCodeRegex)],
                        MFValidators: [],
                        error: {
                            required: this.errorMessages.zipcode_required,
                            pattern: this.errorMessages.zipcode_invalid
                        },
                        JF: true,
                        MFJF: true
                    },
                    accountType: {
                        validations: [Validators.required],
                        error: {
                            required: this.errorMessages.accType_required
                        },
                        defaults: { JF: 'S', MF: 'S', MFJF: 'S' },
                        JF: true,
                        MF: true,
                        MFJF: true
                    }
                },
                getForwardRoute: function (investor) {
                    investor = investor || _this.investor;
                    if (investor && investor.id) {
                        return _this.getForwardRoute(investor, _this.businessUnit);
                    }
                },
                getBackwardRoute: function () {
                }
            },
            'income-details': {
                inputs: {
                    birthCountry: {
                        validations: [Validators.required, Validators.minLength(2), Validators.pattern(nameRegex)],
                        error: {
                            required: this.errorMessages.birthCountry_required,
                            invalid: this.errorMessages.country_invalid
                        },
                        MF: true,
                        MFJF: true,
                        JF: true
                    },
                    taxResidency: {
                        validations: [Validators.required, Validators.minLength(2), Validators.pattern(nameRegex)],
                        error: {
                            required: this.errorMessages.taxCountry_required,
                            invalid: this.errorMessages.country_invalid
                        },
                        MF: true,
                        MFJF: true,
                        JF: true
                    },
                    occupation: {
                        JFValidators: [],
                        MFJFValidators: [],
                        MFValidators: [Validators.required],
                        error: {
                            required: this.errorMessages.default_required,
                            invalid: this.errorMessages.occupation_invalid
                        },
                        MF: true,
                        JF: false,
                        MFJF: false
                    },
                    tinNumber: {
                        JFValidators: [],
                        MFJFValidators: [],
                        MFValidators: [],
                        error: {
                            required: this.errorMessages.default_required,
                        },
                        MF: true,
                        JF: false,
                        MFJF: true
                    }
                },
                getForwardRoute: function (investor) {
                    investor = investor || _this.investor;
                    if (investor && investor.id) {
                        return _this.getForwardRoute(investor, _this.businessUnit);
                    }
                },
                getBackwardRoute: function () {
                }
            },
            'ipv-details': {
                inputs: {
                    ipvFile: {
                        validations: [],
                        error: {
                            'required': 'Please Click Valid IPV File.',
                            'fileType': this.errorMessages.default_fileType2,
                            'fileSize': this.errorMessages.default_fileSize
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    }
                },
                getForwardRoute: function (investor) {
                    investor = investor || _this.investor;
                    if (investor && investor.id) {
                        return _this.getForwardRoute(investor, _this.businessUnit);
                    }
                },
                getBackwardRoute: function () {
                }
            },
            'segment-details': {
                inputs: {
                    segments: [
                        {
                            formControlName: 'NSECASH',
                            formControlLabel: 'NSE CASH',
                            id: '8a82b2b068bc46360168bc52702b0002',
                            segmentName: "NSECash",
                            segmentType: "Equity",
                            validations: [],
                            JF: true,
                            MFJF: true
                        },
                        {
                            formControlName: 'BSECash',
                            formControlLabel: 'BSE CASH',
                            id: '8a82b2b068bc46360168bc5271d80003',
                            segmentName: "BSECash",
                            segmentType: "Equity",
                            validations: [],
                            JF: true,
                            MFJF: true
                        },
                        {
                            formControlName: 'NSEFNO',
                            formControlLabel: 'NSE F&O',
                            id: '8a82b2b0689dbae201689dbb581e0001',
                            segmentName: "NSEFNO",
                            segmentType: "Derivatives",
                            validations: [],
                            JF: true,
                            MFJF: true
                        },
                        {
                            formControlName: 'BSEFNO',
                            formControlLabel: 'BSE F&O',
                            id: '8a82b2b068bc46360168bc5272fe0006',
                            segmentName: "BSEFNO",
                            segmentType: "Derivatives",
                            validations: [],
                            JF: true,
                            MFJF: true,
                            hidden: true
                        },
                        {
                            formControlName: 'NSECDS',
                            formControlLabel: 'NSE CURRENCY',
                            id: '8a82b2b068bc46360168bc5272320004',
                            segmentName: "NSECDS",
                            segmentType: "Equity",
                            validations: [],
                            JF: true,
                            MFJF: true
                        },
                        {
                            formControlName: 'BSECDS',
                            formControlLabel: 'BSE CURRENCY',
                            id: '8a82b2b068bc46360168bc52729b0005',
                            segmentName: "BSECDS",
                            segmentType: "Equity",
                            validations: [],
                            JF: true,
                            MFJF: true,
                            hidden: true
                        },
                        {
                            formControlName: 'MCX',
                            formControlLabel: 'MCX',
                            id: '8a82b2b068bc46360168bc526e3c0000',
                            segmentName: "MCX",
                            segmentType: "Commodity",
                            validations: [],
                            JF: true,
                            MFJF: true
                        },
                        {
                            formControlName: 'NCDEX',
                            formControlLabel: 'NCDEX',
                            id: '8a82b2b068bc46360168bc526f570001',
                            segmentName: "NCDEX",
                            segmentType: "Commodity",
                            validations: [],
                            JF: true,
                            MFJF: true
                        }
                        // {
                        //   formControlName: 'ICEX',
                        //   formControlLabel: 'ICEX',
                        //   id: '8a82b2b069c40ced0169c43dd5480009',
                        //   segmentName: "ICEX",
                        //   segmentType: "Commodity",
                        //   validations: [],
                        //   JF: true,
                        //   MFJF: true
                        // }
                        // {
                        //   formControlName: 'MTF',
                        //   formControlLabel: 'MTF(Margin Trading Facility)',
                        //   id: 'ff8081816cdd312b016cdd34f0510000',
                        //   segmentName: "MTF",
                        //   segmentType: "Service",
                        //   info: 'Using Margin Trading Facility (MTF) facility, an investor can buy Share saying a small amount from his available funds/shares as collateral known as Margin. The remaining balance required to complete the transaction is funded by the Bro. For more info <a href="https://choicebroking.in/mtf-services" target="_blank">Click Here</a>.',
                        //   validations: [],
                        //   JF: true,
                        //   MFJF: true
                        // }
                    ],
                    plans: {
                        selected: 'Annual AMC Plan',
                        disabled: true,
                        controls: [
                            { id: 'Annual AMC Plan', value: 'Annual AMC Plan', desc: '<strong>&#8377;  200+18% GST </strong><span class="info-style">(Free for 1st Year)</span>' },
                            { id: 'Life Time AMC Plan', value: 'Life Time AMC Plan', desc: '<strong>&#8377; 1,500 + 18% GST</strong>' },
                            { id: 'Zero AMC Plan', value: 'Zero AMC Plan', desc: 'NIL with <strong>&#8377; 3,000 Refundable Deposit</strong>. Deposit will be refunded at the time of closing of Demat Account.' },
                            { id: 'First Three Years AMC Free Plan', value: 'First Three Years AMC Free Plan', desc: '' },
                            { id: 'BSDA', value: 'BSDA', desc: '' }
                        ],
                        validations: [],
                        JF: true,
                        MFJF: true
                    }
                },
                getForwardRoute: function (investor) {
                    investor = investor || _this.investor;
                    if (investor && investor.id) {
                        return _this.getForwardRoute(investor, _this.businessUnit);
                    }
                },
                getBackwardRoute: function () {
                }
            },
            'document-uploads': {
                inputs: {
                    panCardFile: {
                        JFValidators: [],
                        MFJFValidators: [],
                        MFValidators: [],
                        error: {
                            'required': this.errorMessages.panFile_required,
                            'fileType': this.errorMessages.default_fileType,
                            'fileSize': this.errorMessages.default_fileSize
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    photoFile: {
                        JFValidators: [],
                        MFJFValidators: [],
                        MFValidators: [],
                        error: {
                            'required': this.errorMessages.photoFile_required,
                            'fileType': this.errorMessages.default_fileType2,
                            'fileSize': this.errorMessages.default_fileSize
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    addrProofType: {
                        JFValidators: [],
                        MFJFValidators: [],
                        MFValidators: [],
                        error: {
                            'required': this.errorMessages.incProof_required,
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    addrProofFrontFile: {
                        JFValidators: [Validators.required],
                        MFJFValidators: [],
                        MFValidators: [],
                        error: {
                            'required': 'Please Click/Upload Valid Address Proof.',
                            'fileType': 'Please upload file having extensions jpeg, jpg, and png only.',
                            'fileTypeadhaar': 'Please upload file having extensions jpeg, jpg and png only.',
                            'fileSize': 'Maximum Allowed File size is 10MB.',
                            'fileSize2': 'Maximum Allowed File size is 10MB.',
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    ismaskingadhaar: {
                        JFValidators: [Validators.required],
                        MFJFValidators: [Validators.required],
                        MFValidators: [Validators.required],
                        JF: true,
                        MF: true,
                        MFJF: true,
                    },
                    addrProofRearFile: {
                        validations: [],
                        error: {
                            'required': 'Please Click/Upload Valid Address Proof.',
                            'fileType': 'Please upload file having extensions jpeg, jpg, and png only.',
                            'fileSize': 'Maximum Allowed File size is 10MB.',
                            'fileSize2': 'Maximum Allowed File size is 10MB.',
                            'fileTypeadhaar': 'Please upload file having extensions jpeg, jpg and png only.',
                        },
                        JF: true,
                        MF: true,
                        MFJF: true,
                        hidden: true
                    },
                    overseasAddressFrontFile: {
                        JFValidators: [Validators.required],
                        MFJFValidators: [],
                        MFValidators: [],
                        error: {
                            'required': this.errorMessages.overseasAddProof_required,
                            'fileType': this.errorMessages.default_fileType,
                            'fileSize': this.errorMessages.default_fileSize
                        },
                        JF: false,
                        MF: true,
                        MFJF: false
                    },
                    overseasAddressRearFile: {
                        JFValidators: [],
                        MFJFValidators: [],
                        MFValidators: [],
                        error: {
                            'required': this.errorMessages.overseasAddProof_required,
                            'fileType': this.errorMessages.default_fileType,
                            'fileSize': this.errorMessages.default_fileSize
                        },
                        JF: false,
                        MF: true,
                        MFJF: false
                    },
                    passportFrontFile: {
                        JFValidators: [],
                        MFJFValidators: [],
                        MFValidators: [],
                        error: {
                            'required': this.errorMessages.passportFile_required,
                            'fileType': this.errorMessages.default_fileType,
                            'fileSize': this.errorMessages.default_fileSize
                        },
                        JF: false,
                        MF: true,
                        MFJF: false
                    },
                    passportRearFile: {
                        JFValidators: [],
                        MFJFValidators: [],
                        MFValidators: [],
                        error: {
                            'required': this.errorMessages.passportFile_required,
                            'fileType': this.errorMessages.default_fileType,
                            'fileSize': this.errorMessages.default_fileSize
                        },
                        JF: false,
                        MF: true,
                        MFJF: false
                    },
                    visaFile: {
                        JFValidators: [],
                        MFJFValidators: [],
                        MFValidators: [],
                        error: {
                            'required': 'Please Upload VISA.',
                            'fileType': this.errorMessages.default_fileType,
                            'fileSize': this.errorMessages.default_fileSize
                        },
                        JF: false,
                        MF: true,
                        MFJF: false
                    },
                    incomeProofType: {
                        JFValidators: [],
                        MFJFValidators: [],
                        MFValidators: [],
                        error: {
                            'required': this.errorMessages.incProof_required,
                        },
                        JF: true,
                        MF: false,
                        MFJF: true
                    },
                    incomeProofFile: {
                        validations: [],
                        error: {
                            'required': this.errorMessages.incProofFile_required,
                            'fileType': this.errorMessages.default_fileType_incomeproof,
                            'fileSize': this.errorMessages.default_fileSize
                        },
                        JF: true,
                        MF: false,
                        MFJF: true
                    },
                    plans: {
                        selected: 'Annual AMC Plan',
                        disabled: true,
                        controls: [
                            { id: 'Annual AMC Plan', value: 'Annual AMC Plan', desc: '<strong>&#8377;  200+18% GST </strong><span class="info-style">(Free for 1st Year)</span>', key: '3' },
                            { id: 'Life Time AMC Plan', value: 'Life Time AMC Plan', desc: '<strong>&#8377; 1,500 + 18% GST</strong>', key: '1' },
                            { id: 'Zero AMC Plan', value: 'Zero AMC Plan', desc: 'NIL with <strong>&#8377; 3,000 Refundable Deposit</strong>. Deposit will be refunded at the time of closing of Demat Account.', key: '2' },
                            { id: 'First Three Years AMC Free Plan', value: 'First Three Years AMC Free Plan', desc: '', key: '4' },
                            { id: 'BSDA', value: 'BSDA', desc: '', key: '5' }
                        ],
                        validations: [],
                        JF: false,
                        MFJF: false
                    },
                    signFile: {
                        validations: [Validators.required],
                        error: {
                            'required': this.errorMessages.signFile_required,
                            'fileType': this.errorMessages.default_fileType2,
                            'fileSize': this.errorMessages.default_fileSize3
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    expireDate: {
                        validations: [Validators.required],
                        error: {
                            required: this.errorMessages.expire_date,
                            pattern: this.errorMessages.invalidFormat
                        },
                        MF: true,
                        JF: true,
                        MFJF: true
                    },
                    identifyNumber: {
                        validations: [Validators.required],
                        error: {
                            required: this.errorMessages.identify_Number,
                        },
                        MF: true,
                        JF: true,
                        MFJF: true
                    },
                    segments: [
                        {
                            formControlName: 'MTF',
                            formControlLabel: 'MTF(Margin Trading Facility)',
                            id: 'ff8081816cdd312b016cdd34f0510000',
                            info: 'Using Margin Trading Facility (MTF) facility, an investor can buy shares using a small amount from his available funds/shares as collateral known as margin. The remaining balance required to complete the transaction is funded by the broker.',
                            segmentName: "MTF",
                            segmentType: "Service",
                            incomeProofRequired: false,
                            validations: [],
                            hidden: false,
                            JF: true,
                            MFJF: true
                        },
                        {
                            formControlName: 'NSESLBM',
                            formControlLabel: 'SLBM (NSE)',
                            id: '9481b24273c8d3ad0173cca5cd240000',
                            info: 'SLBM or Stock Lending and Borrowing is a mechanism in which a trader can borrow shares that they do not already own or can lend the stocks that they own. An SLBM transaction has a rate of interest and a fixed tenure.',
                            segmentName: "NSESLBM",
                            segmentType: "Service",
                            incomeProofRequired: false,
                            validations: [],
                            JF: true,
                            MFJF: true
                        }, {
                            formControlName: 'BSECDS',
                            formControlLabel: 'CURRENCY',
                            info: 'Currency derivatives are financial contracts between the buyer and seller involving the exchange of two currencies at a future.',
                            id: '8a82b2b068bc46360168bc52729b0005',
                            segmentName: "BSECDS",
                            segmentType: "Currency",
                            validations: [],
                            JF: true,
                            MFJF: true,
                            hidden: true
                        },
                        {
                            formControlName: 'MCX',
                            formControlLabel: 'MCX',
                            info: 'In the commodity market, you can buy, sell, or trade raw products like oil, gold, copper or coffee, categorized as either natural resources (hard commodities) or livestock and agricultural goods (soft commodities).',
                            id: '8a82b2b068bc46360168bc526e3c0000',
                            segmentName: "MCX",
                            segmentType: "Commodity",
                            validations: [],
                            JF: true,
                            MFJF: true
                        },
                        {
                            formControlName: 'BSEFNO',
                            formControlLabel: 'DERIVATIVES',
                            info: 'Equity derivatives are contracts deriving value from stock or stock index price movements, such as Nifty 50 and Bank Nifty.',
                            id: '8a82b2b068bc46360168bc5272fe0006',
                            segmentName: "BSEFNO",
                            segmentType: "Equity",
                            validations: [],
                            JF: true,
                            MFJF: true,
                            hidden: true
                        },
                    ]
                },
                getForwardRoute: function (investor, isSkippable) {
                    investor = investor || _this.investor;
                    if (investor && investor.id) {
                        return _this.getForwardRoute(investor, _this.businessUnit, isSkippable);
                    }
                },
                getBackwardRoute: function () {
                }
            },
            'brokerage-details': {
                inputs: {
                    eqTrPaisa1: {
                        validations: [Validators.required],
                        JF: true,
                        error: {
                            'required': this.errorMessages.default_required,
                            'min': this.errorMessages.brokerage_min
                        },
                    },
                    eqTrPer1: {
                        validations: [Validators.required],
                        JF: true,
                        error: {
                            'required': this.errorMessages.default_required,
                            'min': this.errorMessages.eqt_min
                        },
                    },
                    eqTrPaisa2: {
                        validations: [Validators.required],
                        JF: true,
                        error: {
                            'required': this.errorMessages.default_required,
                            'min': this.errorMessages.brokerage_min
                        },
                    },
                    eqTrPer2: {
                        validations: [Validators.required],
                        JF: true,
                        error: {
                            'required': this.errorMessages.default_required,
                            'min': this.errorMessages.eqt_min
                        },
                    },
                    eqDelPaisa1: {
                        validations: [Validators.required],
                        JF: true,
                        error: {
                            'required': this.errorMessages.default_required,
                            'min': this.errorMessages.brokerage_min
                        },
                    },
                    eqDelPer1: {
                        validations: [Validators.required],
                        JF: true,
                        error: {
                            'required': this.errorMessages.default_required,
                            'min': this.errorMessages.eqt_min
                        },
                    },
                    eqDelPaisa2: {
                        validations: [Validators.required],
                        JF: true,
                        error: {
                            'required': this.errorMessages.default_required,
                            'min': this.errorMessages.brokerage_min
                        },
                    },
                    eqDelPer2: {
                        validations: [Validators.required],
                        JF: true,
                        error: {
                            'required': this.errorMessages.default_required,
                            'min': this.errorMessages.eqt_min
                        },
                    },
                    eqFutPaisa1: {
                        validations: [Validators.required],
                        JF: true,
                        error: {
                            'required': this.errorMessages.default_required,
                            'min': this.errorMessages.brokerage_min
                        },
                    },
                    eqFutPer1: {
                        validations: [Validators.required],
                        JF: true,
                        error: {
                            'required': this.errorMessages.default_required,
                            'min': this.errorMessages.eqt_min
                        },
                    },
                    eqFutPaisa2: {
                        validations: [Validators.required],
                        JF: true,
                        error: {
                            'required': this.errorMessages.default_required,
                            'min': this.errorMessages.brokerage_min
                        },
                    },
                    eqFutPer2: {
                        validations: [Validators.required],
                        JF: true,
                        error: {
                            'required': this.errorMessages.default_required,
                            'min': this.errorMessages.eqt_min
                        },
                    },
                    eqOptionRs1: {
                        validations: [Validators.required],
                        JF: true,
                        error: {
                            'required': this.errorMessages.default_required,
                            'min': 'Min value allowed is Re. 1.'
                        },
                    },
                    eqOptionRs2: {
                        validations: [Validators.required],
                        JF: true,
                        error: {
                            'required': this.errorMessages.default_required,
                            'min': 'Min value allowed is is Re. 1.'
                        },
                    },
                    cdFutPaisa1: {
                        validations: [Validators.required],
                        JF: true,
                        error: {
                            'required': this.errorMessages.default_required,
                            'min': this.errorMessages.brokerage_min
                        },
                    },
                    cdFutPer1: {
                        validations: [Validators.required],
                        JF: true,
                        error: {
                            'required': this.errorMessages.default_required,
                            'min': this.errorMessages.eqt_min
                        },
                    },
                    cdFutPaisa2: {
                        validations: [Validators.required],
                        JF: true,
                        error: {
                            'required': this.errorMessages.default_required,
                            'min': this.errorMessages.brokerage_min
                        },
                    },
                    cdFutPer2: {
                        validations: [Validators.required],
                        JF: true,
                        error: {
                            'required': this.errorMessages.default_required,
                            'min': this.errorMessages.eqt_min
                        },
                    },
                    cdOptionRs1: {
                        validations: [Validators.required],
                        JF: true,
                        error: {
                            'required': this.errorMessages.default_required,
                            'min': 'Min value allowed is Re. 1.'
                        },
                    },
                    cdOptionRs2: {
                        validations: [Validators.required],
                        JF: true,
                        error: {
                            'required': this.errorMessages.default_required,
                            'min': 'Min value allowed is is Re. 1.'
                        },
                    },
                    commFutPaisa1: {
                        validations: [Validators.required],
                        JF: true,
                        error: {
                            'required': this.errorMessages.default_required,
                            'min': this.errorMessages.brokerage_min
                        },
                    },
                    commFutPer1: {
                        validations: [Validators.required],
                        JF: true,
                        error: {
                            'required': this.errorMessages.default_required,
                            'min': this.errorMessages.eqt_min
                        },
                    },
                    commFutPaisa2: {
                        validations: [Validators.required],
                        JF: true,
                        error: {
                            'required': this.errorMessages.default_required,
                            'min': this.errorMessages.brokerage_min
                        },
                    },
                    commFutPer2: {
                        validations: [Validators.required],
                        JF: true,
                        error: {
                            'required': this.errorMessages.default_required,
                            'min': this.errorMessages.eqt_min
                        },
                    },
                    commOptionRs1: {
                        validations: [Validators.required],
                        JF: true,
                        error: {
                            'required': this.errorMessages.default_required,
                            'min': 'Min value allowed is Re. 1.'
                        },
                    },
                    commOptionRs2: {
                        validations: [Validators.required],
                        JF: true,
                        error: {
                            'required': this.errorMessages.default_required,
                            'min': 'Min value allowed is is Re. 1.'
                        },
                    },
                    niftyFutPaisa1: {
                        validations: [],
                        JF: true,
                        error: {
                            'required': this.errorMessages.default_required,
                            'min': this.errorMessages.brokerage_min
                        },
                    },
                    niftyFutPer1: {
                        validations: [],
                        JF: true,
                        error: {
                            'required': this.errorMessages.default_required,
                            'min': this.errorMessages.eqt_min
                        },
                    },
                    niftyFutPaisa2: {
                        validations: [],
                        JF: true,
                        error: {
                            'required': this.errorMessages.default_required,
                            'min': this.errorMessages.brokerage_min
                        },
                    },
                    niftyFutPer2: {
                        validations: [],
                        JF: true,
                        error: {
                            'required': this.errorMessages.default_required,
                            'min': this.errorMessages.eqt_min
                        },
                    },
                    niftyOptionRs1: {
                        validations: [],
                        JF: true,
                        error: {
                            'required': this.errorMessages.default_required,
                            'min': 'Min value allowed is Re. 1.'
                        },
                    },
                    niftyOptionRs2: {
                        validations: [],
                        JF: true,
                        error: {
                            'required': this.errorMessages.default_required,
                            'min': 'Min value allowed is is Re. 1.'
                        },
                    },
                    bankNiftyFutPaisa1: {
                        validations: [],
                        JF: true,
                        error: {
                            'required': this.errorMessages.default_required,
                            'min': this.errorMessages.brokerage_min
                        },
                    },
                    bankNiftyFutPer1: {
                        validations: [],
                        JF: true,
                        error: {
                            'required': this.errorMessages.default_required,
                            'min': this.errorMessages.eqt_min
                        },
                    },
                    bankNiftyFutPaisa2: {
                        validations: [],
                        JF: true,
                        error: {
                            'required': this.errorMessages.default_required,
                            'min': this.errorMessages.brokerage_min
                        },
                    },
                    bankNiftyFutPer2: {
                        validations: [],
                        JF: true,
                        error: {
                            'required': this.errorMessages.default_required,
                            'min': this.errorMessages.eqt_min
                        },
                    },
                    bankNiftyOptionRs1: {
                        validations: [],
                        JF: true,
                        error: {
                            'required': this.errorMessages.default_required,
                            'min': 'Min value allowed is Re. 1.'
                        },
                    },
                    bankNiftyOptionRs2: {
                        validations: [],
                        JF: true,
                        error: {
                            'required': this.errorMessages.default_required,
                            'min': 'Min value allowed is is Re. 1.'
                        },
                    },
                    goldFutPaisa1: {
                        validations: [],
                        JF: true,
                        error: {
                            'required': this.errorMessages.default_required,
                            'min': this.errorMessages.brokerage_min
                        },
                    },
                    goldFutPer1: {
                        validations: [],
                        JF: true,
                        error: {
                            'required': this.errorMessages.default_required,
                            'min': this.errorMessages.eqt_min
                        },
                    },
                    goldFutPaisa2: {
                        validations: [],
                        JF: true,
                        error: {
                            'required': this.errorMessages.default_required,
                            'min': this.errorMessages.brokerage_min
                        },
                    },
                    goldFutPer2: {
                        validations: [],
                        JF: true,
                        error: {
                            'required': this.errorMessages.default_required,
                            'min': this.errorMessages.eqt_min
                        },
                    },
                    goldOptionRs1: {
                        validations: [],
                        JF: true,
                        error: {
                            'required': this.errorMessages.default_required,
                            'min': 'Min value allowed is Re. 1.'
                        },
                    },
                    goldOptionRs2: {
                        validations: [],
                        JF: true,
                        error: {
                            'required': this.errorMessages.default_required,
                            'min': 'Min value allowed is is Re. 1.'
                        },
                    },
                    remark: {
                        validations: [Validators.maxLength(255)],
                        JF: true
                    }
                },
                getForwardRoute: function (investor) {
                    investor = investor || _this.investor;
                    if (investor && investor.id) {
                        return _this.getForwardRoute(investor, _this.businessUnit);
                    }
                },
                getBackwardRoute: function () {
                }
            },
            'esign': {
                esignURL: '',
                successURL: '/succRes.jsp',
                failureURL: '/failRes.jsp',
                getForwardRoute: function (investor) {
                    investor = investor || _this.investor;
                    if (investor && investor.id) {
                        return _this.getForwardRoute(investor, _this.businessUnit);
                    }
                },
                getBackwardRoute: function () {
                }
            },
            'support': {
                inputs: {
                    name: {
                        validations: [Validators.required, Validators.pattern(nameRegex)],
                        error: {
                            required: this.errorMessages.defaultName_required,
                            pattern: this.errorMessages.name_invalid
                        },
                        JF: true,
                        MF: true
                    },
                    email: {
                        validations: [Validators.required, Validators.pattern(emailRegex)],
                        error: {
                            required: this.errorMessages.email_required,
                            pattern: this.errorMessages.email_invalid
                        },
                        JF: true,
                        MF: true
                    },
                    subject: {
                        JFValidators: [Validators.required],
                        MFValidators: [Validators.required],
                        error: {
                            required: this.errorMessages.defaultSubject_required
                        },
                        JF: true,
                        MF: false
                    },
                    message: {
                        validations: [Validators.required, Validators.maxLength(250), Validators.pattern(messageRegex)],
                        error: {
                            required: this.errorMessages.default_required,
                            pattern: this.errorMessages.defaultInvalid_msg
                        },
                        JF: true,
                        MF: true
                    }
                }
            },
            'client-login': {
                inputs: {
                    clientId: {
                        validations: [Validators.maxLength(20), Validators.pattern(userNameRegex)],
                        error: {
                            required: this.errorMessages.clientId_required,
                            pattern: this.errorMessages.clientId_pattern,
                            maxlength: this.errorMessages.clientID_maxlength,
                        },
                        JF: true,
                        MF: true
                    },
                    panNumber: {
                        validations: [Validators.minLength(10), Validators.maxLength(10), Validators.pattern(panNumberRegex)],
                        error: {
                            required: this.errorMessages.pan_required,
                            pattern: this.errorMessages.pan_pattern
                        },
                        MF: true,
                        JF: true
                    },
                    otp: {
                        validations: [Validators.required, Validators.pattern(unifiedotpRegex)],
                        error: {
                            required: this.errorMessages.otp_required,
                            pattern: this.errorMessages.unifiedotp_pattern
                        },
                        MF: true,
                        JF: true
                    },
                    signFile: {
                        validations: [],
                        error: {
                            'required': this.errorMessages.signFile_required,
                            'fileType': this.errorMessages.default_fileType2,
                            'fileSize': this.errorMessages.default_fileSize3
                        },
                        JF: true
                    }
                }
            },
            'client-modification': {
                inputs: {
                    segments: [
                        {
                            formControlName: 'CASH',
                            formControlLabel: 'CASH (NSE & BSE)',
                            id: '8a82b2b068bc46360168bc52702b0002',
                            segmentName: "NSECash",
                            segmentType: "Cash",
                            validations: [],
                            incomeProofRequired: false,
                            JF: true,
                            MFJF: true
                        },
                        {
                            formControlName: 'FO',
                            formControlLabel: 'EQUITY F&O (NSE & BSE)',
                            id: '8a82b2b068bc46360168bc52702b0002',
                            segmentName: "NSECash",
                            segmentType: "FNO",
                            validations: [],
                            incomeProofRequired: true,
                            JF: true,
                            MFJF: true
                        },
                        {
                            formControlName: 'CURRENCY',
                            formControlLabel: 'CURRENCY (NSE & BSE) ',
                            id: '8a82b2b068bc46360168bc5271d80003',
                            segmentName: "BSECash",
                            segmentType: "Currency",
                            incomeProofRequired: true,
                            validations: [],
                            JF: true,
                            MFJF: true
                        },
                        {
                            formControlName: 'COMMODITY',
                            formControlLabel: 'COMMODITY (MCX, NCDEX & NSE)',
                            id: '8a82b2b0689dbae201689dbb581e0001',
                            segmentName: "NSEFNO",
                            segmentType: "Commodity",
                            incomeProofRequired: true,
                            validations: [],
                            JF: true,
                            MFJF: true
                        },
                        // {
                        //   formControlName: 'DEBT',
                        //   formControlLabel: 'DEBT (NSE & BSE)',
                        //   id: '8a82b2b068bc46360168bc5272fe0006',
                        //   segmentName: "BSEFNO",
                        //   segmentType: "Debt",
                        //   incomeProofRequired: false,
                        //   validations: [],
                        //   JF: true,
                        //   MFJF: true,
                        // },
                        {
                            formControlName: 'MTF',
                            formControlLabel: 'MTF(Margin Trading Facility)',
                            id: 'ff8081816cdd312b016cdd34f0510000',
                            info: 'Using Margin Trading Facility (MTF) facility, an investor can buy shares using a small amount from his available funds/shares as collateral known as margin. The remaining balance required to complete the transaction is funded by the broker.',
                            segmentName: "MTF",
                            segmentType: "MTF",
                            incomeProofRequired: false,
                            validations: [],
                            JF: true,
                            MFJF: true
                        },
                        {
                            formControlName: 'SLBM',
                            formControlLabel: 'SLBM',
                            id: '9481b24273c8d3ad0173cca5cd240000',
                            info: 'SLBM or stock lending and borrowing is a mechanism in which a trader can borrow shares that they do not already own or can lend the stocks that they own. An SLBM transaction has a rate of interest and a fixed tenure.',
                            segmentName: "NSESLBM",
                            segmentType: "SLBM",
                            incomeProofRequired: false,
                            validations: [],
                            JF: true,
                            MFJF: true
                        },
                    ],
                    incomeProofType: {
                        validations: [],
                        error: {
                            'required': this.errorMessages.incProof_required,
                        },
                        JF: true,
                        MFJF: true
                    },
                    incomeProofFile: {
                        validations: [],
                        error: {
                            'required': this.errorMessages.incProofFile_required,
                            'fileType': this.errorMessages.default_fileType_incomeproof,
                            'fileSize': this.errorMessages.default_fileSize
                        },
                        JF: true,
                        MFJF: true
                    },
                    mobileNumber: {
                        validations: [Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern(mobileNumberRegex)],
                        error: {
                            required: this.errorMessages.mob_required,
                            pattern: this.errorMessages.mob_pattern
                        },
                        MF: true,
                        JF: true,
                    },
                    // Validators.required, Validators.minLength(2)
                    address: {
                        validations: [],
                        error: {
                            required: this.errorMessages.default_required,
                            pattern: this.errorMessages.address_invalid,
                            minLength: this.errorMessages.address_invalid
                        },
                        JF: false,
                        MF: true,
                        MFJF: true
                    },
                    address1: {
                        validations: [Validators.required, Validators.minLength(2)],
                        error: {
                            required: this.errorMessages.default_required,
                            pattern: this.errorMessages.address_invalid,
                            minLength: this.errorMessages.address_invalid
                        },
                        JF: true,
                        MF: false,
                        MFJF: false
                    },
                    // , Validators.minLength(2)
                    address2: {
                        validations: [Validators.required],
                        error: {
                            required: this.errorMessages.default_required,
                            pattern: this.errorMessages.address_invalid,
                            minLength: this.errorMessages.address_invalid
                        },
                        JF: true,
                        MF: false,
                        MFJF: false
                    },
                    city: {
                        validations: [Validators.required, Validators.minLength(2)],
                        error: {
                            required: this.errorMessages.default_required,
                            pattern: this.errorMessages.city_invalid
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    state: {
                        validations: [Validators.required],
                        error: {
                            required: this.errorMessages.default_required,
                            pattern: this.errorMessages.state_invalid
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    zipCode: {
                        validations: [Validators.required, Validators.pattern(pinCodeRegex)],
                        error: {
                            required: this.errorMessages.zipcode_required,
                            pattern: this.errorMessages.zipcode_invalid
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    isAddressSame: {
                        JFValidators: [],
                        MFJFValidators: [],
                        JF: true,
                        MF: false,
                        MFJF: true
                    },
                    //           Validators.minLength(2)
                    //           Validators.minLength(2)
                    addressC: {
                        JFValidators: [],
                        MFJFValidators: [],
                        MFValidators: [],
                        error: {
                            required: this.errorMessages.default_required,
                            pattern: this.errorMessages.address_invalid,
                            minLength: this.errorMessages.address_invalid
                        },
                        JF: false,
                        MFJF: true
                    },
                    addressC1: {
                        JFValidators: [Validators.minLength(2)],
                        MFJFValidators: [Validators.minLength(2)],
                        MFValidators: [],
                        error: {
                            required: this.errorMessages.default_required,
                            pattern: this.errorMessages.address_invalid,
                            minLength: this.errorMessages.address_invalid
                        },
                        JF: true,
                        MFJF: false
                    },
                    //           Validators.minLength(2)
                    //           Validators.minLength(2)
                    addressC2: {
                        JFValidators: [],
                        MFJFValidators: [],
                        MFValidators: [],
                        error: {
                            required: this.errorMessages.default_required,
                            pattern: this.errorMessages.address_invalid,
                            minLength: this.errorMessages.address_invalid
                        },
                        JF: true,
                        MFJF: false
                    },
                    cityC: {
                        JFValidators: [Validators.minLength(2)],
                        MFValidators: [],
                        MFJFValidators: [Validators.minLength(2)],
                        error: {
                            required: this.errorMessages.default_required,
                            pattern: this.errorMessages.address_invalid
                        },
                        JF: true,
                        MFJF: false
                    },
                    stateC: {
                        JFValidators: [Validators.minLength(2), Validators.pattern(cityRegex)],
                        MFJFValidators: [Validators.minLength(2), Validators.pattern(cityRegex)],
                        MFValidators: [],
                        error: {
                            required: this.errorMessages.default_required,
                            pattern: this.errorMessages.address_invalid
                        },
                        JF: true,
                        MFJF: true
                    },
                    zipCodeC: {
                        JFValidators: [Validators.pattern(pinCodeRegex)],
                        MFJFValidators: [Validators.pattern(pinCodeRegex)],
                        MFValidators: [],
                        error: {
                            required: this.errorMessages.zipcode_required,
                            pattern: this.errorMessages.zipcode_invalid
                        },
                        JF: true,
                        MFJF: true
                    },
                    addrProofType: {
                        JFValidators: [],
                        MFJFValidators: [],
                        MFValidators: [],
                        error: {
                            'required': this.errorMessages.incProof_required,
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    addrProofFrontFile: {
                        JFValidators: [],
                        MFJFValidators: [],
                        MFValidators: [],
                        error: {
                            'required': 'Please Click/Upload Valid Address Proof.',
                            'fileType': 'Please upload file having extensions jpeg, jpg, and png only.',
                            'fileSize': 'Maximum Allowed File size is 10MB.',
                            'fileSize2': 'Maximum Allowed File size is 2MB.',
                            'fileTypeadhaar': 'Please upload file having extensions jpeg, jpg and png only.'
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    selfiePhotoFileName: {
                        JFValidators: [],
                        MFJFValidators: [],
                        MFValidators: [],
                        error: {
                            'required': 'Need to add selfie.',
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    addrProofRearFile: {
                        validations: [],
                        error: {
                            'required': 'Please Click/Upload Valid Address Proof.',
                            'fileType': 'Please upload file having extensions jpeg, jpg, and png only.',
                            'fileSize': 'Maximum Allowed File size is 10MB.',
                            'fileSize2': 'Maximum Allowed File size is 2MB.',
                            'fileTypeadhaar': 'Please upload file having extensions jpeg, jpg and png only.'
                        },
                        JF: true,
                        MF: true,
                        MFJF: true,
                        hidden: true
                    },
                    ismaskingadhaar: {
                        JFValidators: [Validators.required],
                        MFJFValidators: [Validators.required],
                        MFValidators: [Validators.required],
                        JF: true,
                        MF: true,
                        MFJF: true,
                    },
                    addrCProofType: {
                        JFValidators: [],
                        MFJFValidators: [],
                        MFValidators: [],
                        error: {
                            'required': this.errorMessages.incProof_required,
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    addrCProofFrontFile: {
                        JFValidators: [],
                        MFJFValidators: [],
                        MFValidators: [],
                        error: {
                            'required': this.errorMessages.validAddProof_required,
                            'fileType': this.errorMessages.default_fileType,
                            'fileSize': this.errorMessages.default_fileSize
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    addrCProofRearFile: {
                        validations: [],
                        error: {
                            'required': this.errorMessages.validAddProof_required,
                            'fileType': this.errorMessages.default_fileType,
                            'fileSize': this.errorMessages.default_fileSize
                        },
                        JF: true,
                        MF: true,
                        MFJF: true,
                        hidden: true
                    },
                    email: {
                        validations: [Validators.required, Validators.pattern(emailRegex)],
                        error: {
                            required: this.errorMessages.email_required,
                            pattern: this.errorMessages.email_invalid
                        },
                        JF: true,
                        MF: true
                    },
                    mobOtp: {
                        validations: [Validators.maxLength(6), Validators.pattern(unifiedotpRegex)],
                        error: {
                            required: this.errorMessages.otp_required,
                            pattern: this.errorMessages.unifiedotp_pattern,
                            maxlength: this.errorMessages.clientID_maxlength,
                        },
                        MF: true,
                        JF: true
                    },
                    emailOtp: {
                        validations: [Validators.pattern(unifiedotpRegex)],
                        error: {
                            required: this.errorMessages.otp_required,
                            pattern: this.errorMessages.unifiedotp_pattern
                        },
                        MF: true,
                        JF: true
                    },
                }
            },
            'add-bank-details': {
                inputs: {
                    chequeFile: {
                        validations: [Validators.required],
                        error: {
                            'required': this.errorMessages.cheque_required,
                            'fileType': this.errorMessages.default_fileType,
                            'fileSize': this.errorMessages.default_fileSize
                        },
                        MF: true,
                        JF: true,
                        MFJF: true
                    },
                    accountNumber: {
                        validations: [Validators.required, Validators.pattern(accNoRegex)],
                        error: {
                            required: this.errorMessages.accNo_required,
                            pattern: this.errorMessages.accNo_pattern
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    repeatAccountNumber: {
                        validations: [Validators.required, Validators.pattern(accNoRegex)],
                        error: {
                            required: this.errorMessages.accNo_required,
                            pattern: this.errorMessages.accNo_pattern,
                            invalid: this.errorMessages.accNo_notmatch
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    ifsc: {
                        validations: [Validators.required, Validators.pattern(ifscRegex)],
                        error: {
                            required: this.errorMessages.ifsc_required,
                            pattern: this.errorMessages.ifsc_invalid
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    bankName: {
                        validations: [Validators.required],
                        error: {
                            required: this.errorMessages.bankname_required
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    branch: {
                        validations: [Validators.required],
                        error: {
                            required: this.errorMessages.bankbranchname_required
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    bankAddress: {
                        validations: [Validators.required],
                        error: {
                            required: this.errorMessages.branchAdd_required
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    micr: {
                        validations: [],
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    bankZipCode: {
                        JFValidators: [Validators.pattern(pinCodeRegex)],
                        MFJFValidators: [Validators.required, Validators.pattern(pinCodeRegex)],
                        MFValidators: [],
                        error: {
                            required: this.errorMessages.zipcode_required,
                            pattern: this.errorMessages.zipcode_invalid
                        },
                        JF: true,
                        MFJF: true
                    },
                    accountType: {
                        validations: [Validators.required],
                        error: {
                            required: this.errorMessages.accType_required
                        },
                        defaults: { JF: 'S', MF: 'S', MFJF: 'S' },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    addType: {
                        validations: [Validators.required],
                        error: {
                            required: this.errorMessages.purpose_required
                        },
                        defaults: { JF: '1' },
                        JF: true,
                    }
                },
                getForwardRoute: function (investor) {
                    investor = investor || _this.investor;
                    if (investor && investor.id) {
                        return _this.getForwardRoute(investor, _this.businessUnit);
                    }
                },
                getBackwardRoute: function () {
                }
            },
            'respond-client-login': {
                inputs: {
                    clientId: {
                        validations: [Validators.maxLength(20), Validators.pattern(userNameRegex)],
                        error: {
                            required: this.errorMessages.clientId_required,
                            pattern: this.errorMessages.clientId_pattern,
                            maxlength: this.errorMessages.clientID_maxlength,
                        },
                        JF: true,
                        MF: true
                    },
                    panNumber: {
                        validations: [Validators.minLength(10), Validators.maxLength(10), Validators.pattern(panNumberRegex)],
                        error: {
                            required: this.errorMessages.pan_required,
                            pattern: this.errorMessages.pan_pattern
                        },
                        MF: true,
                        JF: true
                    },
                    otp: {
                        validations: [Validators.required, Validators.pattern(unifiedotpRegex)],
                        error: {
                            required: this.errorMessages.otp_required,
                            pattern: this.errorMessages.unifiedotp_pattern
                        },
                        MF: true,
                        JF: true
                    }
                }
            },
            'respond-issue': {
                inputs: {
                    panCardFile: {
                        JFValidators: [],
                        MFJFValidators: [],
                        MFValidators: [],
                        error: {
                            'required': this.errorMessages.panFile_required,
                            'fileType': this.errorMessages.default_fileType,
                            'fileSize': this.errorMessages.default_fileSize
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    photoFile: {
                        JFValidators: [],
                        MFJFValidators: [],
                        MFValidators: [],
                        error: {
                            'required': this.errorMessages.photoFile_required,
                            'fileType': this.errorMessages.default_fileType2,
                            'fileSize': this.errorMessages.default_fileSize
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    signFile: {
                        validations: [],
                        error: {
                            'required': this.errorMessages.signFile_required,
                            'fileType': this.errorMessages.default_fileType2,
                            'fileSize': this.errorMessages.default_fileSize3
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    addrProofType: {
                        JFValidators: [],
                        MFJFValidators: [],
                        MFValidators: [],
                        error: {
                            'required': this.errorMessages.incProof_required,
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    addrProofFrontFile: {
                        JFValidators: [],
                        MFJFValidators: [],
                        MFValidators: [],
                        error: {
                            'required': 'Please Click/Upload Valid Address Proof.',
                            'fileType': 'Please upload file having extensions jpeg, jpg, and png only.',
                            'fileSize': 'Maximum Allowed File size is 10MB.',
                            'fileSize2': 'Maximum Allowed File size is 2MB.',
                            'fileTypeadhaar': 'Please upload file having extensions jpeg, jpg and png only.'
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    addrProofRearFile: {
                        validations: [],
                        error: {
                            'required': 'Please Click/Upload Valid Address Proof.',
                            'fileType': 'Please upload file having extensions jpeg, jpg, and png only.',
                            'fileSize': 'Maximum Allowed File size is 10MB.',
                            'fileSize2': 'Maximum Allowed File size is 2MB.',
                            'fileTypeadhaar': 'Please upload file having extensions jpeg, jpg and png only.',
                        },
                        JF: true,
                        MF: true,
                        MFJF: true,
                        hidden: true
                    },
                    ismaskingadhaar: {
                        JFValidators: [Validators.required],
                        MFJFValidators: [Validators.required],
                        MFValidators: [Validators.required],
                        JF: true,
                        MF: true,
                        MFJF: true,
                    },
                    overseasAddressFrontFile: {
                        JFValidators: [],
                        MFJFValidators: [],
                        MFValidators: [],
                        error: {
                            'required': 'Please Click/Upload Valid Overseas Address Proof.',
                            'fileType': 'Please upload file having extensions jpeg, jpg, png only.',
                            'fileSize': 'Maximum Allowed File size is 10MB.'
                        },
                        JF: false,
                        MF: true,
                        MFJF: false
                    },
                    overseasAddressRearFile: {
                        JFValidators: [],
                        MFJFValidators: [],
                        MFValidators: [],
                        error: {
                            'required': this.errorMessages.overseasAddProof_required,
                            'fileType': this.errorMessages.default_fileType,
                            'fileSize': this.errorMessages.default_fileSize
                        },
                        JF: false,
                        MF: true,
                        MFJF: false
                    },
                    passportFrontFile: {
                        JFValidators: [],
                        MFJFValidators: [],
                        MFValidators: [],
                        error: {
                            'required': this.errorMessages.passportFile_required,
                            'fileType': this.errorMessages.default_fileType,
                            'fileSize': this.errorMessages.default_fileSize
                        },
                        JF: false,
                        MF: true,
                        MFJF: false
                    },
                    passportRearFile: {
                        JFValidators: [],
                        MFJFValidators: [],
                        MFValidators: [],
                        error: {
                            'required': this.errorMessages.passportFile_required,
                            'fileType': this.errorMessages.default_fileType,
                            'fileSize': this.errorMessages.default_fileSize
                        },
                        JF: false,
                        MF: true,
                        MFJF: false
                    },
                    visaFile: {
                        JFValidators: [],
                        MFJFValidators: [],
                        MFValidators: [],
                        error: {
                            'required': 'Please Upload VISA.',
                            'fileType': this.errorMessages.default_fileType,
                            'fileSize': this.errorMessages.default_fileSize
                        },
                        JF: false,
                        MF: true,
                        MFJF: false
                    },
                    incomeProofType: {
                        JFValidators: [],
                        MFJFValidators: [],
                        MFValidators: [],
                        error: {
                            'required': this.errorMessages.incProof_required,
                        },
                        JF: true,
                        MF: false,
                        MFJF: true
                    },
                    incomeProofFile: {
                        validations: [],
                        error: {
                            'required': this.errorMessages.incProofFile_required,
                            'fileType': this.errorMessages.default_fileType_incomeproof,
                            'fileSize': this.errorMessages.default_fileSize
                        },
                        JF: true,
                        MF: false,
                        MFJF: true
                    },
                    ipvFile: {
                        validations: [],
                        error: {
                            'required': this.errorMessages.ipvFile_required,
                            'fileType': this.errorMessages.default_fileType2,
                            'fileSize': this.errorMessages.default_fileSize
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    chequeFile: {
                        validations: [],
                        error: {
                            'required': this.errorMessages.cheque_required,
                            'fileType': this.errorMessages.default_fileType,
                            'fileSize': this.errorMessages.default_fileSize
                        },
                        MF: true,
                        JF: true,
                        MFJF: true
                    },
                    accountNumber: {
                        validations: [Validators.pattern(accNoRegex)],
                        error: {
                            required: this.errorMessages.accNo_required,
                            pattern: this.errorMessages.accNo_pattern
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    repeatAccountNumber: {
                        validations: [Validators.pattern(accNoRegex)],
                        error: {
                            required: this.errorMessages.accNo_required,
                            pattern: this.errorMessages.accNo_pattern,
                            invalid: this.errorMessages.accNo_notmatch
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    ifsc: {
                        validations: [Validators.pattern(ifscRegex)],
                        error: {
                            required: this.errorMessages.ifsc_required,
                            pattern: this.errorMessages.ifsc_invalid
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    bankName: {
                        validations: [],
                        error: {
                            required: this.errorMessages.bankname_required
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    branch: {
                        validations: [],
                        error: {
                            required: this.errorMessages.bankbranchname_required
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    bankAddress: {
                        validations: [],
                        error: {
                            required: this.errorMessages.branchAdd_required
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    micr: {
                        validations: [],
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    bankZipCode: {
                        JFValidators: [Validators.pattern(pinCodeRegex)],
                        MFJFValidators: [Validators.required, Validators.pattern(pinCodeRegex)],
                        MFValidators: [],
                        error: {
                            required: this.errorMessages.zipcode_required,
                            pattern: this.errorMessages.zipcode_invalid
                        },
                        JF: true,
                        MFJF: true
                    },
                    accountType: {
                        validations: [],
                        error: {
                            required: this.errorMessages.accType_required
                        },
                        defaults: { JF: 'S', MF: 'S', MFJF: 'S' },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    address: {
                        // , Validators.pattern(addressRegex)
                        validations: [Validators.required, Validators.minLength(2)],
                        error: {
                            required: this.errorMessages.default_required,
                            pattern: this.errorMessages.address_invalid
                        },
                        JF: false,
                        MF: true,
                        MFJF: true
                    },
                    address1: {
                        validations: [Validators.required, Validators.minLength(2)],
                        error: {
                            required: this.errorMessages.default_required,
                            pattern: this.errorMessages.address_invalid
                        },
                        JF: true,
                        MF: false,
                        MFJF: false
                    },
                    address2: {
                        validations: [Validators.required, Validators.minLength(2)],
                        error: {
                            required: this.errorMessages.default_required,
                            pattern: this.errorMessages.address_invalid
                        },
                        JF: true,
                        MF: false,
                        MFJF: false
                    },
                    city: {
                        validations: [Validators.required, Validators.minLength(2), Validators.pattern(cityRegex)],
                        error: {
                            required: this.errorMessages.default_required,
                            pattern: this.errorMessages.city_invalid
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    state: {
                        validations: [Validators.required],
                        error: {
                            required: this.errorMessages.default_required,
                            pattern: this.errorMessages.state_invalid
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    zipCode: {
                        validations: [Validators.required, Validators.pattern(pinCodeRegex)],
                        error: {
                            required: this.errorMessages.zipcode_required,
                            pattern: this.errorMessages.zipcode_invalid
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    isAddressSame: {
                        JFValidators: [Validators.required],
                        MFJFValidators: [Validators.required],
                        JF: true,
                        MF: false,
                        MFJF: true
                    },
                    addressC: {
                        JFValidators: [Validators.minLength(2)],
                        MFJFValidators: [Validators.minLength(2)],
                        MFValidators: [],
                        error: {
                            required: this.errorMessages.default_required,
                            pattern: this.errorMessages.address_invalid
                        },
                        JF: false,
                        MFJF: true
                    },
                    addressC1: {
                        JFValidators: [Validators.minLength(2)],
                        MFJFValidators: [Validators.minLength(2)],
                        MFValidators: [],
                        error: {
                            required: this.errorMessages.default_required,
                            pattern: this.errorMessages.address_invalid
                        },
                        JF: true,
                        MFJF: false
                    },
                    addressC2: {
                        JFValidators: [Validators.minLength(2)],
                        MFJFValidators: [Validators.minLength(2)],
                        MFValidators: [],
                        error: {
                            required: this.errorMessages.default_required,
                            pattern: this.errorMessages.address_invalid
                        },
                        JF: true,
                        MFJF: false
                    },
                    cityC: {
                        JFValidators: [Validators.minLength(2), Validators.pattern(cityRegex)],
                        MFValidators: [],
                        MFJFValidators: [Validators.minLength(2), Validators.pattern(cityRegex)],
                        error: {
                            required: this.errorMessages.default_required,
                            pattern: this.errorMessages.address_invalid
                        },
                        JF: true,
                        MFJF: true
                    },
                    stateC: {
                        JFValidators: [Validators.minLength(2), Validators.pattern(cityRegex)],
                        MFJFValidators: [Validators.minLength(2), Validators.pattern(cityRegex)],
                        MFValidators: [],
                        error: {
                            required: this.errorMessages.default_required,
                            pattern: this.errorMessages.address_invalid
                        },
                        JF: true,
                        MFJF: true
                    },
                    zipCodeC: {
                        JFValidators: [Validators.pattern(pinCodeRegex)],
                        MFJFValidators: [Validators.pattern(pinCodeRegex)],
                        MFValidators: [],
                        error: {
                            required: this.errorMessages.zipcode_required,
                            pattern: this.errorMessages.zipcode_invalid
                        },
                        JF: true,
                        MFJF: true
                    }
                }
            },
            'bank-bazaar-doc-upload': {
                inputs: {
                    signFile: {
                        validations: [],
                        error: {
                            'required': this.errorMessages.signUpload2,
                            'fileType': this.errorMessages.default_fileType2,
                            'fileSize': this.errorMessages.default_fileSize3
                        },
                        JF: false,
                        MF: true,
                        MFJF: false
                    },
                    chequeFile: {
                        validations: [],
                        error: {
                            'required': this.errorMessages.chequeUpload2,
                            'fileType': this.errorMessages.default_fileType,
                            'fileSize': this.errorMessages.default_fileSize
                        },
                        MF: true,
                        JF: false,
                        MFJF: false
                    },
                }
            },
            'add-nominee-details': {
                inputs: {
                    name: {
                        validations: [Validators.required, Validators.minLength(2), Validators.pattern(nameRegex)],
                        error: {
                            required: this.errorMessages.nominee_required,
                            pattern: this.errorMessages.name_invalid,
                            sameName: this.errorMessages.nominee_same,
                            duplicte_nomineeName: this.errorMessages.duplicte_nomineeName
                        },
                        MF: true,
                        JF: true,
                        MFJF: true
                    },
                    mobileNum: {
                        validations: [Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern(mobileNumberRegex)],
                        error: {
                            required: this.errorMessages.mob_required,
                            pattern: this.errorMessages.mob_pattern
                        },
                        MF: true,
                        JF: true,
                        MFJF: true,
                    },
                    email: {
                        validations: [Validators.required, Validators.pattern(emailRegex)],
                        error: {
                            required: this.errorMessages.email_required,
                            pattern: this.errorMessages.email_invalid
                        },
                        JF: true,
                        MFJF: true
                    },
                    dob: {
                        validations: [Validators.required],
                        error: {
                            required: this.errorMessages.dob_required,
                            range: this.errorMessages.dob_range,
                            pattern: this.errorMessages.invalidFormat
                        },
                        MF: true,
                        JF: true,
                        MFJF: true
                    },
                    isMinor: {
                        validations: [],
                        error: {
                            required: this.errorMessages.dob_required
                        },
                        MF: true,
                        JF: true,
                        MFJF: true
                    },
                    isAddrSameAsApplicant: {
                        validations: [Validators.required],
                        error: {
                            required: this.errorMessages.default_required
                        },
                        MF: true,
                        JF: true,
                        MFJF: true
                    },
                    address: {
                        validations: [],
                        error: {
                            required: this.errorMessages.default_required,
                            pattern: this.errorMessages.address_invalid
                        },
                        JF: false,
                        MF: false,
                        MFJF: false
                    },
                    address1: {
                        validations: [Validators.required, Validators.minLength(2)],
                        error: {
                            required: this.errorMessages.default_required,
                            pattern: this.errorMessages.address_invalid
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    address2: {
                        validations: [Validators.required, Validators.minLength(2)],
                        error: {
                            required: this.errorMessages.default_required,
                            pattern: this.errorMessages.address_invalid
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    city: {
                        validations: [Validators.required, Validators.minLength(2), Validators.pattern(cityRegex)],
                        error: {
                            required: this.errorMessages.default_required,
                            pattern: this.errorMessages.city_invalid
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    state: {
                        validations: [Validators.required],
                        error: {
                            required: this.errorMessages.default_required,
                            pattern: this.errorMessages.state_invalid
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    zipCode: {
                        validations: [Validators.required, Validators.pattern(pinCodeRegex)],
                        error: {
                            required: this.errorMessages.zipcode_required,
                            pattern: this.errorMessages.zipcode_invalid
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    relation: {
                        validations: [Validators.required],
                        error: {
                            required: this.errorMessages.nomineeRelation_required
                        },
                        MF: true,
                        JF: true,
                        MFJF: true
                    },
                    shares: {
                        validations: [Validators.required, Validators.pattern(sharePercentRegex)],
                        error: {
                            required: this.errorMessages.sharePrcnt_required,
                            pattern: this.errorMessages.sharePrcnt_invalid
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    proofType: {
                        validations: [Validators.required],
                        error: {
                            'required': this.errorMessages.doctype_required
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    documentId: {
                        JFValidators: [Validators.required],
                        MFValidators: [Validators.required],
                        MFJFValidators: [Validators.required],
                        error: {
                            'required': this.errorMessages.docID_required,
                            'pattern': this.errorMessages.docID_invalid,
                            'duplicte_docId': this.errorMessages.duplicte_docId
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    proofFileName1: {
                        validations: [Validators.required],
                        error: {
                            'required': this.errorMessages.defaultUpload_valid,
                            'fileType': this.errorMessages.default_fileType,
                            'fileSize': this.errorMessages.default_fileSize
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    proofFileName2: {
                        validations: [],
                        error: {
                            // 'required': this.errorMessages.defaultUpload_valid,
                            'fileType': this.errorMessages.default_fileType,
                            'fileSize': this.errorMessages.default_fileSize
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    guardianName: {
                        validations: [Validators.minLength(2), Validators.pattern(nameRegex)],
                        error: {
                            required: this.errorMessages.guardianname_required,
                            pattern: this.errorMessages.guardianname_invalid
                        },
                        MF: true,
                        JF: true,
                        MFJF: true
                    },
                    gdMobileNum: {
                        validations: [Validators.minLength(10), Validators.maxLength(10), Validators.pattern(mobileNumberRegex)],
                        error: {
                            required: this.errorMessages.mob_required,
                            pattern: this.errorMessages.mob_pattern
                        },
                        MF: true,
                        JF: true,
                        MFJF: true,
                    },
                    gdEmail: {
                        validations: [Validators.pattern(emailRegex)],
                        error: {
                            required: this.errorMessages.email_required,
                            pattern: this.errorMessages.email_invalid
                        },
                        JF: true,
                        MFJF: true
                    },
                    gdisAddrSameAsApplicant: {
                        validations: [Validators.required],
                        error: {
                            required: this.errorMessages.default_required
                        },
                        MF: true,
                        JF: true,
                        MFJF: true
                    },
                    gdAddress: {
                        validations: [],
                        error: {
                            required: this.errorMessages.default_required,
                            pattern: this.errorMessages.guardianAdd_invalid
                        },
                        JF: true,
                        MFJF: true
                    },
                    gdAddress1: {
                        validations: [Validators.required, Validators.minLength(2)],
                        error: {
                            required: this.errorMessages.default_required,
                            pattern: this.errorMessages.address_invalid
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    gdAddress2: {
                        validations: [Validators.required, Validators.minLength(2)],
                        error: {
                            required: this.errorMessages.default_required,
                            pattern: this.errorMessages.address_invalid
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    gdCity: {
                        validations: [Validators.required, Validators.minLength(2), Validators.pattern(cityRegex)],
                        error: {
                            required: this.errorMessages.default_required,
                            pattern: this.errorMessages.city_invalid
                        },
                        JF: true,
                        MFJF: true
                    },
                    gdState: {
                        validations: [Validators.required, Validators.minLength(2), Validators.pattern(cityRegex)],
                        error: {
                            required: this.errorMessages.default_required,
                            pattern: this.errorMessages.address_invalid
                        },
                        JF: true,
                        MFJF: true
                    },
                    gdZipCode: {
                        validations: [Validators.required, Validators.pattern(pinCodeRegex)],
                        error: {
                            required: this.errorMessages.zipcode_required,
                            pattern: this.errorMessages.zipcode_invalid
                        },
                        JF: true,
                        MFJF: true
                    },
                    gdRelation: {
                        validations: [Validators.required],
                        error: {
                            'required': this.errorMessages.doctype_required
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    gdProofType: {
                        // validations: [Validators.required],
                        error: {
                            'required': this.errorMessages.doctype_required
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    gdDocumentId: {
                        // validations: [Validators.required],
                        JFValidators: [],
                        MFValidators: [],
                        MFJFValidators: [],
                        error: {
                            // 'required': this.errorMessages.docID_required,
                            'pattern': this.errorMessages.docID_invalid
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    gdproofFileName1: {
                        // validations: [Validators.required],
                        error: {
                            // 'required': this.errorMessages.defaultUpload_valid,
                            'fileType': this.errorMessages.default_fileType,
                            'fileSize': this.errorMessages.default_fileSize
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                    gdproofFileName2: {
                        validations: [],
                        error: {
                            // 'required': this.errorMessages.defaultUpload_valid,
                            'fileType': this.errorMessages.default_fileType,
                            'fileSize': this.errorMessages.default_fileSize
                        },
                        JF: true,
                        MF: true,
                        MFJF: true
                    },
                },
                getForwardRoute: function (investor) {
                    investor = investor || _this.investor;
                    if (investor && investor.id) {
                        return _this.getForwardRoute(investor, _this.businessUnit);
                    }
                },
                getBackwardRoute: function () {
                }
            },
            'review': {
                inputs: {
                    isDDPIOpted: {
                        validations: [Validators.required],
                        error: {
                            required: 'Authorization is required',
                        },
                        JF: true
                    }
                },
            }
        };
    };
    /**
     * Getting Routing information
     * @param route route path assign
     * @param key key as param assign
     * @returns Complete routing url assign
     */
    UtilsService.prototype.getRouteInfo = function (route, key) {
        // console.log('called')
        this.businessUnit = this.getBusinessUnit();
        return key ? this.utils[route][key] : this.utils[route];
    };
    /**
     * identify bussinee unit
     * @returns Bussinessunit
     */
    UtilsService.prototype.getBusinessUnit = function () {
        /**href to pathname changes for businessunit in header issues. */
        var href = location.pathname.toLowerCase();
        return href.indexOf('/mf/') > -1 || href.indexOf('/connect-mf/') > -1 ? 'MF' :
            href.indexOf('/trading/') > -1 || href.indexOf('/connect-trading/') > -1 ? 'JF' :
                href.indexOf('/mf-trading/') > -1 || href.indexOf('/connect-mf-trading/') > -1 ? 'MFJF' : 'MFJF';
    };
    /**
     * store business unit
     */
    UtilsService.prototype.setBusinessUnit = function () {
        this.businessUnit = this.getBusinessUnit();
    };
    /** fetch original source platform */
    UtilsService.prototype.getOriginalSource = function () {
        var investorAccount = ((this.investor.investorAccountDetailsDtoList || [])[0] || new InvestorAccount());
        var isAlphabee = (investorAccount.lmsLeadSource) ? investorAccount.lmsLeadSource.toLowerCase().indexOf('alphabee') > -1 : (investorAccount.originalSource) ? investorAccount.originalSource.toLowerCase().indexOf('alphabee') > -1 : ((this.getLMSData(this.businessUnit) || {}).leadSource || '').toLowerCase().indexOf('alphabee') > -1;
        var href = location.href.toLowerCase();
        return href.indexOf('/mf/') > -1 ? 'INVESTICA' : (href.indexOf('trading/offline-onboard') > -1 ? 'NEURON_JIFFY_OFFLINE' : (href.indexOf('/trading/') > -1 || href.indexOf('/mf-trading/') > -1 ? isAlphabee ? 'ALPHABEE' : 'JIFFY' :
            href.indexOf('/connect-') > -1 || href.indexOf('/connect-') > -1 ? 'CHOICE CONNECT' : 'INVESTICA'));
    };
    /** Get Investor DOB Range  */
    UtilsService.prototype.getInvestorDOBRange = function () {
        var date = new Date();
        date.setFullYear(date.getFullYear() - 18);
        return { min: '1899-12-31', max: date.toJSON().split('T')[0] };
    };
    /** Get Nominee DOB Range */
    UtilsService.prototype.getNomineeDOBRange = function () {
        var date = new Date();
        date.setFullYear(date.getFullYear() - 18);
        return { min: date.toJSON().split('T')[0], max: new Date().toJSON().split('T')[0] };
    };
    /**
     * normalize Date
     * @param date passing date
     * @returns Get normalize date
     */
    UtilsService.prototype.normalizeDate = function (date) {
        return (date || "").indexOf('T') > -1 ? date.split('T')[0] : (date || "").indexOf(' ') > -1 ? date.split(' ')[0] : date;
    };
    /**
     * identify mobile device
     * @returns boolean mobile device or not
     */
    UtilsService.prototype.isMobileDevice = function () {
        return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent));
    };
    /**
     * Everytime this function will call while redirecting any component
     * all condition check here for routing basis
     * @param investor passing investor detail object data
     * @param businessUnit passing bussiness unit MF/JF
     * @param isSkippable is nominee skip or not
     * @returns routing url will pass
     */
    UtilsService.prototype.getForwardRoute = function (investor, businessUnit, isSkippable) {
        console.log('inside ROUTE');
        var aaStatus = sessionStorage.getItem('Account_aggregator_status');
        var routeInfo;
        var screen;
        var otpConfig = this.getOtpConfig();
        var mobileIPV = this.getIPVOnMobileCheck();
        var isManualVerification = this.getDigiLockerConfig();
        var isDigioIPVSubmitted = this.getDigioIPVConfig();
        var isDigioSelfieSubmitted = this.getDigioSelfieConfig();
        var checkIPVFilesForRouting = (this.investor.isKYC !== 'Y' && this.investor.investorDetailsDtoList && this.investor.investorDetailsDtoList.length && !this.investor.investorDetailsDtoList[0].kycVerifiedBy);
        var isDirectMFPorting = sessionStorage.getItem('isDirectMFPorting');
        var investorDetails = ((investor || new Investor()).investorDetailsDtoList || [])[0] || new InvestorDetails();
        if (businessUnit == 'MF') {
            routeInfo = '/onboard/' + location.pathname.split('/')[2] + '/';
            var investorAccount = ((investor.investorAccountDetailsDtoList || [])[0] || new InvestorAccount());
            // if (investor && !investorAccount.clientID || investorAccount.isMobileVerified != 'Y') {
            //   screen = 'registration';
            // }
            if (investor && (!investor.id || !investor.pannum || !investorDetails.emailID || !investor.investorAccountDetailsDtoList || !investorDetails.occupation || (investorAccount.isMobileVerified != 'Y' || investorAccount.isEmailVerified != 'Y' || !investorDetails.education || !investorDetails.annualIncome || !investorDetails.politicalRelation))) {
                if (mobileIPV && this.isMobile)
                    screen = 'ipv-details';
                else
                    screen = 'open-account';
            }
            else if (investor && investor.investorDetailsDtoList && investor.investorDetailsDtoList.length) {
                var ipvDetails = (investor.documentsIPVDtoList || [])[0] || {};
                var invDetails = investor.investorDetailsDtoList[0];
                var bankDetails = investor.investorBankDetailsDtoList;
                var isPorted = investor.isPorting;
                var documentDetails = (this.investor.documentsDtoList || [])[0] || new DocumentDetails();
                var invAddresses = investor.addressDtoList;
                var isNRI = investorAccount.isNRI == 'Y';
                var ipvDocumentDto = (investor.documentsIPVDtoList || [])[0] || {};
                var nomineeDetails = (investor.nomineeDetailsDtoList || [])[0];
                var date = ipvDocumentDto.lastModifiedDate ? new Date(ipvDocumentDto.lastModifiedDate.split('T')[0]) : '';
                if (date && date instanceof Date) {
                    date.setDate(date.getDate() + 30);
                }
                // date && 
                var isIPVRequired = mobileIPV ? (this.isMobile && mobileIPV) : ((this.investor.isKYC === 'Y') || (this.investor.isKYC !== 'Y' && this.investor.investorDetailsDtoList && this.investor.investorDetailsDtoList.length && this.investor.investorDetailsDtoList[0].kycVerifiedBy) ? false : ((!ipvDocumentDto.ipvVideoFileName && !ipvDocumentDto.ipvImageFileName) || !ipvDocumentDto.createdDate || moment(new Date()).format('YYYY-MM-DD') > moment(date).format('YYYY-MM-DD')));
                if (this.isMobile && mobileIPV && (investor.investorAccountDetailsDtoList[0].isDirectPorting != 'Y' || investor.isPorting != 'Y')) {
                    screen = 'ipv-details';
                }
                else if (investor.isKYC != 'Y' && (!invDetails.fatherName || !invDetails.investorName) && !(isManualVerification.isManual || invDetails.kycVerifiedBy || isManualVerification.isDigilocker) && (investor.investorAccountDetailsDtoList[0].isDirectPorting != 'Y' || investor.isPorting != 'Y')) {
                    screen = 'digi-locker';
                }
                else if (investor.isKYC != 'Y' && (!invDetails.fatherName || !invDetails.investorName) && (isManualVerification.isManual || invDetails.kycVerifiedBy || isManualVerification.isDigilocker)) {
                    screen = 'basic-details';
                }
                else if (investor.isKYC != 'Y' && (!invAddresses || !invAddresses.length) && !invDetails.kycVerifiedBy) {
                    screen = 'address-details';
                }
                else if (!invDetails.occupation) {
                    screen = 'income-details';
                    // || (!bankDetails[0].cancelChequeFileName && bankDetails[0].isPennydropVerified != 'Y')
                }
                else if (investor.isPorting !== 'Y' && (!bankDetails || !bankDetails.length || (!bankDetails[0].cancelChequeFileName && bankDetails[0].isPennydropVerified != 'Y'))) {
                    screen = 'bank-details';
                    // && investor.isKYC != 'Y' && !invDetails.kycVerifiedBy
                }
                else if (investor.isPorting === 'Y' && (!bankDetails || !bankDetails.length)) {
                    screen = 'bank-details';
                }
                // else if (isDirectMFPorting == 'true' && !bankDetails[0].cancelChequeFileName) {
                //   screen = 'bank-details';
                // }
                else if (bankDetails && bankDetails.length && bankDetails[0].accountNumber && isIPVRequired && !isDigioIPVSubmitted.isSubmitted && (investor.investorAccountDetailsDtoList[0].isDirectPorting != 'Y' || investor.isPorting != 'Y')) {
                    screen = 'ipv-details';
                }
                else if (investor.isKYC != 'Y' && (checkIPVFilesForRouting ? (ipvDetails.ipvVideoFileName || ipvDetails.ipvImageFileName || isDigioIPVSubmitted.isSubmitted) : (bankDetails && bankDetails.length && bankDetails[0].accountNumber)) && (!documentDetails.panCardFileName) && (investor.investorAccountDetailsDtoList[0].isDirectPorting != 'Y' || investor.isPorting != 'Y')) {
                    screen = 'document-uploads/panCardFile';
                }
                else if (investor.isKYC != 'Y' && (checkIPVFilesForRouting ? (ipvDetails.ipvVideoFileName || ipvDetails.ipvImageFileName || isDigioIPVSubmitted.isSubmitted) : true) && (!documentDetails.addrProofFrontFileName) && (investor.investorAccountDetailsDtoList[0].isDirectPorting != 'Y' || investor.isPorting != 'Y')) {
                    screen = 'document-uploads/addrProofFrontFile';
                }
                else if (investor.isKYC != 'Y' && (checkIPVFilesForRouting ? (ipvDetails.ipvVideoFileName || ipvDetails.ipvImageFileName || isDigioIPVSubmitted.isSubmitted) : true) && (!documentDetails.photoFileName && !isDigioSelfieSubmitted.isSubmitted) && (investor.investorAccountDetailsDtoList[0].isDirectPorting != 'Y' || investor.isPorting != 'Y')) {
                    screen = 'document-uploads/photoFile';
                }
                else if (investor.isKYC === 'Y' && (bankDetails && bankDetails.length && bankDetails[0].accountNumber) && (!documentDetails.photoFileName && !isDigioSelfieSubmitted.isSubmitted) && (investor.investorAccountDetailsDtoList[0].isDirectPorting != 'Y' || investor.isPorting != 'Y')) {
                    screen = 'document-uploads/photoFile';
                }
                // else if (!documentDetails.signFileName && (investor.isKYC == 'Y')) {
                //   screen = 'document-uploads/signFile';
                // } else if (investor.isKYC != 'Y' && (checkIPVFilesForRouting ? (ipvDetails.ipvVideoFileName || ipvDetails.ipvImageFileName || isDigioIPVSubmitted.isSubmitted || invDetails.kycVerifiedBy) : true) && (!documentDetails.signFileName)) {
                //   screen = 'document-uploads/signFile';
                // } 
                else if ((!documentDetails.signFileName)) {
                    screen = 'document-uploads/signFile';
                }
                else if (isNRI && !(documentDetails.overseasAddressFrontFileName) && (investor.investorAccountDetailsDtoList[0].isDirectPorting != 'Y' || investor.isPorting != 'Y')) {
                    screen = 'document-uploads/overseasAddressFrontFile';
                }
                else if (isNRI && !(documentDetails.passportFrontFileName) && (investor.investorAccountDetailsDtoList[0].isDirectPorting != 'Y' || investor.isPorting != 'Y')) {
                    screen = 'document-uploads/passportFrontFile';
                }
                else if (isNRI && !(documentDetails.visaFileName) && (investor.investorAccountDetailsDtoList[0].isDirectPorting != 'Y' || investor.isPorting != 'Y')) {
                    screen = 'document-uploads/visaFile';
                }
                else if (!nomineeDetails && documentDetails.signFileName && investor.isNomineeSkipped != 'Y') {
                    screen = 'nominee-details';
                }
                else if (investor.investorAccountDetailsDtoList[0].isOnBoardFlag && investor.investorAccountDetailsDtoList[0].isOnBoardFlag === 'N' && (investor.investorAccountDetailsDtoList[0].isDirectPorting != 'Y' || investor.isPorting != 'Y') && (investor.isKYC === 'Y' ? investor.investorAccountDetailsDtoList[0].isKraMismatched : true)) {
                    screen = 'esign';
                }
                // else if (((investor.isKYC == 'Y' && documentDetails.signFileName) ||
                //   (investor.isKYC == 'N' && documentDetails.signFileName && documentDetails.panCardFileName && documentDetails.addrProofFrontFileName) ||
                //   (isNRI && documentDetails.overseasAddressFrontFileName && documentDetails.passportFrontFileName && documentDetails.visaFileName)) && (investorAccount.isOnBoardFlag == 'N')) {
                //   screen = 'document-uploads/finalSub';
                // }
                /* else if (((investor.isKYC == 'Y' && documentDetails.signFileName) ||
              (investor.isKYC == 'N' && documentDetails.signFileName && documentDetails.panCardFileName && documentDetails.addrProofFrontFileName) ||
              (isNRI && documentDetails.overseasAddressFrontFileName && documentDetails.passportFrontFileName && documentDetails.visaFileName)) && (investorAccount.isOnBoardFlag == 'N')) {
              screen = 'document-uploads/signFile';
            } */ else if (((investor.isKYC == 'Y' && documentDetails.signFileName) ||
                    (investor.isKYC == 'N' && documentDetails.signFileName && documentDetails.panCardFileName && documentDetails.addrProofFrontFileName) ||
                    (isNRI && documentDetails.overseasAddressFrontFileName && documentDetails.passportFrontFileName && documentDetails.visaFileName)) && (investorAccount.isOnBoardFlag == 'Y' || investorAccount.isOnBoardFlag == 'C')) {
                    screen = 'congrats';
                }
                else if (isDirectMFPorting == 'true' || (investor.investorAccountDetailsDtoList[0].isDirectPorting === 'Y' && investor.isPorting === 'Y')) {
                    screen = 'congrats';
                }
                else if (investor.isKYC == 'Y' && !investor.investorAccountDetailsDtoList[0].isKraMismatched && documentDetails.signFileName) {
                    // sessionStorage.setItem('setOnbFlag',investor.investorAccountDetailsDtoList[0].isOnBoardFlag)
                    // console.log('JJJJ',this.investor.investorAccountDetailsDtoList[0].isOnBoardFlag)
                    // this.investor.investorAccountDetailsDtoList[0].isOnBoardFlag = 'Y';
                    // console.log('JJJJ2',this.investor.investorAccountDetailsDtoList[0].isOnBoardFlag)
                    screen = 'congrats';
                }
            }
        }
        else if (businessUnit == 'JF' || businessUnit == 'MFJF') {
            routeInfo = '/onboard/' + location.pathname.split('/')[2] + '/';
            var investorDetails_1 = ((investor || new Investor()).investorDetailsDtoList || [])[0] || new InvestorDetails();
            var investorAccount = ((investor || new Investor()).investorAccountDetailsDtoList || [])[0] || new InvestorAccount();
            if (!investor.pannum || !investorDetails_1.dateOfBirth) {
                screen = 'onboard-info';
            }
            else if (investor && (!investor.id || !investor.pannum || !investorDetails_1.emailID || !investor.investorAccountDetailsDtoList || !investorDetails_1.occupation || ((investorAccount.isMobileVerified != 'Y' || investorAccount.isEmailVerified != 'Y' || !investorDetails_1.education || !investorDetails_1.annualIncome || !investorDetails_1.politicalRelation) && !otpConfig.isSkip))) {
                if (mobileIPV && this.isMobile)
                    screen = 'ipv-details';
                else
                    screen = 'open-account';
            }
            else if (investor && investor.investorDetailsDtoList && investor.investorDetailsDtoList.length) {
                var investorAccountDetails = investor.investorAccountDetailsDtoList[0];
                var ipvDetails = (investor.documentsIPVDtoList || [])[0] || {};
                var documentDetails = (this.investor.documentsDtoList || [])[0] || new DocumentDetails();
                var invDetails = investor.investorDetailsDtoList[0];
                var bankDetails = investor.investorBankDetailsDtoList;
                var invAddresses = investor.addressDtoList;
                var segmentDetails = investor.optSegments;
                // let isIncomeProofRequired = (segmentDetails || []).filter((segment: SegmentDetails) => segment.isOpt == 'Y' && ['NSECash', 'BSECash'].indexOf(segment.segmentMasterDto.segmentName) == -1).length;
                var ipvDocumentDto = (investor.documentsIPVDtoList || [])[0] || {};
                var nomineeDetails = investor.nomineeDetailsDtoList;
                var date = ipvDocumentDto.lastModifiedDate ? new Date(ipvDocumentDto.lastModifiedDate.split('T')[0]) : '';
                if (date && date instanceof Date) {
                    date.setDate(date.getDate() + 30);
                }
                // date && 
                var isIPVRequired = mobileIPV ? (this.isMobile && mobileIPV) : ((this.investor.isKYC === 'Y') || (this.investor.isKYC !== 'Y' && this.investor.investorDetailsDtoList && this.investor.investorDetailsDtoList.length && this.investor.investorDetailsDtoList[0].kycVerifiedBy) ? false : ((!ipvDocumentDto.ipvVideoFileName && !ipvDocumentDto.ipvImageFileName) || !ipvDocumentDto.createdDate || moment(new Date()).format('YYYY-MM-DD') > moment(date).format('YYYY-MM-DD')));
                if (this.isMobile && mobileIPV) {
                    screen = 'ipv-details';
                }
                else if (investor.isKYC != 'Y' && (!invDetails.fatherName || !invDetails.investorName) && !(isManualVerification.isManual || invDetails.kycVerifiedBy || isManualVerification.isDigilocker)) {
                    screen = 'digi-locker';
                }
                else if (investor.isKYC != 'Y' && (!invDetails.fatherName || !invDetails.investorName) && (isManualVerification.isManual || invDetails.kycVerifiedBy || isManualVerification.isDigilocker)) {
                    screen = 'basic-details';
                }
                else if ((!nomineeDetails && documentDetails.signFileName && investor.isNomineeSkipped != 'Y')) {
                    screen = 'nominee-details';
                }
                else if (investor.isKYC != 'Y' && (!invAddresses || !invAddresses.length) && !invDetails.kycVerifiedBy) {
                    screen = 'address-details';
                }
                else if (!bankDetails || !bankDetails.length || ((!bankDetails[0].isPennydropVerified || bankDetails[0].isPennydropVerified != 'Y') && !bankDetails[0].cancelChequeFileName)) {
                    screen = 'bank-details';
                }
                // else if (!segmentDetails || !segmentDetails.length)(!segmentDetails || !segmentDetails.length) {
                //   screen = 'segment-details';
                //   // && investor.isKYC != 'Y' && (!invDetails.kycVerifiedBy)
                // }
                else if (isIPVRequired && !isDigioIPVSubmitted.isSubmitted) {
                    screen = 'ipv-details';
                }
                else if (investor.isKYC != 'Y' && ((ipvDetails.ipvVideoFileName || ipvDetails.ipvImageFileName || isDigioIPVSubmitted.isSubmitted)) && (!documentDetails || !documentDetails.panCardFileName)) {
                    screen = 'document-uploads/panCardFile';
                }
                else if (investor.isKYC != 'Y' && (checkIPVFilesForRouting ? (ipvDetails.ipvVideoFileName || ipvDetails.ipvImageFileName || isDigioIPVSubmitted.isSubmitted) : true) && (!documentDetails.addrProofFrontFileName)) {
                    screen = 'document-uploads/addrProofFrontFile';
                }
                else if (investor.isKYC != 'Y' && (checkIPVFilesForRouting ? (ipvDetails.ipvVideoFileName || ipvDetails.ipvImageFileName || isDigioIPVSubmitted.isSubmitted) : true) && (!documentDetails.photoFileName && !isDigioSelfieSubmitted.isSubmitted)) {
                    screen = 'document-uploads/photoFile';
                }
                else if (investor.isKYC == 'Y' && (!documentDetails.photoFileName && !isDigioSelfieSubmitted.isSubmitted)) {
                    screen = 'document-uploads/photoFile';
                }
                else if ((investor.isKYC == 'Y' && !documentDetails.signFileName)) {
                    screen = 'document-uploads/signFile';
                }
                else if (investor.isKYC != 'Y' && (checkIPVFilesForRouting ? (ipvDetails.ipvVideoFileName || ipvDetails.ipvImageFileName || isDigioIPVSubmitted.isSubmitted || invDetails.kycVerifiedBy) : true) && (!documentDetails.signFileName)) {
                    screen = 'document-uploads/signFile';
                    // isIncomeProofRequired && 
                }
                else if ((!segmentDetails && (investor.tag != "india-post"))) {
                    screen = 'document-uploads/incomeProofFile';
                }
                else if ((segmentDetails &&
                    investor.tag !== "india-post") &&
                    (!investor.documentsDtoList[0].incomeProofFileName ||
                        !investor.documentsDtoList[0].incomeProofType) &&
                    !["Cash", "SLBM", "MTF", "Cash,SLBM", "Cash,MTF", "Cash,MTF,SLBM", "Cash,SLBM,MTF", "MTF,SLBM"].includes(segmentDetails.trim().replace(/\s+/g, '')) && (aaStatus != 'done')) {
                    screen = 'document-uploads/incomeProofFile';
                }
                // else if ((!investorAccountDetails.plan) || isSkippable) {
                //   screen = 'document-uploads/plans';
                // } 
                // else if (((this.getOnboardingType() || '').trim().toLowerCase() == 'referral' && !investorAccountDetails.brokerageJson) && ((investor.isKYC != 'Y' && (documentDetails && documentDetails.panCardFileName && documentDetails.photoFileName && documentDetails.signFileName && investorAccountDetails.plan)) || (investor.isKYC == 'Y' && documentDetails.signFileName && investorAccountDetails.plan))) {
                //   screen = 'brokerage-details';
                // } 
                else if ((!investorAccount.isReviewed || investorAccount.isReviewed != 'Y') && ((investor.isKYC != 'Y' && (documentDetails && documentDetails.panCardFileName && (documentDetails.photoFileName || isDigioSelfieSubmitted.isSubmitted) && documentDetails.signFileName)) || (investor.isKYC == 'Y' && documentDetails.signFileName))) {
                    screen = 'review';
                }
                else if (investorAccountDetails.isReviewed == 'Y' && (!investorAccountDetails.isOnBoardFlag || investorAccountDetails.isOnBoardFlag == 'N')) {
                    screen = 'esign';
                }
                else if (investorAccountDetails.isReviewed == 'Y' && (investorAccountDetails.isOnBoardFlag == 'Y' || investorAccountDetails.isOnBoardFlag == 'C')) {
                    screen = 'congrats';
                }
                else if (documentDetails.panCardFileName === '' || documentDetails.panCardFileName === null || documentDetails.addrProofFrontFileName === null) {
                    screen = 'digi-locker';
                }
            }
        }
        //  this.getTotalSteps()
        return { route: routeInfo + screen, screen: screen };
    };
    /**
     * Onboarding journey total step for jf and Mf user mention
     * @returns  pass step with business unit
     */
    UtilsService.prototype.getTotalSteps = function () {
        var investor = this.investor;
        var businessUnit = this.businessUnit;
        var invDetails = investor.investorDetailsDtoList[0];
        var investorAccount = ((investor.investorAccountDetailsDtoList || [])[0] || new InvestorAccount());
        var isNRI = investorAccount.isNRI == 'Y';
        var bankDetails = investor.investorBankDetailsDtoList;
        var ipvDetails = (investor.documentsIPVDtoList || [])[0] || {};
        var segmentDetails = investor.optSegments;
        var documentDetails = (this.investor.documentsDtoList || [])[0] || new DocumentDetails();
        var nomineeDetail = (this.investor.nomineeDetailsDtoList);
        var investorAccountDetails = investor.investorAccountDetailsDtoList[0];
        // let isIncomeProofRequired = (segmentDetails || []).filter((segment: SegmentDetails) => segment.isOpt == 'Y' && ['NSECash', 'BSECash'].indexOf(segment.segmentMasterDto.segmentName) == -1).length
        var stepData = {
            MF: [
                /* {key:'registration',ispresent:true,isCompleted:(investor && investorAccount.clientID && investorAccount.isMobileVerified == 'Y')},
                {key:'basic-details',ispresent:investor.isKYC != 'Y',isCompleted:(invDetails.fatherName && invDetails.investorName)},
                {key:'address-details',ispresent:investor.isKYC != 'Y',isCompleted:(investor.addressDtoList && investor.addressDtoList.length)},
                {key:'income-details',ispresent:true,isCompleted:invDetails.occupation},
                {key:'bank-details',ispresent:true,isCompleted:(bankDetails && bankDetails.length)},
                {key:'ipv-details',ispresent:true,isCompleted:ipvDetails.ipvImageFileName}, */
                // && ipvDetails.ipvVideoFileName
                { name: 'PANCARD', key: 'panCardFile', ispresent: ((investor.isKYC == 'N')), isCompleted: documentDetails.panCardFileName },
                // && ipvDetails.ipvVideoFileName
                { name: 'ADDRESS PROOF', key: 'addrProofFrontFile', ispresent: ((investor.isKYC == 'N')), isCompleted: documentDetails.addrProofFrontFileName },
                // ((investor.isKYC == 'N') && ipvDetails.ipvVideoFileName)
                { name: 'PHOTO', key: 'photoFile', ispresent: ((investor.isKYC === 'Y') ? false : true), isCompleted: documentDetails.photoFileName },
                { name: 'SIGNATURE', key: 'signFile', ispresent: true, isCompleted: documentDetails.signFileName },
                { name: 'OVERSEAS ADDRESS PROOF', key: 'overseasAddressFrontFile', ispresent: isNRI, isCompleted: documentDetails.overseasAddressFrontFileName },
                { name: 'PASSPORT', key: 'passportFrontFile', ispresent: isNRI, isCompleted: documentDetails.passportFrontFileName },
                { name: 'VISA', key: 'visaFile', ispresent: isNRI, isCompleted: documentDetails.visaFileName },
                { name: 'NOMINEE', key: 'nominee-details', ispresent: ((investor.isNomineeSkipped === 'Y') ? false : true), isCompleted: (nomineeDetail && nomineeDetail.length) },
            ],
            JF: [
                /*  { name:'', key:'open-account',ispresent:true,isCompleted:false},
                 { name:'', key:'basic-details',ispresent:investor.isKYC != 'Y',isCompleted:false},
                 { name:'', key:'address-details',ispresent:investor.isKYC != 'Y',isCompleted:false},
                 { name:'', key:'bank-details',ispresent:(!bankDetails||!!bankDetails[0]||((!bankDetails[0].isPennydropVerified || bankDetails[0].isPennydropVerified != 'Y') && !bankDetails[0].cancelChequeFileName)),isCompleted:false},
                 { name:'', key:'ipv-details',ispresent:investor.isKYC != 'Y' && (!ipvDetails||!ipvDetails.ipvImageFileName),isCompleted:false}, */
                //  && ipvDetails.ipvVideoFileName
                { name: 'PANCARD', key: 'panCardFile', ispresent: ((investor.isKYC != 'Y')), isCompleted: documentDetails.panCardFileName },
                // && ipvDetails.ipvVideoFileName
                { name: 'ADDRESS PROOF', key: 'addrProofFrontFile', ispresent: ((investor.isKYC != 'Y')), isCompleted: documentDetails.addrProofFrontFileName },
                // ((investor.isKYC != 'Y') && ipvDetails.ipvVideoFileName)
                { name: 'PHOTO', key: 'photoFile', ispresent: true, isCompleted: documentDetails.photoFileName },
                { name: 'SIGNATURE', key: 'signFile', ispresent: true, isCompleted: documentDetails.signFileName },
                { name: 'NOMINEE', key: 'nominee-details', ispresent: ((investor.isNomineeSkipped === 'Y') ? false : true), isCompleted: (nomineeDetail && nomineeDetail.length) },
            ]
        };
        if ((!this.investor.tag) || (this.investor.tag && this.investor.tag != 'india-post')) {
            stepData.JF.push({ name: 'INCOME PROOF', key: 'incomeProofFile', ispresent: true, isCompleted: documentDetails.incomeProofFileName });
        }
        //this.shared.setStepData(stepData[businessUnit])
        console.log(stepData[businessUnit] || stepData['MFJF'], "step data");
        return stepData[businessUnit] || stepData['MFJF'];
    };
    /**
     * Config base success message show
     * @param title popup message or sliding message title name
     * @param message passing message which want to show
     */
    UtilsService.prototype.success = function (title, message) {
        this.toastr.success(message, title, { closeButton: true });
        this.toastr.success(message, title, { closeButton: true,
            positionClass: 'toast-bottom-right' });
    };
    /**
       * Config base error message show
       * @param title popup message or sliding message title name
       * @param message passing message which want to show
       */
    UtilsService.prototype.error = function (title, message) {
        this.toastr.error(message, title, { closeButton: true, });
        this.toastr.error(message, title, { closeButton: true,
            positionClass: 'toast-bottom-right' });
    };
    /**
     * Config base error message show
     * @param title popup message or sliding message title name
     * @param message passing message which want to show
     */
    UtilsService.prototype.AAerror = function (title, message, time, disabled) {
        this.toastr.error(message, title, { closeButton: true, timeOut: time, disableTimeOut: disabled });
        this.toastr.error(message, title, { closeButton: true,
            positionClass: 'toast-bottom-right' });
    };
    /**
     * Config base Warning message show
     * @param title popup message or sliding message title name
     * @param message passing message which want to show
     */
    UtilsService.prototype.warning = function (title, message) {
        this.toastr.warning(message, title, { closeButton: true });
        this.toastr.warning(message, title, { closeButton: true,
            positionClass: 'toast-bottom-right' });
    };
    /**
     * Information related message pass
     * @param title popup message or sliding message title name
     * @param message passing message which want to show
     * @param timeout set timer how much message will show
     */
    UtilsService.prototype.info = function (title, message, timeout) {
        this.toastr.info(message, title, { closeButton: true, disableTimeOut: timeout });
        this.toastr.info(message, title, { closeButton: true, disableTimeOut: timeout,
            positionClass: 'toast-bottom-right' });
    };
    /**
     * Investor detail updated Value store in session storage
     * @param data update investor detail data
     */
    UtilsService.prototype.updateOnboardingData = function (data) {
        this.investor = data;
        if (this.storage) {
            this.storage.setItem(this.businessUnit, JSON.stringify(this.investor));
        }
    };
    /**
     * Investor detail updated Value store in session storage
     * @param data passed investor detail data
     */
    UtilsService.prototype.updateModificationData = function (data) {
        this.modification = data;
        if (this.storage) {
            this.storage.setItem(this.businessUnit + 'Modification', JSON.stringify(this.modification));
        }
    };
    /**
     * decrypted Refer Code
     */
    UtilsService.prototype.getReferCode = function () {
        var referCode = this.storage.getItem('referCode');
        return referCode ? atob(referCode) : '';
    };
    /**
     * store skip in session storage
     */
    UtilsService.prototype.setSkip = function () {
        if (this.storage) {
            this.storage.setItem(this.businessUnit + '_skip', 1);
        }
    };
    /**
     * Clear skip in session storage
     */
    UtilsService.prototype.clearSkip = function () {
        if (this.storage && this.storage.getItem(this.businessUnit + '_skip')) {
            this.storage.removeItem(this.businessUnit + '_skip');
        }
    };
    /**
     * Getting value from session storage
     * @returns get skip value
     */
    UtilsService.prototype.getSkip = function () {
        if (this.storage && this.storage.getItem(this.businessUnit + '_skip')) {
            return this.storage.getItem(this.businessUnit + '_skip');
        }
        return false;
    };
    /**
     * set refercode in session storage
     * @param referCode passing referCode
     */
    UtilsService.prototype.setReferCode = function (referCode) {
        this.storage.setItem('referCode', btoa(referCode));
    };
    /**
     * Get language in session storage
     * @returns Get language store
     */
    UtilsService.prototype.getLanguage = function () {
        // console.log('STT',this.storage.getItem('lang'));
        return this.storage.getItem('lang') || 'en';
    };
    /**
     * store language in session storage
     * @param lang selected language
     */
    UtilsService.prototype.setLanguage = function (lang) {
        this.selectedLanguage = lang;
        console.log('LAN', this.selectedLanguage);
        this.storage.setItem('lang', lang);
    };
    /**
     * forward message data
     * @param data showing message data
     */
    UtilsService.prototype.sendMessage = function (data) {
        console.log('send message', data);
        // this.selectedLanguage = this.getLanguage();
        this.subject.next(data);
    };
    /**
     * Get meassage
     * @returns {Observable<any>} An observable for message.
     */
    UtilsService.prototype.getMessage = function () {
        // console.log('getmessage')
        return this.subject.asObservable();
    };
    // getMessage2(): Observable<any>{
    //   return this.subject2.asObservable();
    // }
    /**
     * parses a JSON string, constructing the otp described by the string
     * @returns Otp data
     */
    UtilsService.prototype.getOtpConfig = function () {
        var data = this.storage.getItem('otpConfig');
        if (data)
            return JSON.parse(data);
        return {};
    };
    /**
     * store otp Config
     * @param value otp Config
     */
    UtilsService.prototype.setOtpConfig = function (value) {
        var data = tslib_1.__assign({}, this.getOtpConfig(), value);
        this.storage.setItem('otpConfig', JSON.stringify(data));
    };
    /**
     * Remove otp Config
     */
    UtilsService.prototype.removeOtpConfig = function () {
        this.storage.removeItem('otpConfig');
    };
    /**
     * getting lms id and decrypt it
     * @returns decrypt Lms id
     */
    UtilsService.prototype.getLMSId = function () {
        var lmsId = this.storage.getItem('lmsId');
        return lmsId ? atob(lmsId) : '';
    };
    /**
     * decrypt lmsId  using btoa
     * @param lmsId lmsId
     */
    UtilsService.prototype.setLMSId = function (lmsId) {
        this.storage.setItem('lmsId', btoa(lmsId));
    };
    /**
     * store decrypt entityId  using btoa
     * @param entityId entity Id
     */
    UtilsService.prototype.setEntityId = function (entityId) {
        this.storage.setItem('entityId', btoa(entityId));
    };
    /**
     * get EntityId
     * @returns decrypt EntityId
     */
    UtilsService.prototype.getEntityId = function () {
        var entityId = this.storage.getItem('entityId');
        return entityId ? atob(entityId) : '';
    };
    /**
     * get formName
     * @returns decrypt formName value
     */
    UtilsService.prototype.getForm = function () {
        var formName = this.storage.getItem('formName');
        return formName ? atob(formName) : '';
    };
    /**
     * store FormName in decrypt format
     * @param formName passing FormName
     */
    UtilsService.prototype.setForm = function (formName) {
        this.storage.setItem('formName', btoa(formName));
    };
    /**
     * Get source value
     * @returns decrypt source value
     */
    UtilsService.prototype.getSource = function () {
        var source = this.storage.getItem('source');
        return source ? atob(source) : '';
    };
    /**
     * store decryt source value
     * @param source passing source value
     */
    UtilsService.prototype.setSource = function (source) {
        this.storage.setItem('source', btoa(source));
    };
    /**
     * remove Refer code
     */
    UtilsService.prototype.removeReferCode = function () {
        this.storage.removeItem('referCode');
    };
    /**
     * remove source
     */
    UtilsService.prototype.removeSource = function () {
        this.storage.removeItem('source');
    };
    /**
     * Remove LMS Id
     */
    UtilsService.prototype.removeLMSId = function () {
        this.storage.removeItem('lmsId');
    };
    /**
     * Remove Entity Id
     */
    UtilsService.prototype.removeEntityId = function () {
        this.storage.removeItem('entityId');
    };
    /** Remove Form value */
    UtilsService.prototype.removeForm = function () {
        this.storage.removeItem('formName');
    };
    /**
     * Get decryt Onboarding Type
     * @returns  decryt Onboarding Type
     */
    UtilsService.prototype.getOnboardingType = function () {
        var obType = this.storage.getItem('obType');
        return obType ? atob(obType) : '';
    };
    /** Remove Onboarding Type */
    UtilsService.prototype.removeOnboardingType = function () {
        this.storage.removeItem('obType');
    };
    /**
     * store onboarding type
     * @param obType passing onboarding type
     */
    UtilsService.prototype.setOnboardingType = function (obType) {
        this.storage.setItem('obType', btoa(obType));
    };
    /**
     * store lead Data
     * @param data pass lead data
     * @param businessUnit passing business unit
     */
    UtilsService.prototype.storeLeadData = function (data, businessUnit) {
        this.storage.setItem('lms' + businessUnit, JSON.stringify(data));
    };
    /**
     * Get lms data
     * @param businessUnit passing business unit
     * @returns decrypted LMS data
     */
    UtilsService.prototype.getLMSData = function (businessUnit) {
        var lmsData = this.storage.getItem('lms' + businessUnit);
        if (lmsData)
            return JSON.parse(lmsData);
        return { leadMappingDtoList: [] };
    };
    /**
     * Remove LMS Data
     * @param businessUnit passing business Unit
     */
    UtilsService.prototype.removeLMSData = function (businessUnit) {
        this.storage.removeItem('lms' + businessUnit);
    };
    /**
     * Indentify device
     * @returns get device
     */
    UtilsService.prototype.getOS = function () {
        var agent = navigator.userAgent.toLowerCase();
        var version;
        var browser = "";
        var device = (/Android/i).test(agent) ? 'Android' : (/BlackBerry/i).test(agent) ? 'BlackBerry' : (/iPhone|iPad|iPod/i).test(agent) ? 'iOS' :
            (/WPDesktop|IEMobile|Win/i).test(agent) ? 'Windows' : (/Linux|X11/i).test(agent) ? 'Linux' : (/Mac/i).test(agent) ? 'Macintosh' : 'NA';
        var mobileOrDesktop = (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(agent)) ? 'Mobile' : 'Desktop';
        (version = agent.match(/msie ([\d.]+)/)) ? browser = "IE " + version[1] :
            (version = agent.match(/firefox\/([\d.]+)/)) ? browser = "FireFox " + version[1] :
                (version = agent.match(/chrome\/([\d.]+)/)) ? browser = "Chrome " + version[1] :
                    (version = agent.match(/opera.([\d.]+)/)) ? browser = "Opera " + version[1] :
                        (version = agent.match(/version\/([\d.]+).*safari/)) ? browser = "Safari " + version[1] : "NA";
        if (device === 'NA') {
            device = this.getOSLatest();
        }
        return mobileOrDesktop + '_' + device + '_' + browser;
    };
    /** identify device */
    UtilsService.prototype.getOSLatest = function () {
        var device = navigator['userAgentData'].platform || navigator.userAgent;
        return device;
    };
    /**
     * set step name accourding to screen name
     * @param screenName  passing screen name
     */
    UtilsService.prototype.setStep = function (screenName) {
        var url;
        var businessUnit = this.businessUnit;
        if (this.businessUnit == "MF" && location.pathname.includes('onboard-info')) {
            url = (screenName || location.pathname.split('/')[location.pathname.split('/').length - 2] || '').replace('/', '');
        }
        else {
            url = (screenName || location.pathname.split('/')[location.pathname.split('/').length - 1] || '').replace('/', '');
        }
        if (this.config.screens[url]) {
            var step = (this.config.screens[url].step || this.config.screens[url])[businessUnit];
            this.config.step = this.config.step || {};
            this.config.step[businessUnit] = (this.config.step[businessUnit] || 0) > step ? (this.config.step[businessUnit] || 0) : step;
            if (this.storage) {
                this.storage.setItem('step', JSON.stringify(this.config.step));
            }
        }
    };
    /**
     * identify which screen according to step
     * @returns get step
     */
    UtilsService.prototype.getStep = function () {
        if (this.storage) {
            var data = this.storage.getItem('step');
            if (data)
                return JSON.parse(data);
            return (this.config.step || {})[this.businessUnit] || {};
        }
        return (this.config.step || {})[this.businessUnit] || {};
    };
    /**
     * Clear step
     */
    UtilsService.prototype.clearStep = function () {
        if (this.storage) {
            this.storage.removeItem('step');
        }
        this.config.step = {};
    };
    /**
     * Get investor detail data
     * @returns  investor detail object
     */
    UtilsService.prototype.getOnboardingData = function () {
        if (this.storage) {
            if (!sessionStorage.getItem('closureId')) {
                var data = this.storage.getItem(this.businessUnit);
                if (data)
                    return JSON.parse(data);
            }
            return this.investor;
        }
        return this.investor;
    };
    /**
     * Remove investor detail
     */
    UtilsService.prototype.removeOnboardingData = function () {
        var data = this.storage.getItem(this.businessUnit);
        if (data)
            this.storage.removeItem(this.businessUnit);
    };
    /**
     * modification data
     * @returns get modification data
     */
    UtilsService.prototype.getModificationData = function () {
        if (this.storage) {
            var data = this.storage.getItem(this.businessUnit + 'Modification');
            if (data)
                return JSON.parse(data);
            return this.modification;
        }
        return this.modification;
    };
    /**
     * Get investor detail data
     * @param investor investor detail data
     * @returns Investor detail dto list
     */
    UtilsService.prototype.getInvestorAccount = function (investor) {
        investor = investor || this.investor;
        return investor.investorAccountDetailsDtoList && investor.investorAccountDetailsDtoList.length ? investor.investorAccountDetailsDtoList[0] : new InvestorAccount();
    };
    /**
     * Get investor detail Dto List data
     * @param investor investor detail data
     * @returns investor detail investor Details Dto List data
     */
    UtilsService.prototype.getInvestorDetails = function (investor) {
        investor = investor || this.investor;
        return investor.investorDetailsDtoList[0] || new InvestorDetails();
    };
    /**
     * indian value boolean
     * @param value passing value
     * @returns value
     */
    UtilsService.prototype.isIndian = function (value) {
        return new RegExp(/^india$/i).test(value || '');
    };
    /**
     * Normalizes a name string by removing invalid characters and extra spaces.
     * This method removes any characters from the input string that are not alphabets, periods, apostrophes, hyphens, or spaces.
     * It also replaces multiple consecutive spaces with a single space.
     * Get Address List
     * @param addressList
     * @returns passing address array list
     */
    UtilsService.prototype.normalizeAddress = function (addressList) {
        var investor = this.getOnboardingData() || {};
        if (addressList && addressList.length) {
            if (addressList.length == 1) {
                var addressObject = JSON.parse(JSON.stringify(addressList[0]));
                addressObject.addressType = addressObject.addressType == 'Current' ? 'Permanent' : 'Current';
                addressObject.id = null;
                addressList.push(addressObject);
            }
            var addressChars_1 = new RegExp(/[A-z0-9]/ig);
            var pinCodeChars_1 = new RegExp(/[0-9]/ig);
            addressList.forEach(function (addressObject, index) {
                // addressObject.address = addressObject.address.replace(/[^A-Za-z0-9\s\'-:.,\(\[\]\)]+/g, '').replace(/\s+/g, ' ');
                // addressObject.city = addressObject.city.replace(/[^A-Za-z\s\-\.]+/g, '').replace(/\s+/g, ' ');
                addressObject.id = ((investor.addressDtoList || [])[index] || new AddressDetails()).id || null;
                addressObject.investorId = addressObject.id ? investor.id : null;
            });
            addressList.forEach(function (addressObject, index) {
                var otherIndex = index ? 0 : 1;
                addressObject.address = ((addressChars_1.test(addressObject.address) ? addressObject.address : addressChars_1.test(addressList[otherIndex].address) ? addressList[otherIndex].address : addressObject.address) || '').replace(/\s+/g, ' ');
                addressObject.city = ((addressChars_1.test(addressObject.city) ? addressObject.city : addressChars_1.test(addressList[otherIndex].city) ? addressList[otherIndex].city : addressObject.city) || 'OTHERS').replace(/\s+/g, ' ');
                addressObject.state = ((addressChars_1.test(addressObject.state) ? addressObject.state : addressChars_1.test(addressList[otherIndex].state) ? addressList[otherIndex].state : addressObject.state) || '').replace(/\s+/g, ' ');
                addressObject.zipCode = pinCodeChars_1.test(addressObject.zipCode) ? addressObject.zipCode : pinCodeChars_1.test(addressList[otherIndex].zipCode) ? addressList[otherIndex].zipCode : addressObject.zipCode;
            });
        }
        return addressList;
    };
    /**
     * Normalizes a name string by removing invalid characters and extra spaces.
     *
     * This method removes any characters from the input string that are not alphabets, periods, apostrophes, hyphens, or spaces.
     * It also replaces multiple consecutive spaces with a single space.
     *
     * @param value - The name string to be normalized.
     * @returns  The normalized name string.
     */
    UtilsService.prototype.normalizeNames = function (value) {
        return (value || '').replace(/[^A-Za-z\.\'\- ]/g, '').replace(/\s+/g, ' ');
    };
    /**
     * getting current screen
     * @param investorAccount investor Account Detail
     * @returns passes current screen
     */
    UtilsService.prototype.assignScreen = function (investorAccount) {
        var screenName = (investorAccount.screenName || '').toLowerCase();
        var url = location.pathname.split('/');
        var index = ((location.pathname.indexOf('document-uploads') > -1) || (this.businessUnit == 'MF' && location.pathname.indexOf('onboard-info') > -1)) ? 2 : 1;
        var currentScreen = this.config.screens[url[url.length - index]];
        // let lastScreen: any = screenName ? Object.values(this.config.screens).find((screen: any) => (screen.label || '').toLowerCase() == screenName) : currentScreen;
        // return currentScreen && currentScreen.label && lastScreen && lastScreen.step.id >= currentScreen.step.id ? currentScreen : lastScreen;
        return currentScreen;
    };
    /**
     * Updated  investor Detail
     ** This method gathers the necessary investor data, such as device ID, LMS ID, entity ID, account details, and investor segments,
     * and submits the updated investor information to the backend. It also handles various investor details such as plan, referred ID,
     * @param callback - An optional callback function to be executed after a successful investor update.
     * @param hideLoader boolean loader
     * @param contactUpdationType contact Updation Type
     * @param noNavigation  boolean Navigation
     */
    UtilsService.prototype.updateInvestorDetails = function (callback, hideLoader, contactUpdationType, noNavigation) {
        var _this = this;
        var deviceID = this.getOS();
        this.rest.showLoader("Saving your details..");
        this.investor.deviceID = deviceID;
        this.investor.lid = this.getLMSId() || this.investor.lid || null;
        this.investor.entityId = this.getEntityId() || this.investor.entityId || null;
        if (this.investor.investorAccountDetailsDtoList && this.investor.investorAccountDetailsDtoList.length) {
            var investorDetails = ((this.investor.investorDetailsDtoList || [])[0] || new InvestorDetails());
            this.investor.investorAccountDetailsDtoList[0].deviceID = deviceID;
            var investorAccount = ((this.investor.investorAccountDetailsDtoList || [])[0] || new InvestorAccount());
            var isAlphabee = ((this.getLMSData(this.businessUnit) || {}).leadSource || '').toLowerCase().indexOf('alphabee') > -1;
            this.investor.investorAccountDetailsDtoList[0].originalSource = location.pathname.indexOf('/respond-issue') > -1 ? this.investor.investorAccountDetailsDtoList[0].originalSource : this.getOnboardingType() == 'REFERRAL' ? 'JIFFY_OFFLINE' : this.getOnboardingType() == 'Alphabee' || isAlphabee ? 'ALPHABEE' : (this.getSource() || this.getOriginalSource());
            investorAccount.referredID = (isAlphabee) ? null : (investorAccount.referredID || this.getReferCode() || '');
            location.pathname.indexOf('/review') == -1 ? this.investor.investorAccountDetailsDtoList[0].isReviewed = 'N' : '';
            this.investor.investorAccountDetailsDtoList[0].referredID = this.investor.investorAccountDetailsDtoList[0].referredID || this.getReferCode();
            // || 'Annual AMC Plan'
            this.investor.investorAccountDetailsDtoList[0].plan = this.investor.investorAccountDetailsDtoList[0].plan;
            investorDetails.politicalRelation = (investorDetails.politicalRelation && investorDetails.politicalRelation === 'N') ? 'NPEP_NRPEP' : investorDetails.politicalRelation;
            var screenObject = this.assignScreen(this.investor.investorAccountDetailsDtoList[0]);
            if (screenObject) {
                // this.investor.investorAccountDetailsDtoList[0].screenName = (screenObject.step && screenObject.step.label) || screenObject.label || '';
                // this.investor.investorAccountDetailsDtoList[0].screenIdentifierId = (screenObject.screen && screenObject.screen.id) || screenObject.id || '1';
                /**Onboarding Moengage Event Handling for Label */
                this.investor.investorAccountDetailsDtoList[0].screenName = (screenObject.screen && screenObject.screen.name) || screenObject.label || '';
                this.investor.investorAccountDetailsDtoList[0].screenIdentifierId = (screenObject.screen && screenObject.screen.id) || screenObject.id || '1';
            }
        }
        if (this.businessUnit != 'MF') {
            var investorAccount = ((this.investor.investorAccountDetailsDtoList || [])[0] || new InvestorAccount());
            var isAlphabee = (investorAccount.originalSource) ? investorAccount.originalSource.toLowerCase().indexOf('alphabee') > -1 : '';
            // let obtype = ((this.getLMSData(this.businessUnit) || {}).leadSource || '').toLowerCase().indexOf('alphabee') > -1;
            investorAccount.referredID = (isAlphabee) ? null : (investorAccount.referredID || this.getReferCode() || '');
            // this.investor.investorSegmentDtoList = (isAlphabee) ? this.optSegments(isAlphabee ? 'Cash' : 'All', this.investor.id) : this.investor.investorSegmentDtoList;
            // && this.investor.investorSegmentDtoList.length ? this.investor.investorSegmentDtoList : this.optSegments(isAlphabee ? 'Cash' : 'All', this.investor.id);
            var investorDetails = ((this.investor.investorDetailsDtoList || [])[0] || new InvestorDetails());
            investorDetails.incomeSlab = investorDetails.incomeSlab || '1-5 Lacs';
            investorDetails.education = investorDetails.education || 'Graduate';
            investorDetails.experience = investorDetails.experience || '0';
            investorDetails.politicalRelation = (investorDetails.politicalRelation && investorDetails.politicalRelation === 'N') ? 'NPEP_NRPEP' : investorDetails.politicalRelation;
            this.investor.investorDetailsDtoList = [investorDetails];
            this.investor.investorAccountDetailsDtoList = [investorAccount];
        }
        this.rest.updateInvestor(this.investor, this.investor.id, hideLoader, contactUpdationType).subscribe(function (res) {
            _this.rest.hideLoader();
            if (res && res.errorCode == '9999' || res.errorCode == '0053') {
                var investorAccount = ((_this.investor.investorAccountDetailsDtoList || [])[0] || new InvestorAccount());
                if (res.message && (res.message.trim() === 'Income Proof File Missing.') && investorAccount.isMobileVerified == 'Y' && investorAccount.isEmailVerified == 'Y') {
                    _this.AAerror('Error', 'Unable to fetch your income document through CAMS. Please upload it manually.', 4000, false);
                    setTimeout(function () {
                        var route = _this.getForwardRoute(_this.investor, _this.businessUnit);
                        _this.setStep(route.screen);
                        _this.route.navigate([route.route]);
                    }, 4000);
                }
                else {
                    _this.error('Error', res.message);
                }
            }
            else if (res && res.errorCode == '0054') {
                var lmsData = _this.getLMSData(_this.businessUnit);
                var msg = 'Record with your name: <b>' + lmsData.firstName + '</b> and mobile number: <b>' + lmsData.mobileNo1 + '</b> already exists';
                _this.showModal({
                    title: 'Attention!!',
                    message: msg,
                    actions: [
                        {
                            label: _this.errorMessages.okaybtn,
                            handler: function () {
                                _this.utils.modalConfig = null;
                                location.href = _this.getRedirectionURL('signUpURL');
                            }
                        }
                    ]
                });
            }
            else if (res && res.errorCode && res.errorCode == 3002) {
                _this.error('Error', res.message);
            }
            else if (res && !res.errorCode && !noNavigation) {
                _this.investor = res;
                _this.setStep();
                _this.updateScreenDetails(hideLoader);
                _this.updateOnboardingData(_this.investor);
                if (callback)
                    callback();
            }
            else if (res && !res.errorCode && noNavigation) {
                _this.investor = res;
                _this.updateOnboardingData(_this.investor);
                if (callback)
                    callback();
            }
        }, function (error) {
            _this.error('Error', 'Something went wrong.');
            _this.rest.hideLoader();
        });
    };
    /**
  * Updates investor details and submits them to the server.
  *
  * This method gathers the necessary investor data, such as device ID, LMS ID, entity ID, account details, and investor segments,
  * and submits the updated investor information to the backend. It also handles various investor details such as plan, referred ID,
  * and screen identifiers. The function optionally takes a callback to be executed upon successful submission.
  * @param [callback] - An optional callback function to be executed after a successful investor update.
  */
    UtilsService.prototype.updateInvestorDetailsSubmit = function (callback) {
        var _this = this;
        var deviceID = this.getOS();
        this.investor.deviceID = deviceID;
        this.investor.lid = this.getLMSId() || this.investor.lid || null;
        this.investor.entityId = this.getEntityId() || this.investor.entityId || null;
        if (this.investor.investorAccountDetailsDtoList && this.investor.investorAccountDetailsDtoList.length) {
            this.investor.investorAccountDetailsDtoList[0].deviceID = deviceID;
            this.investor.investorAccountDetailsDtoList[0].originalSource = this.getOnboardingType() == 'REFERRAL' ? 'JIFFY_OFFLINE' : (this.getSource() || this.getOriginalSource());
            location.pathname.indexOf('/review') == -1 ? this.investor.investorAccountDetailsDtoList[0].isReviewed = 'N' : '';
            this.investor.investorAccountDetailsDtoList[0].referredID = this.investor.investorAccountDetailsDtoList[0].referredID || this.getReferCode();
            this.investor.investorAccountDetailsDtoList[0].plan = this.investor.investorAccountDetailsDtoList[0].plan || 'Annual AMC Plan';
            var screenObject = this.assignScreen(this.investor.investorAccountDetailsDtoList[0]);
            if (screenObject) {
                this.investor.investorAccountDetailsDtoList[0].screenName = screenObject.step.label;
                this.investor.investorAccountDetailsDtoList[0].screenIdentifierId = screenObject.screen.id;
            }
        }
        if (this.businessUnit != 'MF') {
            this.investor.investorSegmentDtoList = this.investor.investorSegmentDtoList;
            //  && this.investor.investorSegmentDtoList.length ? this.investor.investorSegmentDtoList : this.optSegments('All', this.investor.id);
            // this.optSegments('Cash', this.investor.id)
            var investorDetails = ((this.investor.investorDetailsDtoList || [])[0] || new InvestorDetails());
            investorDetails.incomeSlab = investorDetails.incomeSlab;
            // || '1-5 Lacs'
            investorDetails.education = investorDetails.education || 'Graduate';
            investorDetails.experience = investorDetails.experience || '0';
            this.investor.investorDetailsDtoList = [investorDetails];
        }
        this.rest.updateInvestor(this.investor, this.investor.id).subscribe(function (res) {
            /* if (res && res.errorCode) {
              this.error('Error', (res.message?res.message:'Something went wrong.'));
            } */
            if (res && res.errorCode == '9999' || res.errorCode == '0053') {
                _this.error('Error', res.message);
            }
            else if (res && !res.errorCode) {
                _this.investor = res;
                /*    this.setStep();
                   this.updateScreenDetails(); */
                _this.updateOnboardingData(_this.investor);
                if (callback)
                    callback();
            }
        });
    };
    /**
     * Getting file name
     * @param fileType Passing file Type
     * @param fileExt Passing  file Extension
     * @param suffix Passing suffix
     * @param investorId Passing investor Id
     * @returns get file name
     */
    UtilsService.prototype.getFileName = function (fileType, fileExt, suffix, investorId) {
        return (investorId || this.investor.id) + '_' + this.businessUnit + '_' + fileType + (suffix || '') + '.' + fileExt;
    };
    /**
     * screen Detail updated value
     * @param hideLoader loader boolean value
     * @param isEsignFromCongrats reach congratulation page or not
     */
    UtilsService.prototype.updateScreenDetails = function (hideLoader, isEsignFromCongrats) {
        var id = this.investor.id || this.getOnboardingData().id;
        if (id) {
            var url = location.pathname.split('/');
            var businessUnit = this.businessUnit == 'MFJF' ? 'JF' : this.businessUnit;
            var index = ((location.pathname.indexOf('document-uploads') > -1) || (this.businessUnit == 'MF' && location.pathname.indexOf('onboard-info') > -1)) ? 2 : 1;
            var screenName = url[url.length - index];
            if (this.config.screens[screenName] && this.config.screens[screenName].screen) {
                var request = {
                    "businessUnitMasterDto": {
                        "id": URLs[businessUnit].id,
                        "name": businessUnit,
                        "smsSenderKey": ""
                    },
                    "id": "",
                    "investorId": id,
                    "screenIdentifierDto": {
                        "id": this.config.screens[screenName].screen.id,
                        "name": this.config.screens[screenName].screen.name
                    }
                };
                if (isEsignFromCongrats) {
                    request.screenIdentifierDto.id = this.config.screens['esign'].screen.id;
                    request.screenIdentifierDto.name = this.config.screens['esign'].screen.name;
                }
                this.rest.updateOnboardingScreen(request, id, hideLoader).subscribe(function (res) {
                    if (res) {
                        // if(request && request.screenIdentifierDto && request.screenIdentifierDto.name == 'bank-details'){
                        //   this.addDataLayer('dlBankDetailsSuccess',this.investor.id); 
                        // }else if(request && request.screenIdentifierDto && request.screenIdentifierDto.name == 'document-uploads' && window.location.href.indexOf('signFile') > -1){
                        //   this.addDataLayer('dlSignatureSuccess',this.investor.id);
                        // }
                    }
                });
            }
        }
    };
    /**
     * Getting file extension
     * @param file  file extension
     * @returns file extension
     */
    UtilsService.prototype.getFileExtension = function (file) {
        var value = (file || {})['type'] ? (file['type'] || '').toLowerCase() : (file || '')['toLowerCase']();
        return value.indexOf('jpeg') > -1 || value.indexOf('jpg') > -1 ? 'jpg' : value.indexOf('png') > -1 ? 'png' : value.indexOf('bmp') > -1 ? 'bmp' : value.indexOf('pdf') > -1 ? 'pdf' : value.indexOf('webm') > -1 ? 'webm' : null;
    };
    /**
     * Getting isBase64Encoded value
     * @param value passing value
     * @returns encoded value
     */
    UtilsService.prototype.isBase64Encoded = function (value) {
        return /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))$/.test((value || '').trim());
    };
    /**
     *  Getting screen detail list
     * @param investor passing investor detail
     * @param businessUnit passing businessunit
     * @returns  screen detail
     */
    UtilsService.prototype.getAccessList = function (investor, businessUnit) {
        // debugger
        // let isManualVerification = this.getDigiLockerConfig();
        var mobileIPV = this.getIPVOnMobileCheck();
        var isDigioIPVSubmitted = this.getDigioIPVConfig();
        var checkIPVFilesForRouting = (this.investor.isKYC !== 'Y' && this.investor.investorDetailsDtoList && this.investor.investorDetailsDtoList.length && !this.investor.investorDetailsDtoList[0].kycVerifiedBy);
        var ipvDocumentDto = (investor.documentsIPVDtoList || [])[0] || {};
        var nomineeDetails = investor.nomineeDetailsDtoList;
        var date = ipvDocumentDto.lastModifiedDate ? new Date(ipvDocumentDto.lastModifiedDate.split('T')[0]) : '';
        if (date && date instanceof Date) {
            date.setDate(date.getDate() + 30);
        }
        // date && 
        var isIPVRequired = mobileIPV ? (this.isMobile && mobileIPV) : ((this.investor.isKYC === 'Y') || (this.investor.isKYC !== 'Y' && this.investor.investorDetailsDtoList && this.investor.investorDetailsDtoList.length && this.investor.investorDetailsDtoList[0].kycVerifiedBy) ? false : ((!ipvDocumentDto.ipvVideoFileName && !ipvDocumentDto.ipvImageFileName) || !ipvDocumentDto.createdDate || moment(new Date()).format('YYYY-MM-DD') > moment(date).format('YYYY-MM-DD')));
        var IPVRequiredForBrokerage = (this.investor.isKYC !== 'Y' && this.investor.investorDetailsDtoList && this.investor.investorDetailsDtoList.length && this.investor.investorDetailsDtoList[0].kycVerifiedBy) ? false : ((!ipvDocumentDto.ipvVideoFileName && !ipvDocumentDto.ipvImageFileName) || !ipvDocumentDto.createdDate || moment(new Date()).format('YYYY-MM-DD') > moment(date).format('YYYY-MM-DD'));
        var detailsScreen = ['onboard-info'];
        if (this.isMobile && mobileIPV) {
            detailsScreen.push('ipv-details');
        }
        if (investor && investor.pannum && investor.investorDetailsDtoList && investor.investorDetailsDtoList.length && investor.investorDetailsDtoList[0].dateOfBirth) {
            detailsScreen.push('open-account');
        }
        if (investor && investor.investorDetailsDtoList && investor.investorDetailsDtoList.length) {
            var investorAccountDetails = investor.investorAccountDetailsDtoList[0];
            var ipvDetails = (investor.documentsIPVDtoList || [])[0] || {};
            var invDetails = investor.investorDetailsDtoList[0];
            var bankDetails = investor.investorBankDetailsDtoList;
            var documentDetails = (investor.documentsDtoList || [])[0] || new DocumentDetails();
            var invAddresses = investor.addressDtoList;
            var segmentDetails = investor.investorSegmentDtoList;
            // let isIncomeProofRequired = (segmentDetails || []).filter((segment: SegmentDetails) => segment.isOpt == 'Y' && ['NSECash', 'BSECash'].indexOf(segment.segmentMasterDto.segmentName) == -1).length;
            var isReferralTypeOnboarding = (this.getOnboardingType() || '').trim().toLowerCase() == 'referral';
            if (investor.pannum && invDetails.dateOfBirth && investor.isKYC != 'Y') {
                detailsScreen.push('digi-locker');
            }
            if (investor.pannum && invDetails.dateOfBirth && investor.isKYC != 'Y') {
                detailsScreen.push('basic-details');
            }
            // if (businessUnit == 'JF' && investor.isNomineeSkipped && investor.isNomineeSkipped === 'N' && !nomineeDetails) {
            //   detailsScreen.push('nominee-details');
            // }
            if (invDetails.fatherName && invDetails.investorName && investor.isKYC != 'Y' && !invDetails.kycVerifiedBy) {
                detailsScreen.push('address-details');
            }
            if (businessUnit == 'MF' && invAddresses && invAddresses.length) {
                detailsScreen.push('income-details');
            }
            if ((businessUnit == 'MF' && invDetails.occupation) || ((businessUnit == 'JF' || businessUnit == 'MFJF') && invAddresses && invAddresses.length)) {
                detailsScreen.push('bank-details');
                // && investor.isKYC != 'Y' && !invDetails.kycVerifiedBy
            }
            if (businessUnit == 'MF' && bankDetails && bankDetails.length && documentDetails && documentDetails.chequeFileName && isIPVRequired && !isDigioIPVSubmitted.isSubmitted) {
                detailsScreen.push('ipv-details');
                // && investor.isKYC != 'Y' && !invDetails.kycVerifiedBy
            }
            if ((businessUnit == 'JF' || businessUnit == 'MFJF') && isIPVRequired && !isDigioIPVSubmitted.isSubmitted) {
                detailsScreen.push('ipv-details');
            }
            if (businessUnit == 'MF' && !documentDetails.signFileName) {
                detailsScreen.push('document-uploads');
            }
            if (businessUnit == 'JF' && bankDetails && bankDetails.length && bankDetails[0].accountNumber && (checkIPVFilesForRouting ? (ipvDetails.ipvVideoFileName || ipvDetails.ipvImageFileName || isDigioIPVSubmitted.isSubmitted) : true)) {
                // ((ipvDetails.ipvVideoFileName || invDetails.kycVerifiedBy) || (!ipvDetails.ipvVideoFileName && investor.isKYC == 'Y'))
                //original -> && (ipvDetails.ipvVideoFileName || (!ipvDetails.ipvVideoFileName && investor.isKYC == 'Y'))
                detailsScreen.push('document-uploads');
            }
            // if(businessUnit == 'JF' && bankDetails && bankDetails.length && bankDetails[0].accountNumber && (checkIPVFilesForRouting ? (ipvDetails.ipvVideoFileName || ipvDetails.ipvImageFileName || isDigioIPVSubmitted.isSubmitted) : true) && documentDetails.signFileName){
            //   detailsScreen.push('nominee-details');
            // }
            // isIncomeProofRequired && 
            if ((businessUnit == 'JF' || businessUnit == 'MFJF') && investorAccountDetails.isOnBoardFlag == 'N') {
                if ((investor.isKYC != 'Y' && (IPVRequiredForBrokerage ? (ipvDetails.ipvVideoFileName || ipvDetails.ipvImageFileName || isDigioIPVSubmitted.isSubmitted) : true) && documentDetails.signFileName && documentDetails.photoFileName && documentDetails.panCardFileName &&
                    documentDetails.addrProofFrontFileName) || (investor.isKYC == 'Y' && documentDetails.signFileName) || (documentDetails.incomeProofFileName)) {
                    // if (isReferralTypeOnboarding) {
                    //   detailsScreen.push('brokerage-details');
                    // }
                    detailsScreen.push('review');
                    detailsScreen.push('nominee-details');
                }
                if (investorAccountDetails.isReviewed == 'Y') {
                    detailsScreen.push('esign');
                }
            }
            if (businessUnit == 'MF' && investorAccountDetails.isOnBoardFlag == 'N' && investor.isNomineeSkipped && investor.isNomineeSkipped === 'N' && !nomineeDetails) {
                detailsScreen.push('nominee-details');
            }
            if (businessUnit == 'MF' && documentDetails.signFileName && (investor.isNomineeSkipped === 'Y' || nomineeDetails) && (!investorAccountDetails.isOnBoardFlag || investorAccountDetails.isOnBoardFlag == 'N') && (investor.investorAccountDetailsDtoList[0].isDirectPorting != 'Y' || investor.isPorting != 'Y') && (investor.isKYC === 'Y' ? investor.investorAccountDetailsDtoList[0].isKraMismatched : true)) {
                detailsScreen.push('esign');
            }
            if (investorAccountDetails.isOnBoardFlag == 'Y' || investorAccountDetails.isOnBoardFlag == 'C') {
                detailsScreen.push('congrats');
            }
        }
        // this.getTotalSteps()
        return detailsScreen;
    };
    /**
     * Validates a pan value using a regular expression.
     * @param value The pan value string to be validated.
     * @returns {RegExpExecArray | null} The result of the regex execution. Returns a match array if the pan value is valid, or null if it's invalid.
     */
    UtilsService.prototype.isPANValid = function (value) {
        return panNumberRegex.exec((value || '').trim());
    };
    /**
     * Validates a mobile number using a regular expression.
     * This method checks if the provided mobile number matches the expected format based on the regular expression.
     * @param  value - The mobile number string to be validated.
     * @returns {RegExpExecArray | null} The result of the regex execution. Returns a match array if the mobile number is valid, or null if it's invalid.
     */
    UtilsService.prototype.isMobileValid = function (value) {
        return mobileNumberRegex.exec((value || '').trim());
    };
    /**
     * Validates a Email using a regular expression.
     * This method checks if the provided Email matches the expected format based on the regular expression.
     * @param  value - The Email string to be validated.
     * @returns {RegExpExecArray | null} The result of the regex execution. Returns a match array if the Email is valid, or null if it's invalid.
     */
    UtilsService.prototype.isEmailValid = function (value) {
        return emailRegex.exec((value || '').trim());
    };
    /**
     * Validates a Refer Code using a regular expression.
     * This method checks if the provided Refer Code matches the expected format based on the regular expression.
     * @param  value - The Refer Code string to be validated.
     * @returns {RegExpExecArray | null} The result of the regex execution. Returns a match array if the Refer Code is valid, or null if it's invalid.
     */
    UtilsService.prototype.isReferCodeValid = function (value) {
        return /^[a-z0-9]+$/i.exec((value || '').trim());
    };
    /**
     * Geting Modification Redirection URL
     * @param isPrev
     * @returns Modification URL
     */
    UtilsService.prototype.getModificationRedirectURL = function (isPrev) {
        var urlMapper = {
            'client-login': { allNext: 'segment-activation' },
            'segment-activation': { allPrev: 'client-login', allNext: 'contact-details' },
            'contact-details': { allPrev: 'segment-activation', allNext: 'bank-modification' },
            'bank-modification': { allPrev: 'contact-details', allNext: 'review-form' },
            'review-form': { allPrev: 'bank-modification', allNext: 'client-login' }
        };
        var currentUrl = location.pathname.toLowerCase();
        var lastPath = currentUrl.split('/');
        lastPath = lastPath[lastPath.length - 1];
        var isAllModification = location.search.indexOf('?redirect=all') > -1;
        var redirectURL = (urlMapper[lastPath] || {})[isPrev ? 'allPrev' : 'allNext'];
        if (!isAllModification) {
            redirectURL = 'client-login';
        }
        return location.pathname.toLowerCase().replace(lastPath, redirectURL) + location.search;
    };
    /**
     * segment detail pass on basis of segment type
     * @param enumType segemt type pass
     * @param investorId investor id passed
     * @returns The result of the Segment detail
     */
    UtilsService.prototype.optSegments = function (enumType, investorId) {
        var segmentDetails = [];
        var segmentControls = this.getRouteInfo('segment-details').inputs.segments;
        var minSegments = enumType == 'Cash' ? segmentControls.filter(function (segment) { return ['NSECash', 'BSECash'].indexOf(segment.segmentName) > -1; }) : segmentControls;
        minSegments.forEach(function (segment, index) {
            if (!segment.hidden) {
                var segmentDetail = new SegmentDetails();
                segmentDetail.isOpt = 'Y';
                segmentDetail.investorId = investorId;
                segmentDetail.segmentMasterDto = { id: segment.id, segmentName: segment.segmentName, segmentType: segment.segmentType };
                segmentDetails.push(segmentDetail);
            }
        });
        return segmentDetails;
    };
    /**
     * Getting IP address
     */
    UtilsService.prototype.getIP = function () {
        var _this = this;
        var RTCPeerConnection = window['RTCPeerConnection'] || window['mozRTCPeerConnection'] || window['webkitRTCPeerConnection'];
        var ipRegex = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/g;
        if (RTCPeerConnection) {
            var candidates_1 = [];
            var connection_1 = new RTCPeerConnection({
                "iceServers": [{
                        "urls": ["stun:stun.l.google.com:19302"]
                    }],
                "iceTransportPolicy": "all",
                "iceCandidatePoolSize": "0"
            });
            connection_1.onicecandidate = function (event) {
                if (event.candidate && event.candidate.candidate && event.candidate.candidate.trim()) {
                    if (event.candidate && (event.candidate.address || '').match(ipRegex) || (event.candidate.address || '').indexOf('.local') > -1) {
                        candidates_1.push(event.candidate.address || '');
                    }
                }
            };
            connection_1.onicegatheringstatechange = function () {
                if (connection_1.iceGatheringState !== 'complete') {
                    return;
                }
                _this.storage.setItem('address', JSON.stringify(candidates_1));
                connection_1.close();
                connection_1 = null;
            };
            connection_1.onicecandidateerror = function (e) {
                console.error('The server ' + e.url +
                    ' returned an error with code=' + e.errorCode + ':\n' +
                    e.errorText + '\n');
            };
            connection_1.createOffer({
                offerToReceiveAudio: 1
            }).then(function (desc) {
                var fpString = desc.sdp.split('\n').find(function (sdpStr) { return sdpStr.indexOf('fingerprint') > -1; });
                if (fpString) {
                    _this.storage.setItem('fingerprint', fpString.replace(/(?:\r\n|\r|\n)/g, ''));
                }
                connection_1.setLocalDescription(desc);
            }, function (error) {
            });
        }
    };
    /**
     * Get compare value of string
     * @param strA passing string one
     * @param strB passing string two
     * @returns Compared string value
     */
    UtilsService.prototype.compareString = function (strA, strB) {
        strA = strA ? strA.replace(/  +/g, ' ') : '';
        strB = strB ? strB.replace(/  +/g, ' ') : '';
        var lengthA = strA ? strA.trim().length : 0;
        var lengthB = strB ? strB.trim().length : 0;
        var equivalency = 0;
        var minLength = (lengthA > lengthB) ? lengthB : lengthA;
        var maxLength = (lengthA < lengthB) ? lengthB : lengthA;
        for (var i = 0; i < minLength; i++) {
            if (strA[i].toLowerCase() == strB[i].toLowerCase()) {
                equivalency++;
            }
        }
        var weight = equivalency / maxLength;
        return (weight * 100);
    };
    /**
     * Getting extension
     * @param extn passing extension
     * @returns file extension
     */
    UtilsService.prototype.getFileType = function (extn) {
        return extn ? ((extn === 'jpg' || extn === 'png' || extn === 'bmp') ? 'Image' : 'PDF') : null;
    };
    /**
     * Getting file size
     * @param bytes passing byte of file size
     * @returns file size
     */
    UtilsService.prototype.getFileSize = function (bytes) {
        var i = Math.floor(Math.log(bytes) / Math.log(1024)), sizes = ['b', 'Kb', 'Mb', 'Gb', 'Tb', 'Pb', 'Eb', 'Zb', 'Yb'];
        return (bytes / Math.pow(1024, i)).toFixed(2) + ' ' + sizes[i];
    };
    /**
     * store decrypted mobileIPV value
     * @param res value of mobileIPV
     */
    UtilsService.prototype.setIPVOnMobileCheck = function (res) {
        this.storage.setItem('mobileIPV', btoa(res));
    };
    /**
     * Getting mobileIPV
     * @returns  mobileIPV value
     */
    UtilsService.prototype.getIPVOnMobileCheck = function () {
        var mobileIPV = this.storage.getItem('mobileIPV');
        return mobileIPV ? atob(mobileIPV) : '';
    };
    /**
     * Remove IPV On Mobile Check
     */
    UtilsService.prototype.removeIPVOnMobileCheck = function () {
        if (this.storage && this.storage.getItem('mobileIPV')) {
            this.storage.removeItem('mobileIPV');
        }
    };
    /**
     * Getting digi Locker Config
     * @returns digiLocker Config value
     */
    UtilsService.prototype.getDigiLockerConfig = function () {
        var data = this.storage.getItem('digiLockerConfig');
        if (data)
            return JSON.parse(data);
        return {};
    };
    /**
     * set DigiLockerConfig
     * @param value passing digi Locker Config value
     */
    UtilsService.prototype.setDigiLockerConfig = function (value) {
        var data = tslib_1.__assign({}, this.getDigiLockerConfig(), value);
        this.storage.setItem('digiLockerConfig', JSON.stringify(data));
    };
    /**
     * clear DigiLocker Config
     */
    UtilsService.prototype.clearDigiLockerConfig = function () {
        if (this.storage && this.storage.getItem('digiLockerConfig')) {
            this.storage.removeItem('digiLockerConfig');
        }
    };
    /**
     * Get Respond Issue Data
     * @returns  Respond Issue Data
     */
    UtilsService.prototype.getRespondIssueData = function () {
        if (this.storage) {
            var data = this.storage.getItem(this.businessUnit + 'Respond');
            if (data)
                return JSON.parse(data);
        }
        return {};
    };
    /**
     * updated Respond Issue Data
     * @param data passing update response data
     */
    UtilsService.prototype.updateRespondIssueData = function (data) {
        if (this.storage) {
            this.storage.setItem(this.businessUnit + 'Respond', JSON.stringify(data));
        }
    };
    /**
     * Clear Response Issue
     */
    UtilsService.prototype.clearRespondIssueData = function () {
        if (this.storage && this.storage.getItem(this.businessUnit + 'Respond')) {
            this.storage.removeItem(this.businessUnit + 'Respond');
        }
    };
    /**
     * Get value Digio IPV Config
     * @returns value Digio IPV Config
     */
    UtilsService.prototype.getDigioIPVConfig = function () {
        var data = this.storage.getItem('digioIPVConfig');
        if (data)
            return JSON.parse(data);
        return {};
    };
    /**
     * store value Digio IPV Config
     * @param value passing value Digio IPV Config
     */
    UtilsService.prototype.setDigioIPVConfig = function (value) {
        var data = tslib_1.__assign({}, this.getDigioIPVConfig(), value);
        this.storage.setItem('digioIPVConfig', JSON.stringify(data));
    };
    /**
     * Clear Digio Selfie Config
     */
    UtilsService.prototype.clearDigioIPVConfig = function () {
        if (this.storage && this.storage.getItem('digioIPVConfig')) {
            this.storage.removeItem('digioIPVConfig');
        }
    };
    /**
     * Getting Digio Selfie Config
     * @returns  Digio Selfie Config
     */
    UtilsService.prototype.getDigioSelfieConfig = function () {
        var data = this.storage.getItem('digioSelfieConfig');
        if (data)
            return JSON.parse(data);
        return {};
    };
    /**
     * store json object Digio Selfie Config
     * @param value passing Digio Selfie Config
     */
    UtilsService.prototype.setDigioSelfieConfig = function (value) {
        var data = tslib_1.__assign({}, this.getDigioSelfieConfig(), value);
        this.storage.setItem('digioSelfieConfig', JSON.stringify(data));
    };
    /**
     * Clear Digio Selfie Config
     */
    UtilsService.prototype.clearDigioSelfieConfig = function () {
        if (this.storage && this.storage.getItem('digioSelfieConfig')) {
            this.storage.removeItem('digioSelfieConfig');
        }
    };
    /**
     * Getting value base on key name
     * @param key passing key name
     * @returns value base on key name
     */
    UtilsService.prototype.getSessionStorageValue = function (key) {
        var data = this.storage.getItem(key);
        return data;
    };
    /**
     * set session storage value base on key and value
     * @param key passing key name
     * @param value passing key value
     */
    UtilsService.prototype.setSessionStorageValue = function (key, value) {
        this.storage.setItem(key, value);
    };
    /**
     * base on key value it will clear in session storage
     * @param key passing key value
     */
    UtilsService.prototype.clearSessionStorageKey = function (key) {
        if (this.storage && this.storage.getItem(key)) {
            this.storage.removeItem(key);
        }
    };
    /**
    * To download file from server
    * @param path file path
    * @param fileName file name to be display
    */
    UtilsService.prototype.downloadFile = function (path, fileName) {
        var _this = this;
        fetch(path)
            .then(function (resp) { return resp.blob(); })
            .then(function (blob) {
            var url = window.URL.createObjectURL(blob);
            var a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            // the filename you want
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            // alert('your file has downloaded!'); // or you know, something with better UX...
        })
            .catch(function () {
            return _this.error('Error', 'Something went wrong. Please try again later.');
        });
    };
    /**
     * Get Mobile Number Regex
     * @returns Mobile Number Regex
     */
    UtilsService.prototype.getMobileNumberRegex = function () {
        return mobileNumberRegex;
    };
    /**
     * Get Email Regex
     * @returns Email Regex
     */
    UtilsService.prototype.getEmailRegex = function () {
        return emailRegex;
    };
    /**
     * Get PAN Regex
     * @returns PAN Regex
     */
    UtilsService.prototype.getPANRegex = function () {
        return panNumberRegex;
    };
    /**
     * Get Account Regex
     * @returns Account Regex
     */
    UtilsService.prototype.getAccountRegex = function () {
        return accNoRegex;
    };
    /**
     * Getting Passport Regex
     * @returns Passport Regex
     */
    UtilsService.prototype.getPassportRegex = function () {
        return passportRegex;
    };
    /**
     * Get Voter Regex
     * @returns VoterRegex
     */
    UtilsService.prototype.getVoterRegex = function () {
        return voterRegex;
    };
    /**
     * Get Aadhaar Regex
     * @returns Aadhaar Regex
     */
    UtilsService.prototype.getAadhaarRegex = function () {
        return aadhaarRegex;
    };
    /**
     * Get AlphaNumericRegex
     * @returns AlphaNumeric Regex
     */
    UtilsService.prototype.getAlphaNumericRegex = function () {
        return alphaNumericRegex;
    };
    /**
     * update Modification API Request
     * @param data passing data of Modification API Request
     */
    UtilsService.prototype.updateModificationAPIRequestData = function (data) {
        this.modification = data;
        if (this.storage) {
            this.storage.setItem(this.businessUnit + 'ModificationAPIRequest', JSON.stringify(this.modification));
        }
    };
    /**
     * get Modification API Request
     * @returns Modification API Request value
     */
    UtilsService.prototype.getModificationAPIRequestData = function () {
        if (this.storage) {
            var data = this.storage.getItem(this.businessUnit + 'ModificationAPIRequest');
            // console.log('DDD',data);
            if (data)
                return JSON.parse(data);
            return this.modification;
        }
        return this.modification;
    };
    /**
     * Getting isCentkart value
     * @returns get value
     */
    UtilsService.prototype.getIsFromCentkart = function () {
        var data = this.storage.getItem('isCentkart');
        if (data)
            return data;
        return {};
    };
    /**
     * store passed isCentkart value
     * @param value passing isCentkart value
     */
    UtilsService.prototype.setIsFromCentkart = function (value) {
        this.storage.setItem('isCentkart', value);
    };
    /**
     * aaded data layer
     * @param eventName passing event name
     * @param customEvent passing custom Event name
     */
    UtilsService.prototype.addDataLayer = function (eventName, customEvent) {
        var scriptElement = document.createElement('script');
        var scripInnerHtml = customEvent ? 'window.dataLayer = window.dataLayer || [];window.dataLayer.push({event:"' + eventName + '",investorId:"' + customEvent + '"})' : 'window.dataLayer = window.dataLayer || [];window.dataLayer.push({event:"' + eventName + '"})';
        scriptElement.textContent = scripInnerHtml;
        document.head.appendChild(scriptElement);
    };
    /**
     * aaded data layer
     * @param eventName passing event name
     * @param customEvent passing custom Event name
     */
    UtilsService.prototype.addDataLayer2 = function (eventName, customEvent) {
        var scriptElement = document.createElement('script');
        var scripInnerHtml = 'window.dataLayer = window.dataLayer || [];window.dataLayer.push({event:"' + eventName + '"})';
        scriptElement.textContent = scripInnerHtml;
        document.head.appendChild(scriptElement);
    };
    /**
     * push event using datalayer
     * @param eventData passing event data
     */
    UtilsService.prototype.pushDataLayerEvent = function (eventData) {
        // let window = windo
        // (window as any).dataLayer = (window as any).dataLayer || [];
        // (window as any).dataLayer.push(eventData);
    };
    /**
     * Secure mobile number for user events in GA4
     * @param input values
     * @returns values
     */
    UtilsService.prototype.generateSHA256Hash = function (input) {
        // console.log('INPUT',input)
        // console.log('Output',cryptoJs.SHA256(input).toString())
        if (input) {
            return cryptoJs.SHA256(input).toString();
        }
        else {
            return "";
        }
    };
    /**
     * initialize Education List Version 2
     */
    UtilsService.prototype.initializeEducationListV2 = function () {
        var _this = this;
        this.rest.retrieveEducationListsV2().subscribe(function (res) {
            if (res && res.Body && res.Body.EducationMasterList) {
                _this.config.educations = res.Body.EducationMasterList;
            }
        });
    };
    /**
     * update Dormant Status
     * @param status Dormant Status
     */
    UtilsService.prototype.updateDormantStatus = function (status) {
        if (this.storage) {
            this.storage.setItem(this.businessUnit + 'DormantStatus', status);
        }
    };
    /**
     * get Dormant Status
     * @returns Dormant Status
     */
    UtilsService.prototype.getDormantStatus = function () {
        if (this.storage) {
            var status_1 = this.storage.getItem(this.businessUnit + 'DormantStatus');
            if (status_1)
                return status_1;
            return null;
        }
        return null;
    };
    /**
     * public function to trigger intializeflowpoints from outside class
     */
    UtilsService.prototype.triggerconfigList = function () {
        this.setValidationLang();
        this.initializeFlowPoints();
    };
    /**function to set the validation languges */
    UtilsService.prototype.setValidationLang = function () {
        if (this.selectedLanguage && this.selectedLanguage === 'hi') {
            this.errorMessages = validationtext[1];
            // console.log('MSG',this.errorMessages.pan_required)
        }
        if (this.selectedLanguage && this.selectedLanguage === 'en') {
            this.errorMessages = validationtext[0];
            // console.log('MSG',this.errorMessages.pan_required)
        }
    };
    /**store security params in session storage. */
    // storeSecurityParams() {
    //   console.log('secureP',this.secureParams)
    //   for (const [key, value] of Object.entries(this.secureParams)) {
    //     sessionStorage.setItem(`${key}`, value.toString())
    //   }
    // }
    /**generate Access token for API's */
    UtilsService.prototype.generateAccessToken = function () {
        var _this = this;
        var payload = {};
        payload['investor_id'] = sessionStorage.getItem('invid') ? sessionStorage.getItem('invid') : sessionStorage.getItem('investorId') ? sessionStorage.getItem('investorId') : null;
        payload['code'] = sessionStorage.getItem('code') ? sessionStorage.getItem('code') : null;
        payload['request_type'] = '';
        this.rest.getAccessTokenURL(payload).subscribe(function (res) {
            if (res && res.Body && res.Body.access_token) {
                sessionStorage.setItem('access_token', res.Body.access_token);
                _this.shared.tokenSuccess.next(res);
                // this.subject2.next(res);
            }
        }, function (error) {
            console.log('ONB error', error);
            if (error.error.Message && error.status == 401) {
                // this.toastr.error(error.error.Message);
                // this.showModal({
                //         title: 'Unauthorized Access',
                //         message: error.error.Message,
                //         actions: [
                //           {
                //             label: 'OKAY',
                //             handler: () => {
                //               window.open('https://dev.choiceindia.com/open-free-demat-account',"_self");
                //               this.utils.modalConfig = null;
                //             }
                //           }
                //         ]
                //       })
                _this.shared.tokenFailure.next(sessionStorage.getItem('requestFrom') || null);
                // setTimeout(() => {
                //   console.log('timeouterror')
                //   return false;
                // },3000)
                // this.subject2.next(error);
            }
            else {
                _this.showModal({
                    title: 'Invalid Request',
                    message: "We're sorry, but you don't have permission to access the requested page. For security reasons, we need to re-authenticate you. To proceed, please click 'OK' and enter your mobile number and OTP on the next page to continue onboarding",
                    actions: [
                        {
                            label: 'OKAY',
                            handler: function () {
                                window.open('https://choiceindia.com/open-free-demat-account', "_self");
                                _this.utils.modalConfig = null;
                            }
                        }
                    ]
                });
                // this.toastr.error(error.error.Message? error.error.Message: 'Something went wrong. Please try again later.')
                // this.subject2.next(error);
            }
        });
    };
    /**
     * Function to decrypt encrypted data
     * @param text Passing text
     * @returns decrypted data
     */
    UtilsService.decryptText = function (text) {
        if (text) {
            var key = cryptoJs.enc.Utf8.parse('');
            var iv = cryptoJs.enc.Utf8.parse('');
            var config = { keySize: 256, iv: iv, mode: cryptoJs.mode.CBC, padding: cryptoJs.pad.Pkcs7 };
            try {
                var encPassword = cryptoJs.AES.decrypt(text, key, config);
                return encPassword.toString(cryptoJs.enc.Utf8);
            }
            catch (err) {
                try {
                    return JSON.parse(text);
                }
                catch (err1) {
                    return text || '';
                }
            }
        }
        else {
            return '';
        }
    };
    /**
     * update  InvestorDetails latest
     * @param callback callback function
     * @param hideLoader  loader boolean value
     * @param contactUpdationType  contact Updation Type
     */
    UtilsService.prototype.updateInvestorDetailsNew = function (callback, hideLoader, contactUpdationType) {
        var deviceID = this.getOS();
        this.rest.showLoader("Saving your details..");
        this.investor.deviceID = deviceID;
        this.investor.lid = this.getLMSId() || this.investor.lid || null;
        this.investor.entityId = this.getEntityId() || this.investor.entityId || null;
        if (this.investor.investorAccountDetailsDtoList && this.investor.investorAccountDetailsDtoList.length) {
            var investorDetails = ((this.investor.investorDetailsDtoList || [])[0] || new InvestorDetails());
            this.investor.investorAccountDetailsDtoList[0].deviceID = deviceID;
            var investorAccount = ((this.investor.investorAccountDetailsDtoList || [])[0] || new InvestorAccount());
            var isAlphabee = ((this.getLMSData(this.businessUnit) || {}).leadSource || '').toLowerCase().indexOf('alphabee') > -1;
            this.investor.investorAccountDetailsDtoList[0].originalSource = this.getOnboardingType() == 'REFERRAL' ? 'JIFFY_OFFLINE' : this.getOnboardingType() == 'Alphabee' || isAlphabee ? 'ALPHABEE' : (this.getSource() || this.getOriginalSource());
            investorAccount.referredID = (isAlphabee) ? null : (investorAccount.referredID || this.getReferCode() || '');
            location.pathname.indexOf('/review') == -1 ? this.investor.investorAccountDetailsDtoList[0].isReviewed = 'N' : '';
            this.investor.investorAccountDetailsDtoList[0].referredID = this.investor.investorAccountDetailsDtoList[0].referredID || this.getReferCode();
            // || 'Annual AMC Plan'
            this.investor.investorAccountDetailsDtoList[0].plan = this.investor.investorAccountDetailsDtoList[0].plan;
            investorDetails.politicalRelation = (investorDetails.politicalRelation && investorDetails.politicalRelation === 'N') ? 'NPEP_NRPEP' : investorDetails.politicalRelation;
            var screenObject = this.assignScreen(this.investor.investorAccountDetailsDtoList[0]);
            if (screenObject) {
                this.investor.investorAccountDetailsDtoList[0].screenName = (screenObject.step && screenObject.step.label) || screenObject.label || '';
                this.investor.investorAccountDetailsDtoList[0].screenIdentifierId = (screenObject.screen && screenObject.screen.id) || screenObject.id || '1';
            }
        }
        if (this.businessUnit != 'MF') {
            var investorAccount = ((this.investor.investorAccountDetailsDtoList || [])[0] || new InvestorAccount());
            var isAlphabee = (investorAccount.originalSource) ? investorAccount.originalSource.toLowerCase().indexOf('alphabee') > -1 : '';
            // let obtype = ((this.getLMSData(this.businessUnit) || {}).leadSource || '').toLowerCase().indexOf('alphabee') > -1;
            investorAccount.referredID = (isAlphabee) ? null : (investorAccount.referredID || this.getReferCode() || '');
            this.investor.investorSegmentDtoList = (isAlphabee) ? this.optSegments(isAlphabee ? 'Cash' : 'All', this.investor.id) : this.investor.investorSegmentDtoList;
            // && this.investor.investorSegmentDtoList.length ? this.investor.investorSegmentDtoList : this.optSegments(isAlphabee ? 'Cash' : 'All', this.investor.id);
            var investorDetails = ((this.investor.investorDetailsDtoList || [])[0] || new InvestorDetails());
            investorDetails.incomeSlab = investorDetails.incomeSlab || '1-5 Lacs';
            investorDetails.education = investorDetails.education || 'Graduate';
            investorDetails.experience = investorDetails.experience || '0';
            investorDetails.politicalRelation = (investorDetails.politicalRelation && investorDetails.politicalRelation === 'N') ? 'NPEP_NRPEP' : investorDetails.politicalRelation;
            this.investor.investorDetailsDtoList = [investorDetails];
            this.investor.investorAccountDetailsDtoList = [investorAccount];
        }
        if (callback)
            callback();
        // this.rest.updateInvestor(this.investor, this.investor.id, hideLoader, contactUpdationType).subscribe((res) => {
        //   this.rest.hideLoader();
        //   if (res && res.errorCode == '9999' || res.errorCode == '0053') {
        //     this.error('Error', res.message);
        //   } else if (res && res.errorCode == '0054') {
        //     let lmsData = this.getLMSData(this.businessUnit);
        //     let msg = 'Record with your name: <b>' + lmsData.firstName + '</b> and mobile number: <b>' + lmsData.mobileNo1 + '</b> already exists';
        //     this.showModal({
        //       title: 'Attention!!',
        //       message: msg,
        //       actions: [
        //         {
        //           label: this.errorMessages.okaybtn,
        //           handler: () => {
        //             this.utils.modalConfig = null;
        //             location.href = this.getRedirectionURL('signUpURL');
        //           }
        //         }
        //       ]
        //     })
        //   }
        //   else if (res && !res.errorCode) {
        //     this.investor = res;
        //     this.setStep();
        //     this.updateScreenDetails(hideLoader);
        //     this.updateOnboardingData(this.investor);
        //     if (callback) callback();
        //   }
        // },
        //   error => {
        //     this.rest.hideLoader();
        //   })
    };
    /**
     * Function to encrpt data
     * @param plainText passing text
     * @returns encrpt data
     */
    UtilsService.prototype.encryptText = function (plainText) {
        if (plainText) {
            var key = cryptoJs.enc.Utf8.parse('');
            var iv = cryptoJs.enc.Utf8.parse('');
            var config = { keySize: 256, iv: iv, mode: cryptoJs.mode.CBC, padding: cryptoJs.pad.Pkcs7 };
            var encPassword = cryptoJs.AES.encrypt(plainText, key, config);
            return encPassword.ciphertext.toString(cryptoJs.enc.Base64);
        }
        else {
            return '';
        }
    };
    UtilsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function UtilsService_Factory() { return new UtilsService(i0.ɵɵinject(i1.ToastrService), i0.ɵɵinject(i2.OnboardingService), i0.ɵɵinject(i3.SharedService), i0.ɵɵinject(i4.ActivatedRoute), i0.ɵɵinject(i4.Router)); }, token: UtilsService, providedIn: "root" });
    return UtilsService;
}());
export { UtilsService };
/**
 * Here we provide date range used
 * @param min  minimum date
 * @param max  maximum date
 * @returns Range Value
 */
export function range(min, max) {
    return function (control) {
        return !control.value || (new Date(control.value).valueOf() >= min && new Date(control.value).valueOf() <= max) ? null : { range: true };
    };
}
